/**
 *
 * Schema
 *
 */

import React from "react"
import { ReactSession } from 'react-client-session'
import { FormGroup, Badge, UncontrolledTooltip } from "reactstrap"
import { Link } from "react-router-dom"
import ConfirmButton from "../components/ConfirmButton"
import ButtonSpinner from "../components/ButtonSpinner"
import api from "../helpers/Api"
import a31eaf2ac from "store/a31eaf2ac"
import fc2400f3 from "store/fc2400f3"
import da6383a4 from "store/da6383a4"
import fa2c0984 from "store/fa2c0984"
import ZGVsaXZlcnlfbW9kZQ from "store/ZGVsaXZlcnlfbW9kZQ"
import b80a3d64 from "store/b80a3d64"
// import zXZlbnQq from "store/zXZlbnQq"
import ZXZlbnQgbGlz from "store/ZXZlbnQgbGlz"
import a99df6f1 from "store/a99df6f1"
import db1dc367 from "store/db1dc367"
import c4ddb684 from "store/c4ddb684"
import d9024f94 from "store/d9024f94"
import bfa4b9a6 from "store/bfa4b9a6"
import e3bf4eed from "store/e3bf4eed"
import b8a14fb3 from "store/b8a14fb3"
import ca3b000f from "store/ca3b000f"
import cXVvdGF0 from "store/cXVvdGF0"
import b2ZmZXI from "store/b2ZmZXI"
import Zm9sbG93dXA from "store/Zm9sbG93dXA"
import Zm9sbG93dXBfbWFzdGVy from "store/Zm9sbG93dXBfbWFzdGVy"
import Zm9sbG93dXBfYWN0aW9u from "store/Zm9sbG93dXBfYWN0aW9u"
import Zm9sbG93dXBfc3RyYXRlZ3k from "store/Zm9sbG93dXBfc3RyYXRlZ3k"
import c2FsZXM from "store/c2FsZXM"
import c2FsZXMgZW5 from "store/c2FsZXMgZW5"
import c2FsZXMgcWM from "store/c2FsZXMgcWM"
//Alter Quote
import YWx0ZXIgcXVvdGU from "store/YWx0ZXIgcXVvdGU"
// import RXF1aXBtZW50TWFwcGluZw from "store/RXF1aXBtZW50TWFwcGluZw"
//Login Otp page
import bG9naW5fb3Rw from "store/bG9naW5fb3Rw"
// import c3a9f540 from 'store/c3a9f540'
import LeadHeader from "pages/Lead/component/LeadHeader"
import LeadStatus from "pages/Lead/component/LeadStatus"
import c2hpZnQ from "store/c2hpZnQ"
import aHJtc19wb2xpY3lfc2V0dGluZw from "store/aHJtc19wb2xpY3lfc2V0dGluZw"
import aHJfcmVxdWVzdA from "store/aHJfcmVxdWVzdA"
import ZW1wbG95ZWVfdHlwZQ from "store/ZW1wbG95ZWVfdHlwZQ"
import RW1wbG95ZWVSZXF1ZXN0 from "store/RW1wbG95ZWVSZXF1ZXN0"
import UmVmZXJyYWw from "store/UmVmZXJyYWw"
import QmlydGhkYXkgTGlzdA from 'store/QmlydGhkYXkgbGlzdA'
import aG9saWRheQ from "store/aG9saWRheQ"
import YmFubmVy from "store/YmFubmVy"
import Y2xpZW50X3Byb2ZpbGU from "store/Y2xpZW50X3Byb2ZpbGU"
import c2VydmljZQ from "store/c2VydmljZQ"
import c3ViX3Byb2R1Y3Q from "store/c3ViX3Byb2R1Y3Q"
import ZGVsaXZlcmFibGU from "store/ZGVsaXZlcmFibGU"
import cGF5bWVudF90ZXJtcw from "store/cGF5bWVudF90ZXJtcw"
import cHJvZHVjdA from "store/cHJvZHVjdA"
import dGVhbQ from "store/dGVhbQ"
import dmVudW from "store/dmVudW"
import dmVudWVfbG9 from "store/dmVudWVfbG9"
import UmVzZXRQYX from "store/UmVzZXRQYX"
import TXlGb2xsb3d1cA from "store/TXlGb2xsb3d1cA"
import bWFuYWdlRm9sbG93 from "store/bWFuYWdlRm9sbG93"
//Followup audit
import c2FsZXNG from "store/c2FsZXNG"

import dW5hc3NpZ25lZEVj from "store/dW5hc3NpZ25lZEVj"
import bWFuYWdlUmVqZWN0 from "store/bWFuYWdlUmVqZWN0"
import bXlSZWplY3Q from "store/bXlSZWplY3Q"
import ZnJlZWxh from "store/ZnJlZWxh"

//Metrics
import bGVhZE1ldHJpY3M from "store/bGVhZE1ldHJpY3M"
import Zm9sbG93dXBNZXRya from "store/Zm9sbG93dXBNZXRya"

//Leave options
import bGVhdmVPcHRpb25z from "store/bGVhdmVPcHRpb25z"

// Booking complete
import Ym9va2luZw from "store/Ym9va2luZw"
import YWx0ZXJRdW90ZUxpc3Q from "store/YWx0ZXJRdW90ZUxpc3Q"
//notifications
import bm90aWZp from "store/bm90aWZp"
import cGF5bWVudF9tb2Rl from "store/cGF5bWVudF9tb2Rl"
import YmFua19kZXRhaWw from "store/YmFua19kZXRhaWw"
import YmFua19hY2NvdW50 from "store/YmFua19hY2NvdW50"
import bXlwcm9maWxl from "store/bXlwcm9maWxl"
import dmVuZG9y from "store/dmVuZG9y"
//LPND
import bGVhdmU from 'store/bGVhdmU'
import cGVybWlzc2lvbg from 'store/cGVybWlzc2lvbg'
import RGVsZWdh from 'store/RGVsZWdh'
import TmlnaHRz from 'store/TmlnaHRz'
import ZXZlbnRfdHlwZQ from "store/ZXZlbnRfdHlwZQ"
import bGF5b3V0X21hc3Rlcg from "store/bGF5b3V0X21hc3Rlcg"
import bGF5b3V0X3NlZ21lbnQ from "store/bGF5b3V0X3NlZ21lbnQ"
import bWVzc2FnZV90ZW1wbGF0ZV9ncm91cA from "store/bWVzc2FnZV90ZW1wbGF0ZV9ncm91cA"
import dGVtcGxhdGVfbWVzc2FnZQ from "store/dGVtcGxhdGVfbWVzc2FnZQ"
import YnVkZ2V0X2NvbG9y from "store/YnVkZ2V0X2NvbG9y"

//Event Coordinations
import ZWNBc3NpZ25lZExpc3Q from "store/ZWNBc3NpZ25lZExpc3Q"

import "./styles.scss"
import moment from "moment"

const schema = [
  {
    schemaId: "a31eaf2ac",
    name: "company",
    title: "Company List",
    formTitle: "Company List",
    path: "/companies",
    visible: true,
    ...a31eaf2ac,
    page: "Company",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions
      console.log(records, "record from company list")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Company Code",
          placeholder: "Enter Company Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          formatter: (cellContent, row) => {
            console.log(row, "row from api")
            return (
              <>
                <p style={{ textTransform: "uppercase" }}>{row.code}</p>
              </>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Company Name",
          placeholder: "Enter Company Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            console.log(row, "row from api")
            return (
              <>
                <p style={{ textTransform: "uppercase" }}>{row.name}</p>
              </>
            )
          },
          type: "textOnly",
          validations: "textOnly"
        },
        {
          id: "6",
          value: "logo",
          label: "Company Logo",
          placeholder: "Enter File Name",
          sort: true,
          required: true,
          colProps: {
            lg: "4",
            md: "4",
            style: { paddingRight: "15px" },
          },
          editRecord: true,
          formatter: (cellContent) => {
            const value = cellContent
            console.log(cellContent)
            return cellContent ? (
              <div className="" style={{ display: "flex" }}>
                {/* <i className="display-4 text-muted bx bxs-file" onClick={() => window.open(value, '_blank')} /> */}
                <img className="cls-imagepreview" src={value} alt={value}></img>
              </div>
            ) : (
              <span>Upload Logo</span>
            )
          },
          viewRecord: true,
          type: "upload",
        },
        {
          id: "7",
          value: "type",
          label: "Type",
          placeholder: "Enter Type",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          type: "radio",
          options: [
            {
              label: "Event",
              value: "event",
            },
            {
              label: "Service",
              value: "service",
            },
          ],
          formatter: (cellContent) => {
            const data = [
              {
                label: "EVENT",
                value: "event",
              },
              {
                label: "SERVICE",
                value: "service",
              },
            ]
            return (
              (cellContent && data.find((_) => _.value === cellContent).label) ||
              ""
            )
          },
        },
        {
          id: "8",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status == 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "9",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "12",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "13",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "cXVvdGF0",
    name: "quotation",
    title: "Quotation",
    path: "/quotation",
    visible: true,
    formTitle: "Quotation",
    page: "Quotation",
    ...cXVvdGF0,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "code",
        label: "State Code",
        placeholder: "Enter State Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
      },
      {
        id: "4",
        value: "name",
        label: "State Name",
        placeholder: "Enter State Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
      },
      {
        id: "5",
        value: "countryName",
        label: "Country Name",
        sort: true,
        editRecord: false,
        viewRecord: true,
        type: "text",
      },
      {
        id: "6",
        value: "companyId",
        label: "Company",
        placeholder: "Select Company",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "select",
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
            (metaData &&
              metaData.companyOptions &&
              metaData.companyOptions.length > 0 &&
              metaData.companyOptions.find(
                (_) => _.value.toString() === cellContent.toString()
              ) &&
              metaData.companyOptions.find((_) => _.value === cellContent)
                .label) ||
            ""
          )
        },
        options: "companyOptions",
      },
      {
        id: "7",
        value: "venueLocation",
        label: "Venue Location",
        placeholder: "Select Venue Location",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
          },
        },
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
            (cellContent &&
              metaData &&
              metaData.cityOptions &&
              metaData.cityOptions.length > 0 &&
              metaData.cityOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ) &&
              metaData.cityOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ).label) ||
            ""
          )
        },
        type: "select",
        options: "cityOptions",
      },
      {
        id: "8",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "9",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
    testcolumns: () => [
      {
        id: "1",
        value: "eventType",
        label: "Event Type",
        placeholder: "Select Event Type",
        sort: true,
        editRecord: true,
        viewRecord: true,
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "10px" },
        },
        required: true,
        type: "select",
        options: [
          {
            label: "Hindu Wedding",
            value: "hinduWedding",
          },
          {
            label: "Muslim Wedding",
            value: "muslimWedding",
          },
          {
            label: "Christian Wedding",
            value: "christianWedding",
          },
        ],
      },
      {
        id: "2",
        value: "event",
        label: "Event Details",
        placeholder: "Select Event Details",
        sort: false,
        editRecord: true,
        required: true,
        viewRecord: true,
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
            //  marginLeft: "-5px"
          },
          className: "event-form-margin",
        },
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
            (cellContent &&
              metaData &&
              metaData.companyOptions &&
              metaData.companyOptions.length > 0 &&
              metaData.companyOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ) &&
              metaData.companyOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ).label) ||
            ""
          )
        },
        type: "select",
        options: "companyOptions",
      },
      {
        id: "3",
        value: "eventDate",
        label: "Date",
        placeholder: "Select Date",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
            //  marginLeft: "6px"
          },
        },
        type: "date",
      },
      {
        id: "4",
        value: "crewAssemblyTime",
        label: "Crew Assembly Time",
        placeholder: "Enter Crew Assembly Time",
        sort: false,
        editRecord: true,
        viewRecord: false,
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
            //  marginLeft: "-5px"
          },
          className: "event-form-margin",
        },
        type: "text",
      },
      {
        id: "5",
        value: "startTime",
        label: "Start Time",
        placeholder: "Enter Start Time",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
          },
        },
        type: "text",
      },
      {
        id: "6",
        value: "endTime",
        label: "End Time",
        placeholder: "Enter End Time",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
            //  marginLeft: "-5px"
          },
          className: "event-form-margin",
        },
        type: "text",
      },
      {
        id: "7",
        value: "venueLocation",
        label: "Venue Location",
        placeholder: "Select Venue Location",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
          },
        },
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
            (cellContent &&
              metaData &&
              metaData.cityOptions &&
              metaData.cityOptions.length > 0 &&
              metaData.cityOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ) &&
              metaData.cityOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ).label) ||
            ""
          )
        },
        type: "select",
        options: "cityOptions",
      },
      {
        id: "8",
        value: "venueName",
        label: "Venue Name",
        placeholder: "Enter Venue Name",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
            //  marginLeft: "-5px"
          },
          className: "event-form-margin",
        },
        type: "text",
      },
      {
        id: "9",
        value: "crowdStrength",
        label: "Crowd Strength",
        placeholder: "Enter Crowd Strength",
        sort: true,
        editRecord: true,
        viewRecord: true,
        type: "text",
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
          },
        },
      },
    ],
  },
  {
    schemaId: "b2ZmZXI",
    name: "offer",
    title: "Offer",
    path: "/offer",
    visible: true,
    formTitle: "Offer",
    page: "Offer",
    ...b2ZmZXI,
    columns: (record = {}, metaData) => {

      console.log(record, "record from api")
      
      const codeValueMetaData = metaData && metaData.codeOptions
      
   console.log(codeValueMetaData, "codeValueMetaData")

   var companyOptions = []
   if(metaData && metaData.companyOptions){
     var metaCompanyOptions = metaData.companyOptions
     companyOptions = metaCompanyOptions.map((data) => {
       return {
         value: data.value,
         label: data.label,
       }
   })
  }

   const branchOptions =
   record &&
   record.companyId &&
   metaData &&
   Object.keys(metaData).length > 0 &&
   metaData.branchOptions &&
   metaData.branchOptions.length > 0
     ? metaData.branchOptions.filter(
         (_) => _.companyId.toString() === record.companyId.toString()
       ) : metaData &&
       Object.keys(metaData).length > 0 &&
       metaData.branchOptions &&
       metaData.branchOptions.length > 0
     ? metaData.branchOptions
     : []
   const serviceOptions =
   record &&
   record.companyId &&
   metaData &&
   Object.keys(metaData).length > 0 &&
   metaData.serviceOptions &&
   metaData.serviceOptions.length > 0
     ? metaData.serviceOptions.filter(
         (_) => _.companyId.toString() === record.companyId.toString()
       ) : metaData &&
       Object.keys(metaData).length > 0 &&
       metaData.serviceOptions &&
       metaData.serviceOptions.length > 0
     ? metaData.serviceOptions
     : []
     return [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "6",
        value: "companyId",
        label: "Company",
        placeholder: "Select Company",
        sort: true,
       // required:true,
        editRecord: true,
        viewRecord: true,
        type: "select",
        colProps: {
          lg: "12",
          md: "12",
        },

        formatter: (cellContent, row) => {
        
         return <span>{row && row.companyName}</span>

         },
        options: companyOptions,
      },
      {
        id: "5",
        value: 'branchId',
        label: 'Branch',
        placeholder: 'Enter Branch',
        sort: true,
        editRecord: true,
        viewRecord: true,
     //   required:true,
        type: 'multiSelect',
       // validations: "arrayField",
        formatter: (cellContent, row) => {
         const branch = row && row.branchName
         return <span>{branch}</span>
        //  return <span>{row.branchName.length > 1 ? branch +"," : branch}</span>
       },
        options: branchOptions
      },
      {
        id: "6",
        value: 'eventId',
        label: 'Event',
        placeholder: 'Enter Event',
        sort: true,
        //required:true,
        editRecord: true,
        viewRecord: true,
        type: 'multiSelect',
       //validations: "arrayField",
        formatter: (cellContent, row) => {
         const event = row && row.eventName
         return <span>{event}</span>
        //  return <span>{row.eventName.length > 1 ? event +"," : event}</span>
        },
        options: 'eventOptions'
      },
      {
        id: "6",
        value: 'serviceId',
        label: 'Service',
        placeholder: 'Enter Event',
        sort: true,
        required:false,
        editRecord: true,
        viewRecord: true,
        type: 'select',
        // validations: "arrayField",
        formatter: (cellContent, row) => {
         const service = row && row.serviceName
         return <span>{service}</span>
        //  return <span>{row.eventName.length > 1 ? event +"," : event}</span>
        },
        options: serviceOptions
      },
      {
        id: "3",
        value: "shortCode",
        autofillValue: codeValueMetaData,
        label: "Short Code",
        placeholder: "Enter Short Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        type: "code",
      },
      {
        id: "4",
        value: "offerTitle",
        label: "Offer Title",
        placeholder: "Enter Offer Title",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
        formatter: (cellContent, row)=> {
          return <>
              <span style={{textTransform: "uppercase"}}>{row.offerTitle}</span>
                </>
          },
      },
      {
        id: "5",
        value: "fromDate",
        label: "Offer From Date",
        editRecord: true,
        viewRecord: true,
        required: true,
        sort: true,
        colProps: {
          lg: "6",
          md: "6",
          className: "filter-field",
        },
        type: "date",
        formatter: (cellContent, row)=> {
          return <>
             <p>{moment(row.fromDate).format("DD-MM-YYYY")}</p>
                </>
          },
      },
      {
        id: "6",
        value: "toDate",
        label: "Offer To Date",
        editRecord: true,
        viewRecord: true,
        required: true,
        sort: true,
        colProps: {
          lg: "6",
          md: "6",
          className: "filter-field",
        },
        type: "date",
        formatter: (cellContent, row)=> {
          return <>
             <p>{moment(row.toDate).format("DD-MM-YYYY")}</p>
                </>
          },
      },
      {
        id: "5",
        value: "description",
        label: "Description",
        sort: true,
        required: true,
        placeholder: "Enter Description",
        editRecord: true,
        viewRecord: true,
        type: "text",
        formatter: (cellContent, row)=> {
          return <>
              <span style={{textTransform: "uppercase"}}>{row.description}</span>
                </>
          },
      },
      {
        id: "8",
        value: "status",
         label: "Status",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             <Badge
               className={`font-size-12 badge rounded-pill ${row.status === 1
                 ? "bg-success badge-soft-success"
                 : "bg-danger badge-soft-danger"
                 }`}
               color={row.badgeclass}
               pill
             >
               {row.status === 1 ? "Active" : "Inactive"}
             </Badge>
           ),
         type: "text",
      },
      {
        id: "7",
        value: "offerImage",
        label: "Offer Image",
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "3",
          md: "6",
          className: "filter-field",
        },
       
        type: "upload",
      },
      {
        id: "9",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]},
  },
  {
    schemaId: "c2FsZXMgZW5",
    name: "salesEntry",
    title: "Sales Entry",
    path: "/sales-entry",
    visible: true,
    formTitle: "Sales",
    page: "Sales",
    ...c2FsZXMgZW5,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "code",
        label: "State Code",
        placeholder: "Enter State Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
      },
      {
        id: "4",
        value: "name",
        label: "State Name",
        placeholder: "Enter State Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
      },
      {
        id: "5",
        value: "countryName",
        label: "Country Name",
        sort: true,
        editRecord: false,
        viewRecord: true,
        type: "text",
      },
      {
        id: "6",
        value: "companyId",
        label: "Company",
        placeholder: "Select Company",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "select",
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
            (metaData &&
              metaData.companyOptions &&
              metaData.companyOptions.length > 0 &&
              metaData.companyOptions.find(
                (_) => _.value.toString() === cellContent.toString()
              ) &&
              metaData.companyOptions.find((_) => _.value === cellContent)
                .label) ||
            ""
          )
        },
        options: "companyOptions",
      },
      {
        id: "7",
        value: "venueLocation",
        label: "Venue Location",
        placeholder: "Select Venue Location",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
          },
        },
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
            (cellContent &&
              metaData &&
              metaData.cityOptions &&
              metaData.cityOptions.length > 0 &&
              metaData.cityOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ) &&
              metaData.cityOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ).label) ||
            ""
          )
        },
        type: "select",
        options: "cityOptions",
      },
      {
        id: "8",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "9",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
  {
    schemaId: "c2FsZXM",
    name: "sales",
    title: "Sales",
    path: "/sales-approval",
    visible: true,
    formTitle: "Sales",
    page: "Sales",
    ...c2FsZXM,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "code",
        label: "State Code",
        placeholder: "Enter State Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
      },
      {
        id: "4",
        value: "name",
        label: "State Name",
        placeholder: "Enter State Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
      },
      {
        id: "5",
        value: "countryName",
        label: "Country Name",
        sort: true,
        editRecord: false,
        viewRecord: true,
        type: "text",
      },
      {
        id: "6",
        value: "companyId",
        label: "Company",
        placeholder: "Select Company",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "select",
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
            (metaData &&
              metaData.companyOptions &&
              metaData.companyOptions.length > 0 &&
              metaData.companyOptions.find(
                (_) => _.value.toString() === cellContent.toString()
              ) &&
              metaData.companyOptions.find((_) => _.value === cellContent)
                .label) ||
            ""
          )
        },
        options: "companyOptions",
      },
      {
        id: "7",
        value: "venueLocation",
        label: "Venue Location",
        placeholder: "Select Venue Location",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
          },
        },
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
            (cellContent &&
              metaData &&
              metaData.cityOptions &&
              metaData.cityOptions.length > 0 &&
              metaData.cityOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ) &&
              metaData.cityOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ).label) ||
            ""
          )
        },
        type: "select",
        options: "cityOptions",
      },
      {
        id: "8",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "9",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
  {
    schemaId: "c2FsZXMgcWM",
    name: "salesQc",
    title: "SalesQC",
    path: "/sales-qc",
    visible: true,
    formTitle: "SalesQC",
    page: "SalesQC",
    ...c2FsZXMgcWM,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "code",
        label: "State Code",
        placeholder: "Enter State Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
      },
      {
        id: "4",
        value: "name",
        label: "State Name",
        placeholder: "Enter State Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
      },
      {
        id: "5",
        value: "countryName",
        label: "Country Name",
        sort: true,
        editRecord: false,
        viewRecord: true,
        type: "text",
      },
      {
        id: "6",
        value: "companyId",
        label: "Company",
        placeholder: "Select Company",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "select",
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
            (metaData &&
              metaData.companyOptions &&
              metaData.companyOptions.length > 0 &&
              metaData.companyOptions.find(
                (_) => _.value.toString() === cellContent.toString()
              ) &&
              metaData.companyOptions.find((_) => _.value === cellContent)
                .label) ||
            ""
          )
        },
        options: "companyOptions",
      },
      {
        id: "7",
        value: "venueLocation",
        label: "Venue Location",
        placeholder: "Select Venue Location",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
          },
        },
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
            (cellContent &&
              metaData &&
              metaData.cityOptions &&
              metaData.cityOptions.length > 0 &&
              metaData.cityOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ) &&
              metaData.cityOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ).label) ||
            ""
          )
        },
        type: "select",
        options: "cityOptions",
      },
      {
        id: "8",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "9",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
  {
    schemaId: "YWx0ZXIgcXVvdGU",
    name: "alterQuote",
    title: "AlterQuote",
    path: "/alter-quote",
    visible: true,
    formTitle: "AlterQuote",
    page: "AlterQuote",
    ...YWx0ZXIgcXVvdGU,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "code",
        label: "State Code",
        placeholder: "Enter State Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
      },
      {
        id: "4",
        value: "name",
        label: "State Name",
        placeholder: "Enter State Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
      },
      {
        id: "5",
        value: "countryName",
        label: "Country Name",
        sort: true,
        editRecord: false,
        viewRecord: true,
        type: "text",
      },
      {
        id: "6",
        value: "companyId",
        label: "Company",
        placeholder: "Select Company",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "select",
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
            (metaData &&
              metaData.companyOptions &&
              metaData.companyOptions.length > 0 &&
              metaData.companyOptions.find(
                (_) => _.value.toString() === cellContent.toString()
              ) &&
              metaData.companyOptions.find((_) => _.value === cellContent)
                .label) ||
            ""
          )
        },
        options: "companyOptions",
      },
      {
        id: "7",
        value: "venueLocation",
        label: "Venue Location",
        placeholder: "Select Venue Location",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
          },
        },
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
            (cellContent &&
              metaData &&
              metaData.cityOptions &&
              metaData.cityOptions.length > 0 &&
              metaData.cityOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ) &&
              metaData.cityOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ).label) ||
            ""
          )
        },
        type: "select",
        options: "cityOptions",
      },
      {
        id: "8",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading === 1 ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "9",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
  {
    schemaId: "ZXZlbnQgbGlz",
    name: "event",
    title: "Event List",
    path: "/event-list",
    visible: true,
    formTitle: "Event List",
    page: "Event",
    ...ZXZlbnQgbGlz,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "eventCode",
          autofillValue: codeValueMetaData,
          label: "Event Code",
          placeholder: "Enter Event Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          type: "code",
          formatter: (cellContent, row) => {
            return <>
              <span style={{ textTransform: "uppercase" }}>{row.eventCode}</span>
            </>
          },
          colProps: {
            lg: "6",
            md: "6",
            style: { paddingRight: "15px" },
          },
        },
        {
          id: "4",
          value: "eventName",
          label: "Event Name",
          placeholder: "Enter Event Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return <>
              <span style={{ textTransform: "uppercase" }}>{row.eventName}</span>
            </>
          },
          type: "text",
         // validations: "textOnly",

          colProps: {
            lg: "6",
            md: "6",
            style: { paddingRight: "15px" },
          },
        },
        {
          id: "5",
          value: "description",
          label: "Description",
          placeholder: "Enter Description ",
          sort: true,
          editRecord: true,
          required: true,
          viewRecord: true,
          formatter: (cellContent, row) => {
            return <>
              <span style={{ textTransform: "uppercase" }}>{row.description}</span>
            </>
          },
          type: "textarea",
        },
      
        {
          id: "6",
          value: "isMainEvent",
          label: "Is Main Event",
          placeholder: "Enter EC",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: false,
            formatter: (cellContent, row) => {
            return (<>
             
              <Badge
              className={`font-size-12 badge rounded-pill ${row.isMainEvent==true
                ? "bg-success"
                : "bg-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.isMainEvent==true?"Yes":"No"}
            </Badge>
            </>)
          },
          type: "checkbox",
          // validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
              className={`font-size-12 badge rounded-pill ${row.status ===1 
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "Zm9sbG93dXA",
    name: "followup",
    title: "followup",
    path: "/followup",
    visible: true,
    formTitle: "followup",
    page: "followup",
    ...Zm9sbG93dXA,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "code",
        label: "State Code",
        placeholder: "Enter State Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
      },
      {
        id: "4",
        value: "name",
        label: "State Name",
        placeholder: "Enter State Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
      },
      {
        id: "5",
        value: "countryName",
        label: "Country Name",
        sort: true,
        editRecord: false,
        viewRecord: true,
        type: "text",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },

  //Followup Start
  {
    schemaId: "Zm9sbG93dXBfbWFzdGVy",
    name: "followup_master",
    title: "Followup Mode",
    formTitle: "Followup Mode",
    path: "/followup-mode",
    visible: true,
    ...Zm9sbG93dXBfbWFzdGVy,
    page: "FollowupMode",
    exact: true,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "followupCode",
          autofillValue: codeValueMetaData,
          label: "Followup Code",
          placeholder: "Enter Followup Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return <>
              <span style={{ textTransform: "uppercase" }}>{row.followupCode}</span>
            </>
          },
          type: "code",
        },
        {
          id: "5",
          value: "followupMaster",
          label: "Followup Name",
          placeholder: "Enter Followup Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          type: "textOnly",
          formatter: (cellContent, row) => {
            return <>
              <span style={{ textTransform: "uppercase" }}>{row.followupMaster}</span>
            </>
          },
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ?  "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //Followup End

  //Followup Status Start
  {
    schemaId: "Zm9sbG93dXBfYWN0aW9u",
    name: "followup_action",
    title: "Followup Status",
    formTitle: "Followup Status",
    path: "/followup-status",
    visible: true,
    ...Zm9sbG93dXBfYWN0aW9u,
    page: "FollowupStatus",
    exact: true,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "followupCode",
          autofillValue: codeValueMetaData,
          label: "Followup Code",
          placeholder: "Enter Followup Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.followupCode}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "followupAction",
          label: "Followup Status Name",
          placeholder: "Enter Followup Status Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return <>
              <span style={{ textTransform: "uppercase" }}>{row.followupAction}</span>
            </>
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //Followup Status End

  //Followup Strategy Start
  {
    schemaId: "Zm9sbG93dXBfc3RyYXRlZ3k",
    name: "followup_strategy",
    title: "Followup Strategy",
    formTitle: "Followup Strategy",
    path: "/followup-strategy",
    visible: true,
    ...Zm9sbG93dXBfc3RyYXRlZ3k,
    page: "FollowupStrategy",
    exact: true,
    columns: (records = [], metaData) => {
      console.log(records, "record from api")
      console.log(metaData, "record from meta data")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "shortCode",
          autofillValue: codeValueMetaData,
          label: "Followup Strategy Code",
          placeholder: "Enter Followup Strategy Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          formatter: (cellContent, row) => {
            return <>
              <span style={{ textTransform: "uppercase" }}>{row.shortCode}</span>
            </>
          },
          // required: true,
          type: "code",
        },
        {
          id: "5",
          value: "followupStrategy",
          label: "Followup Strategy",
          placeholder: "Enter Followup Strategy",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return <>
              <span style={{ textTransform: "uppercase" }}>{row.followupStrategy}</span>
            </>
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status == 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status == 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  //Followup Strategy End

  {
    schemaId: "fc2400f3",
    name: "branch",
    title: "Branch List",
    path: "/branch",
    visible: true,
    formTitle: "Branch List",
    page: "Branch",
    ...fc2400f3,
     columns: (record = {}, metaData) => {
      const stateOptions =
      record &&
      record.country &&
      metaData &&
      Object.keys(metaData).length > 0 &&
      metaData.stateOptions &&
      metaData.stateOptions.length > 0
        ? metaData.stateOptions.filter(
            (c) => c.countryId !== undefined ? c.countryId.toString() === record.country.toString() : []
          )
        : metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.stateOptions &&
          metaData.stateOptions.length > 0
        ? metaData.stateOptions
        : []
      const cityOptions =
      record &&
      record.state &&
      metaData &&
      Object.keys(metaData).length > 0 &&
      metaData.cityOptions &&
      metaData.cityOptions.length > 0
        ? metaData.cityOptions.filter(
            (c) => c.stateId !== undefined ? c.stateId.toString() === record.state.toString() : []
          )
        : metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.cityOptions &&
          metaData.cityOptions.length > 0
        ? metaData.cityOptions
        : []
       console.log(record, "record from api")
       console.log(metaData , "record from api")
       
       const codeValueMetaData = metaData && metaData.codeOptions
       return [
         {
           id: "1",
           value: "_id",
           label: "Id",
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: "text",
         },
         {
           id: "2",
           value: "sno",
           label: "S.No",
           sort: false,
           editRecord: false,
           viewRecord: true,
           formatter: (cellContent, row, rowIndex) =>
             row.loading ? (
               <p className="card-text placeholder-glow">
                 <span className="placeholder col-7"></span>
               </p>
             ) : (
               rowIndex + 1
             ),
           type: "text",
         },
         {
           id: "3",
           value: "actions",
           label: "Actions",
           sort: false,
           editRecord: false,
           viewRecord: true,
           editFormatter: "actions",
           type: "text",
         },
         {
           id: "4",
           value: "companyId",
           label: "Company",
           placeholder: "Select Company",
           sort: true,
           editRecord: true,
           viewRecord: true,
           required: true,
           type: "select",
           colProps: {
             lg: "6",
             md: "6",
             style: { paddingRight: "15px" },
           },
           formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.companyOptions &&
                metaData.companyOptions.length > 0 &&
                metaData.companyOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.companyOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          //  formatter: (cellContent, row, ) => {
          //    return (
          //       <span style={{textTransform: "uppercase"}}>{row.companyName}</span>
          //    )
          //  },
           options: "companyOptions",
         },
         {
           id: "5",
           value: "code",
           autofillValue: codeValueMetaData,
           label: "Branch Code",
           placeholder: "Enter Branch Code",
           sort: true,
           editRecord: true,
           viewRecord: true,
           // required: true,
           colProps: {
             lg: "6",
             md: "6",
             style: { paddingRight: "15px" },
           },
           formatter: (cellContent, row) => {
             console.log(row, "row from api")
             return (
               <>
                 <p style={{ textTransform: "uppercase" }}>{row.code}</p>
               </>
             )
           },
           type: "code",
         },
         {
           id: "6",
           value: "name",
           label: "Branch Name",
           placeholder: "Enter Branch Name",
           sort: true,
           editRecord: true,
           viewRecord: true,
           required: true,
           colProps: {
             lg: "6",
             md: "6",
             style: { paddingRight: "15px" },
           },
           formatter: (cellContent, row) => {
             return <span style={{ textTransform: "uppercase" }}>{row.name} </span>
           },
           type: "textOnly",
           validations: "textOnly"
         },
         {
           id: "7",
           value: "mobileNumber",
           label: "Mobile Number",
           placeholder: "Enter Mobile Number",
           sort: true,
           editRecord: true,
           viewRecord: true,
           required: true,
           colProps: {
             lg: "6",
             md: "6",
             style: { paddingRight: "15px" },
           },
           type: "mobile",
           validations: "mobile"
         },
         {
           id: "8",
           value: "email",
           label: "Email",
           placeholder: "Enter Email",
           sort: true,
           editRecord: true,
           viewRecord: true,
           required: true,
           colProps: {
             lg: "6",
             md: "6",
             style: { paddingRight: "15px" },
           },
           formatter: (cellContent, row) => {
             return <span style={{ textTransform: "uppercase" }}>{row.email} </span>
           },
           type: "email",
         },
         {
           id: "9",
           value: "address",
           label: "Address",
           placeholder: "Enter Address",
           sort: true,
           editRecord: true,
           viewRecord: true,
           required: true,
           colProps: {
             lg: "6",
             md: "6",
             style: { paddingRight: "15px" },
           },
           formatter: (cellContent, row) => {
            return <span style={{ textTransform: "uppercase" }}>{row.address} </span>
          },
           type: "textOnly",
 
         },
         {
           id: "10",
           value: "country",
           label: "Country",
           placeholder: "Enter Country",
           sort: true,
           editRecord: true,
           viewRecord: false,
           required: true,
           colProps: {
             lg: "6",
             md: "6",
             style: { paddingRight: "15px" },
           },
           formatter: (cellContent, row) => {
            return <span style={{ textTransform: "uppercase" }}>{row.countryname} </span>
          },
          type: "select",
          options: "countryOptions",
        },
         {
           id: "11",                                                                                                                           
           value: "state",
           label: "State",
           placeholder: "Enter State",
           sort: true,
           editRecord: true,
           viewRecord: false,
           required: true,
           colProps: {
             lg: "6",
             md: "6",
             style: { paddingRight: "15px" },
           },
           formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.stateOptions &&
                metaData.stateOptions.length > 0 &&
                metaData.stateOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.stateOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: stateOptions ,
        },
         {
           id: "12",
           value: "city",
           label: "City",
           placeholder: "Enter City",
           sort: true,
           editRecord: true,
           viewRecord: false,
           required: true,
           colProps: {
             lg: "6",
             md: "6",
             style: { paddingRight: "15px" },
           },
           formatter: ( row) => {
            return <span style={{ textTransform: "uppercase" }}>{row.cityname} </span>
          },
          type: "select",
          options: cityOptions,
        },
        {
          id: "13",
          value: "pincode",
          label: "Pin Code",
          placeholder: "Enter Pin Code",
          sort: true,
          editRecord: true,
          viewRecord: false,
          required: true,
          colProps: {
            lg: "6",
            md: "6",
            style: { paddingRight: "15px" },
            className: "employee-input"
          },
          type: "zipCode",
          validations: "zipCode"
        },
        {
          id: "14",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "15",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "16",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "17",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "18",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: 'dW5hc3NpZ25lZEVj',
    name: 'unassignedEc',
    title: 'UnassignedEc',
    path: '/unassigned-ec',
    visible: true,
    formTitle: 'UnassignedEc',
    page: 'UnassignedEc',
    ...dW5hc3NpZ25lZEVj,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "5",
        value: "budgetFrom",
        label: "Budget From",
        placeholder: "Enter Budget From",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        colProps: {
          className: "employee-input"
        },
        type: "number",
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.budgetFrom} </span>
          },
      },
      {
        id: "5",
        value: "budgetTo",
        label: "Budget To",
        placeholder: "Enter Budget To",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        colProps: {
          className: "employee-input",
          style: {
            marginTop: "7px"
          },
        },
        type: "number",
      },
      {
        id: "5",
        value: "colorCode",
        label: "Color Code",
        placeholder: "Enter Color Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        colProps: {
          style: {
            marginTop: "7px"
          },
        },
        formatter: (cellContent, row) => {
          console.log(row, "row from api")
          return (
            <>
              <p style={{ textTransform: "uppercase" }}>{row.colorCode}</p>
            </>
          )},
        type: "text",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status == 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],

  },
  {
    schemaId: 'ZWNBc3NpZ25lZExpc3Q',
    name: 'ecAssignedList',
    title: 'EcAssignedList',
    path: '/ec-assigned-list',
    visible: true,
    formTitle: 'EcAssignedList',
    page: 'EcAssignedList',
    ...ZWNBc3NpZ25lZExpc3Q,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "5",
        value: "budgetFrom",
        label: "Budget From",
        placeholder: "Enter Budget From",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        colProps: {
          className: "employee-input"
        },
        type: "number",
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.budgetFrom} </span>
          },
      },
      {
        id: "5",
        value: "budgetTo",
        label: "Budget To",
        placeholder: "Enter Budget To",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        colProps: {
          className: "employee-input",
          style: {
            marginTop: "7px"
          },
        },
        type: "number",
      },
      {
        id: "5",
        value: "colorCode",
        label: "Color Code",
        placeholder: "Enter Color Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        colProps: {
          style: {
            marginTop: "7px"
          },
        },
        formatter: (cellContent, row) => {
          console.log(row, "row from api")
          return (
            <>
              <p style={{ textTransform: "uppercase" }}>{row.colorCode}</p>
            </>
          )},
        type: "text",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status == 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],

  },
  {
    schemaId: "da6383a4",
    name: "country",
    title: "Country List",
    path: "/country",
    visible: true,
    formTitle: "Country List",
    page: "Country",
    ...da6383a4,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "3",
        value: "shortName",
        label: "Country Code",
        placeholder: "Enter Country Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
        // validations:'textOnly',
        formatter: (cellContent, row) => {
          return <span style={{ textTransform: "uppercase" }}>{row.shortName} </span>
        }
      },
      {
        id: "4",
        value: "name",
        label: "Country Name",
        placeholder: "Enter Country Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'textOnly',
        formatter: (cellContent, row) => {
          return <span style={{ textTransform: "uppercase" }}>{row.name} </span>
        },
        validations: 'textOnly'
      },
      {
        id: "5",
        value: "countryCode",
        label: "Dial Code",
        placeholder: "Enter Dial Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        colProps: {
          className: "employee-input"},
        formatter: (cellContent, row) => {
          return <span>{row.countryCode} </span>
        },
        type: "zipCode",
      },
      {
        id: "14",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
  {
    schemaId: "a99df6f1",
    name: "state",
    title: "State List",
    path: "/state",
    visible: true,
    formTitle: "State List",
    page: "State",
    ...a99df6f1,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "countryId",
        label: "Country Name",
        placeholder: "Enter Country Name",
        sort: true,
        editRecord: true,
        required: true,
        viewRecord: true,
        formatter: (cellContent, row) => {
          return <span style={{ textTransform: "uppercase" }}>{row.countryname} </span>
        },
        type: "select",
        options: "countryOptions",
      },
      {
        id: "5",
        value: "shortName",
        label: "State Code",
        placeholder: "Enter State Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return <span style={{ textTransform: "uppercase" }}>{row.shortName} </span>
        },
        type: "text",
      },
      {
        id: "6",
        value: "name",
        label: "State Name",
        placeholder: "Enter State Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return <span style={{ textTransform: "uppercase" }}>{row.name} </span>
        },
        type: 'textOnly',
        validations: 'textOnly'
      },

      {
        id: "7",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${ row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "8",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
  {
    schemaId: "db1dc367",
    name: "city",
    title: "City List",
    path: "/city",
    visible: true,
    formTitle: "City List",
    page: "City",
    ...db1dc367,
    columns: (record = [], metaData) => {
      console.log(metaData, "metaData")
      const stateOptions =
          record &&
          record.countryId &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.stateOptions &&
          metaData.stateOptions.length > 0
            ? metaData.stateOptions.filter(
                (c) => c.countryId !== undefined ? c.countryId.toString() === record.countryId.toString() : []
              )
            : metaData &&
              Object.keys(metaData).length > 0 &&
              metaData.stateOptions &&
              metaData.stateOptions.length > 0
            ? metaData.stateOptions
            : []
  
      return[
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "3",
        value: "countryId",
        label: "Country Name",
        placeholder: "Enter Country Name",
        sort: true,
        editRecord: true,
        required: true,
        viewRecord: true,
        formatter: (cellContent, row) => {
          return <span style={{ textTransform: "uppercase" }}>{row.countryname} </span>
        },
        type: "select",
        options: "countryOptions",
      },
      {
        id: "4",
        value: "stateId",
        label: "State Name",
        placeholder: "Enter State Name",
        sort: true,
        editRecord: true,
        required: true,
        viewRecord: true,
        formatter: (cellContent, row) => {
          return <span style={{ textTransform: "uppercase" }}>{row.statename} </span>
        },
        type: "select",
        options: stateOptions, 
      },
      
     
      {
        id: "5",
        value: "name",
        label: "City Name",
        placeholder: "Enter City Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.name} </span>
          },
        type: 'textOnly',
        validations:'textOnly'
      },
      
     
      {
        id: "6",
        value: "shortName",
        label: "City Code",
        placeholder: "Enter City Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.shortName} </span>
          },
        type: "text",
      },
       {
        id: "7",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${
                row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
              }`}
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]}
  },
  {
    schemaId: "fa2c0984",
    name: "department",
    title: "Department List",
    path: "/department",
    visible: true,
    formTitle: "Department List",
    page: "Department",
    ...fa2c0984,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  {
    schemaId: "bG9naW5fb3Rw",
    name: "employeeLoginOtp",
    title: "LoginOtp List",
    path: "/login-otp",
    visible: true,
    formTitle: "LoginOtp List",
    page: "LoginOtp",
    ...bG9naW5fb3Rw,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  {
    schemaId: "e3bf4eed",
    name: "lead",
    title: "New Lead",
    formTitle: "New Lead",
    path: "/manage-lead",
    visible: true,
    ...e3bf4eed,
    page: "Lead",
    className: "lead-counter",
    enableTableFilter: true,
    grid: [
      {
        id: 1,
        component: LeadHeader,
      },
      {
        id: 2,
        component: "Counter",
        onLoad: async (filterData) => {
          return await api
            .post("/get_lead_count_by_status_new", filterData)
            .then((response) => response.data && response.data.data)
            .catch((error) => Promise.reject(error))
        },
        columns: () => [
  {
            id: "1",
            filterId: false,
            value: "lead",
            label: "Lead",
            customLabel: "Lead - Today’s | MTD | Overall",
            editRecord: false,
            viewRecord: true,
            getValues: (data) => {
              console.log(data,"schema")
              return (data || []).map(
                (a) =>
                  Object.assign({},  {
                    monthTillDate:a.lead.monthLead,
                    todayLead: a.lead.todayLead,
                    totalLead: a.lead.totalLead,
                  })
              )
            },
            cardStyle: {
              backgroundColor: "#0D70E2",
              marginBottom: "0px",
              display: "inline-block",
              width: "100%",
              height: "92px",
            },
            type: "text",
          },        
          {
            id: "2",
            filterId: "PS2",
            value: "openLeads",
            label: "Unactioned",
            customLabel: "Unactioned - Today’s | MTD | Overall",
            editRecord: false,
            viewRecord: true,
            getValues: (records) => {
              return (records || [])
                .filter(
                  (s) =>
                    s._id &&
                    s._id.processStatusId &&
                    s._id.processStatusId === "PS2"
                )
                .reduce(
                  (a, el) =>
                    Object.assign({}, a, {
                      monthTillDate:
                        parseInt(a.monthTillDate) + parseInt(el.monthTillDate),
                      todayLead: parseInt(a.todayLead) + parseInt(el.todayLead),
                      totalLead: parseInt(a.totalLead) + parseInt(el.totalLead),
                    }),
                  { todayLead: 0, monthTillDate: 0, totalLead: 0 }
                )
            },
            cardStyle: {
              backgroundColor: "#F1B54C",
              marginBottom: "0px",
              display: "inline-block",
              width: "100%",
            },
            type: "text",
          },
          {
            id: "3",
            filterId: "PS3",
            value: "convertedLeads",
            label: "Conversions",
            customLabel: "Conversions - Today’s | MTD | Overall",
            editRecord: false,
            viewRecord: true,
            getValues: (records) => {
              return (records || [])
                .filter(
                  (s) =>
                    s._id &&
                    s._id.processStatusId &&
                    s._id.processStatusId === "PS3"
                )
                .reduce(
                  (a, el) =>
                    Object.assign({}, a, {
                      monthTillDate:
                        parseInt(a.monthTillDate) + parseInt(el.monthTillDate),
                      todayLead: parseInt(a.todayLead) + parseInt(el.todayLead),
                      totalLead: parseInt(a.totalLead) + parseInt(el.totalLead),
                    }),
                  { todayLead: 0, monthTillDate: 0, totalLead: 0 }
                )
            },
            cardStyle: {
              backgroundColor: "#34C28F",
              marginBottom: "0px",
              display: "inline-block",
              width: "100%",
            },
            type: "text",
          },
          {
            id: "4",
            filterId: "PS10",
            value: "rejectedLeads",
            label: "Rejected",
            customLabel: "Rejected - Today’s | MTD | Overall",
            editRecord: false,
            viewRecord: true,
            getValues: (records) => {
              return (records || [])
                .filter(
                  (s) =>
                    s._id &&
                    s._id.processStatusId &&
                    s._id.processStatusId === "PS10"
                )
                .reduce(
                  (a, el) =>
                    Object.assign({}, a, {
                      monthTillDate:
                        parseInt(a.monthTillDate) + parseInt(el.monthTillDate),
                      todayLead: parseInt(a.todayLead) + parseInt(el.todayLead),
                      totalLead: parseInt(a.totalLead) + parseInt(el.totalLead),
                    }),
                  { todayLead: 0, monthTillDate: 0, totalLead: 0 }
                )
            },
            cardStyle: {
              backgroundColor: "#F46969",
              marginBottom: "0px",
              display: "inline-block",
              width: "100%",
            },
            type: "text",
          },
          {
            id: "5",
            filterId: "PS4",
            value: "followupLeads",
            label: "Follow - Ups Pending",
            customLabel: "Follow - Ups Pending - Today’s | MTD | Overall",
            editRecord: false,
            viewRecord: true,
            getValues: (records) => {
              return (records || [])
                .filter(
                  (s) =>
                    s._id &&
                    s._id.processStatusId &&
                    s._id.processStatusId === "PS4"
                )
                .reduce(
                  (a, el) =>
                    Object.assign({}, a, {
                      monthTillDate:
                        parseInt(a.monthTillDate) + parseInt(el.monthTillDate),
                      todayLead: parseInt(a.todayLead) + parseInt(el.todayLead),
                      totalLead: parseInt(a.totalLead) + parseInt(el.totalLead),
                    }),
                  { todayLead: 0, monthTillDate: 0, totalLead: 0 }
                )
            },
            cardStyle: {
              backgroundColor: "#50A5F0",
              marginBottom: "0px",
              display: "inline-block",
              width: "100%",
            },
            type: "text",
          },
          {
            id: "6",
            filterId: "PS5",
            value: "runRate",
            label: "Run Rate",
            customLabel: "Run Rate - Current RR | Required RR",
            editRecord: false,
            viewRecord: true,
            getValues: (records) => {
              return (records || [])
                .filter(
                  (s) =>
                    s._id &&
                    s._id.processStatusId &&
                    s._id.processStatusId === "PS5"
                )
                .reduce(
                  (a, el) =>
                    Object.assign({}, a, {
                      monthTillDate:
                        parseInt(a.monthTillDate) + parseInt(el.monthTillDate),
                      todayLead: parseInt(a.todayLead) + parseInt(el.todayLead),
                      totalLead: parseInt(a.totalLead) + parseInt(el.totalLead),
                    }),
                  { todayLead: 0, monthTillDate: 0, totalLead: 0 }
                )
            },
            cardStyle: {
              backgroundColor: "#353A40",
              marginBottom: "0px",
              display: "inline-block",
              width: "100%",
            },
            type: "text",
          },
        ],
      },
      {
        id: 3,
        component: "DynamicFilter",
        onSubmit: ({ dispatch, actions, submitData, setSubmitting }) => {
          dispatch(
            actions.loadRecords(
              Object.assign({}, submitData, { status: "active" }),
              true
            )
          )
          setTimeout(() => {
            setSubmitting(false)
          }, 3000)
        },
        // onReset: ({ dispatch, actions},setFieldValue) => {
        //   setFieldValue({
        //     companyId: [],
        //     branchId: []
        //   })
        //   dispatch(
        //     actions.loadRecords(
        //       Object.assign({}, { status: "active" }),
        //       true
        //     )
        //   )
        // },
        initialValues: {
          status: "active",
          id: "",
          mobileNo: "",
          leadType: "",
          companyName: "",
          branchId: "",
          // leadFromDate: "",
          // leadToDate: "",
          priorityStatusId: "",
          processStatusId: "",
          leadServiceId: "",
          leadSourceId: "",
          leadSubSourceId: "",
          employeeId: "",
        },
        columns: (record = {}, metaData) => {

          console.log(record,metaData, "record from manage lead lead lead lead")
          const branchOptions =
            record &&
              record.companyId &&
              metaData &&
              Object.keys(metaData).length > 0 &&
              metaData.branchOptions
              ? metaData.branchOptions.filter(
                (_) => _.companyId !== undefined ? _.companyId.toString() === record.companyId.toString() : []
              )
              : metaData &&
                Object.keys(metaData).length > 0 &&
                metaData.branchOptions &&
                metaData.branchOptions.length > 0
                ? metaData.branchOptions
                : []
          const serviceOptions =
            record &&
              record.companyId &&
              metaData &&
              Object.keys(metaData).length > 0 &&
              metaData.serviceOptions &&
              metaData.serviceOptions.length > 0
              ? metaData.serviceOptions.filter((_) =>
              _.companyId !== undefined ? _.companyId.toString() === record.companyId.toString() : []
              )
              : metaData &&
                Object.keys(metaData).length > 0 &&
                metaData.serviceOptions &&
                metaData.serviceOptions.length > 0
                ? metaData.serviceOptions
                : []

          return [
            {
              id: "1",
              value: "_id",
              label: "Id",
              editRecord: false,
              viewRecord: false,
              type: "text",
            },
            {
              id: "2",
               value: "companyId",
              label: "Company",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "filterMultiSelect",
               options: "companyOptions",
            },
            {
              id: "3",
              value: "branchId",
              label: "Branch",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "filterMultiSelect",
              options: branchOptions,
            },
            {
              id: "4",
              value: "leadServiceId",
              label: "Service",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "filterSelect",
              options: serviceOptions,
            },
            {
              id: "5",
              value: "priorityStatusId",
              label: "Priority Status",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "filterSelect",
              options: "priorityStatusOptions",
            },
            {
              id: "6",
              value: "leadStatus",
              label: "Lead Status",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "filterSelect",
              options: "processStatusOptions",
            },
            {
              id: "6",
              value: "eventId",
              label: "Event",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "filterSelect",
              options: "eventOptions",
            },
            {
              id: "7",
              value: "mobileNo",
              label: "Mobile Number",
              editRecord: true,
              viewRecord: false,
              placeholder: "Enter Mobile Number",
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "mobile",
            },
            {
              id: "8",
              value: "eventFromDate",
              label: "Event From Date",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "date",
            },
            {
              id: "9",
              value: "eventToDate",
              label: "Event To Date",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "date",
            },
            {
              id: "10",
              value: "leadNo",
              label: "Lead No",
              editRecord: true,
              viewRecord: false,
              placeholder: "Enter Lead No",
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "text",
            },
            {
              id: "10",
              value: "leadFromDate",
              label: "Lead From Date",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "date",
            },
            {
              id: "11",
              value: "leadToDate",
              label: "Lead To Date",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "date",
            },
            {
              id: "12",
              value: "followUpDate",
              label: "FollowUp Date",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "date",
            },
            {
              id: "13",
              value: "employeeId",
              label: "Sales Agent",
              editRecord: true,
              viewRecord: false,
              placeholder: "Enter Sales Agent",
              colProps: {
                lg: "3",
                md: "6",
                className: "multiselect-field",
                style: { fontSize: "11px",}
            },
            type: 'autocomplete',
            fuseOptions: { keys: ['empCode', 'name']},
            options: 'employeeListOptions'
            },
          
            {
              id: "13",
              value: "status",
              label: "Status",
              editRecord: false,
              viewRecord: false,
              type: "text",
            },
          ]
        },
      },
    ],
    submitButton: ({
      values,
      setFieldValue,
      handleSubmit,
      submitBtnText,
      isSubmitting,
    }) => {
      console.log(values, "values")
      return values &&
        (values.primaryMobileConfirm ||
          values.secondaryMobileConfirm ||
          values.whatsAppNoConfirm) ? (
        <ConfirmButton
          body={
            "This lead already exists, would you like to create this lead under the existing lead?"
          }
          closeBtnText="No"
          confirmBtnText="Yes"
          disableCloseBtn
          buttonLayout={({ updateState }) => {
            return (
              <React.Fragment>
                <button
                  type="button"
                  style={{ height: "46px" }}
                  className="btn btn-primary"
                  onClick={() => {
                    updateState({ openDialog: false })
                  }}
                >
                  {"Cancel"}
                </button>
                <button
                  type="button"
                  style={{ height: "46px" }}
                  className="btn btn-light"
                  onClick={() => {
                    updateState({ openDialog: false })
                    setFieldValue("isRequiredNewClientEntry", true)
                    // setFieldValue("clientId", "")
                    // handleSubmit()
                  }}
                >
                  {"No"}
                </button>
                <button
                  type="button"
                  style={{ height: "46px" }}
                  className="btn btn-primary"
                  onClick={() => {
                    updateState({ openDialog: false })
                    setFieldValue("isRequiredNewClientEntry", false)
                    handleSubmit()
                  }}
                >
                  {"Yes"}
                </button>
              </React.Fragment>
            )
          }}
        >
          {(open) => (
            <button
              key={"showConfirm"}
              id="showConfirm"
              disabled={isSubmitting}
              type="button"
              onClick={open}
              className="btn btn-success btn-label simple-form-submit-btn"
            >
              <i className="bx bx-check-double label-icon"></i>
              {isSubmitting ? <ButtonSpinner /> : submitBtnText || "Submit"}
            </button>
          )}
        </ConfirmButton>
      ) : (
        <button
          type="submit"
          disabled={isSubmitting}
          onClick={() => handleSubmit()}
          className="btn btn-success btn-label simple-form-submit-btn"
        >
          <i className="bx bx-check-double label-icon"></i>
          {isSubmitting ? <ButtonSpinner /> : submitBtnText || "Submit"}
        </button>
      )
    },
    onSubmitValues: (data, record = {},metaData) => {
      console.log(record, "metaData sss from manage lead")
      console.log(metaData,"my meta")
      console.log(data,"my data")
      var today = new Date()
      const time = today.getFullYear() + '-' +
        ((today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1)) + '-' +
        (today.getDate() < 10 ? '0' + today.getDate() : today.getDate()) + ' ' +
        (today.getHours()) + ':' +
        (today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()) + ':' +
        (today.getSeconds() < 10 ? '0' + today.getSeconds() : today.getSeconds())
      console.log(time, "time")
      const status =
        (record &&
          record.processStatus &&
          record.processStatus.processStatus)
      console.log(status)
      const modifyData = data
      modifyData.leadType = "wedding"
    // data.leadServiceId == "624975049a581d38fcbbc8b3" ||
    //  data.leadServiceId == "622f0ba6246a442107c8151f" || 
    //  data.leadServiceId == "63760fcf91e1fb43c5e8017a" || 
    //  data.leadServiceId == "6376100e91e1fb43c5e80193" ||  
    //  data.leadServiceId == "637610a291e1fb43c5e801d5" ||   
    //  data.leadServiceId == "637610da91e1fb43c5e801f6" || 
     
    //  data.leadServiceId == "6376110991e1fb43c5e8020f" ||  
    //  data.leadServiceId == "6376112191e1fb43c5e8021d" ||  
    //  data.leadServiceId == "6376343d91e1fb43c5e80527" || 
    //  data.leadServiceId == "6376345291e1fb43c5e80532" ||  
    //  data.leadServiceId == "6376345f91e1fb43c5e8053d" ||   
    //  data.leadServiceId == "6376346d91e1fb43c5e80548" ||  
    //  data.leadServiceId == "6376348191e1fb43c5e80553" ||  
    //  data.leadServiceId == "6376349291e1fb43c5e8055e" ||   
    //  data.leadServiceId == "637634a191e1fb43c5e80569" ||  
    //  data.leadServiceId == "637634ae91e1fb43c5e80574" ||  
    //  data.leadServiceId == "637634bb91e1fb43c5e8057f" ||  
    //  data.leadServiceId == "637634cb91e1fb43c5e8058a" ||  
    //  data.leadServiceId == "637634da91e1fb43c5e80595" ||   
    //  data.leadServiceId == "63b5299dd57a142a076cdab0" ||  
    //  data.leadServiceId == "63b529acd57a142a076cdbac" || 
    //  data.leadServiceId == "63b529c6d57a142a076cdca5" ||  
    //  data.leadServiceId == "63b529e1d57a142a076cdde1" ||
    //  data.leadServiceId == "63b52a36d57a142a076ceb58" ||
    //  data.leadServiceId == "63b52a7ed57a142a076cebc8" ||
    //  data.leadServiceId == "63b52aa1d57a142a076cec39" ||
    //  data.leadServiceId == "63b52ab8d57a142a076cec92" ||
    //  data.leadServiceId == "63b52b06d57a142a076cf000" ||
    //  data.leadServiceId == "63b52ad6d57a142a076cedab" ||
    //  data.leadServiceId == "63b52b1ed57a142a076cf0d1" ||
    //  data.leadServiceId == "63b52b34d57a142a076cfd3e" ||
    //  data.leadServiceId == "63b91d899cb084b899e678e5" ? "wedding" : "nonWedding"
      modifyData.companyId = data.companyId || ""
      // modifyData.companyName = data.companyId.label || ""
      modifyData.branchId = data.branchId || ""
      modifyData.leadSourceId = data.leadSourceId || ""
      modifyData.leadSubSourceId = "" || data.leadSubSourceId
      modifyData.leadServiceId = data.leadServiceId || ""
      modifyData.eventId = "61f0149ed6a0f0d4716e2b9b"
      modifyData.descriptions = data.descriptions || ""
      modifyData.customField = data.customField || []
      modifyData.priorityStatusId = data.priorityStatusId || ""
      modifyData.processStatus = {
        id: "620be8a53f52687300b1f3fe",
        statusName: "open",
      }
      modifyData.crossPromotion = data.crossPromotion || []
      modifyData.isRequiredNewClientEntry =
        data.isRequiredNewClientEntry === undefined
          ? true
          : data.isRequiredNewClientEntry || false
     modifyData.leadNo = data.leadNo || "",
      modifyData.leadDate = time || ""
      modifyData.clientDetails = {
        firstName: data.firstName || "",
        lastName: data.lastName || "",
        contact: {
          primaryMobile: {
            // code: data.primaryMobile && data.primaryMobile inputValue.data.dialCode,
            //code:  data.primaryMobile.substr(-10),
            // number:  data.primaryMobile,
            code :data.primaryMobile&& data.primaryMobile.length === 10 ? "+"+data.primaryMobile.slice(0,-8):data.primaryMobile.length === 12 ? "+"+data.primaryMobile.slice(0,-10):data.whatsAppNo.length === 11 ? "+"+data.primaryMobile.slice(0,-10):data.primaryMobile.length === 14 ? "+"+data.primaryMobile.slice(0,-12):data.primaryMobile.length === 15 ? "+"+data.primaryMobile.slice(0,-12):"",
             number:  data.primaryMobile&& data.primaryMobile.length ===12 ? data.primaryMobile.slice(2):data.primaryMobile.length ===11 ? data.primaryMobile.slice(1):data.whatsAppNo.length ===10 ? data.primaryMobile.slice(2):data.primaryMobile.length ===14 ? data.primaryMobile.slice(2):data.primaryMobile.length ===15 ? data.primaryMobile.slice(3): "",
           }, 
          
           secondaryMobile: "" || {
             code :data.secondaryMobile&& data.secondaryMobile.length === 10 ? "+"+data.secondaryMobile.slice(0,-8):data.secondaryMobile.length === 12 ? "+"+data.secondaryMobile.slice(0,-10):data.secondaryMobile.length === 11 ? "+"+data.secondaryMobile.slice(0,-10):data.secondaryMobile.length === 14 ? "+"+data.secondaryMobile.slice(0,-12):data.secondaryMobile.length === 15 ? "+"+data.secondaryMobile.slice(0,-12):"",
              //code :data.secondaryMobile&& data.secondaryMobile.length > 10 ? data.secondaryMobile.slice(0,-11):data.secondaryMobile.slice(0,-10),
             //code: "" || data.secondaryMobile !== "undefined" ? data.secondaryMobile.slice(0,-10) : "",
             number:  data.secondaryMobile&& data.secondaryMobile.length ===12 ? data.secondaryMobile.slice(2):data.secondaryMobile.length ===11 ? data.secondaryMobile.slice(1):data.secondaryMobile.length ===10 ? data.secondaryMobile.slice(2):data.secondaryMobile.length ===14 ? data.secondaryMobile.slice(2):data.secondaryMobile.length ===15 ? data.secondaryMobile.slice(3): "",
 
     
            },
           whatsAppNo: {
            
              code :data.whatsAppNo&& data.whatsAppNo.length === 10 ? "+"+data.whatsAppNo.slice(0,-8):data.whatsAppNo.length === 12 ? "+"+data.whatsAppNo.slice(0,-10):data.whatsAppNo.length === 11 ? "+"+data.whatsAppNo.slice(0,-10):data.whatsAppNo.length === 14 ? "+"+data.whatsAppNo.slice(0,-12):data.secondaryMobile.length === 15 ? "+"+data.whatsAppNo.slice(0,-12):"",
             number:data.whatsAppNo&& data.whatsAppNo.length ===12 ? data.whatsAppNo.slice(2):data.whatsAppNo.length ===11 ? data.whatsAppNo.slice(1):data.whatsAppNo.length ===10 ? data.whatsAppNo.slice(2):data.whatsAppNo.length ===14 ? data.whatsAppNo.slice(2):data.whatsAppNo.length ===15 ? data.whatsAppNo.slice(3): "",
         },
        },
        clientLocation: data.clientLocation || "",
        emailId: data.emailId || "",
        address: {
          primary: data.primaryAddress || "",
          secondary: data.primaryAddress || "",
        },
        city: "" || data.city,
        state: "" || data.state,
        country: "" || data.country,
        pincode: data.pincode || "",
      }
      modifyData.clientProfileRemarks = data.clientProfileRemarks || ""
      modifyData.clientProfile = data.clientProfile || ""
      modifyData.isSelfAssign = "" || data.isSelfAssign ? true : false
      modifyData.salesUrge = data.salesUrge || ""
      modifyData.clientId = data.clientId || ""
      modifyData.attachment = data.attachment || ""
      return modifyData
    },
    exact: true,
    initialValues:{
    companyId:"",
    branchId:"",
    leadServiceId:"",
    leadSourceId:"",
    firstName:"",
    saleSurge:"",
    clientProfile:"",
    primaryMobile:"",
    secondaryMobile:"",
    whatsAppNo:"",
    priorityStatusId:""

    },
    columns: (record = {}, metaData) => {

      // console.log(metaData, "records from api manage lead")
      // console.log(record.primaryMobile, "primary Mobile")
      const branchOptions =
        record &&
          record.companyId &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.branchOptions &&
          metaData.branchOptions.length > 0
          ? metaData.branchOptions.filter(
            (_) => _.companyId === undefined ? [] : _.companyId.toString() === record.companyId.toString()
          )
          : metaData &&
            Object.keys(metaData).length > 0 &&
            metaData.branchOptions &&
            metaData.branchOptions.length > 0
            ? metaData.branchOptions
            : []
      const serviceOptions =
        record &&
          record.companyId &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.serviceOptions &&
          metaData.serviceOptions.length > 0
          ? metaData.serviceOptions.filter((_) =>
            _.companyId.includes(record.companyId)
          )
          : metaData &&
            Object.keys(metaData).length > 0 &&
            metaData.serviceOptions &&
            metaData.serviceOptions.length > 0
            ? metaData.serviceOptions
            : []
      const subSourceOptions =
        record &&
          record.leadSourceId &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.subSourceOptions &&
          metaData.subSourceOptions.length > 0
          ? metaData.subSourceOptions.filter(
            (_) => _.sourceId.toString() === record.leadSourceId.toString()
          )
          : metaData &&
            Object.keys(metaData).length > 0 &&
            metaData.subSourceOptions &&
            metaData.subSourceOptions.length > 0
            ? metaData.subSourceOptions
            : []
      const selCountry =
        record &&
          record.country &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.countryOptions &&
          metaData.countryOptions.length > 0
          ? metaData.countryOptions.find(
            (c) => c.value !== undefined ? c.value.toString() === record.country.toString() : []
          )
          : metaData &&
            Object.keys(metaData).length > 0 &&
            metaData.countryOptions &&
            metaData.countryOptions.length > 0
          ? metaData.countryOptions
          : []
      const stateOptions =
        record &&
        record.country &&
        metaData &&
        Object.keys(metaData).length > 0 &&
        metaData.stateOptions &&
        metaData.stateOptions.length > 0
          ? metaData.stateOptions.filter(
              (c) => c.countryId !== undefined ? c.countryId.toString() === record.country.toString() : []
            )
          : metaData &&
            Object.keys(metaData).length > 0 &&
            metaData.stateOptions &&
            metaData.stateOptions.length > 0
          ? metaData.stateOptions
          : []
      const cityOptions =
        record &&
          record.state &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.cityOptions &&
          metaData.cityOptions.length > 0
          ? metaData.cityOptions.filter(
            (c) => c.stateId !== undefined ? c.stateId.toString() === record.state.toString() : []
          )
          : metaData &&
            Object.keys(metaData).length > 0 &&
            metaData.cityOptions &&
            metaData.cityOptions.length > 0
            ? metaData.cityOptions
            : []
      const customFieldOptions =
        record &&
          record.leadServiceId &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.customFieldOptions &&
          metaData.customFieldOptions.length > 0
          ? metaData.customFieldOptions.filter(
            (c) => c.serviceId.toString() === record.leadServiceId.toString()
          )
          : []
      const companyTableOptions =
        record &&
          record.companyId &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.companyTableOptions &&
          metaData.companyTableOptions.length > 0
          ? metaData.companyTableOptions.filter(
            (c) => c._id.toString() !== record.companyId.toString()
          )
          : metaData &&
            Object.keys(metaData).length > 0 &&
            metaData.serviceOptions &&
            metaData.serviceOptions.length > 0
          ? metaData.serviceOptions
          : []
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: true,
          editRecord: false,
          viewRecord: false,
          colProps: {
            lg: "6",
            md: "6",
            style: { paddingRight: "15px" },
          },
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          colProps: {
            lg: "6",
            md: "6",
            style: { paddingRight: "15px" },
          },
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          customEditBtn: ({openModal, record = {} })=> {
            const processStatus = record &&
            record.processStatus &&
            record.processStatus.processStatusId 
            return (
              <button
                onClick={openModal}
                disabled={processStatus && processStatus === "PS1" ? false : processStatus === "PS10" ? true : false}
                type="button"
                className="btn btn-success edit-table-btn"
              >
                 <i className="mdi mdi-pencil d-block font-size-16"></i>
              </button>
            )
          },
          customDeleteBtn: ({ openDialog, record = {} }) => {
            const processStatus = record &&
            record.processStatus &&
            record.processStatus.processStatusId
            const status =
              (record &&
                record.processStatus &&
                record.processStatus.processStatusName) ||
              false
            return (
              <button
                onClick={openDialog}
                disabled={status && status === "Unassigned" ? false : processStatus === "PS10" ? true : true}
                type="button"
                className="btn btn-danger delete-table-btn mx-3"
              >
                <i className="mdi mdi-trash-can d-block font-size-16"></i>
              </button>
            )
          },
          formatterStyle: { width: "100%" },
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "leadNo",
          label: "Lead No",
          placeholder: "Enter Lead No",
          sort: true,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) => {
            // console.log(row.processStatus.processStatusName, "process status")
            return (
              <div>
                <Link
                  to={{ pathname: `client-details/${row._id}`, state: { row ,mode: 'SALES', leadClientId: row} }}
                  className={row.processStatus.processStatusId === "PS1" || row.processStatus.processStatusId === "PS10" ? "disabled-button" : ""}
                  style={{ textTransform: "uppercase" }}
                >
                  {row.leadNo}
                </Link>
                {row.processStatus.processStatusId === "PS1" ?
                  <>
                    <i
                      style={{ color: "grey" }}
                      id="quoteInfo"
                      aria-hidden="true"
                      className="fa fa-info-circle ms-1"
                    ></i>
                    <UncontrolledTooltip placement="right" target="quoteInfo">
                      This lead is not yet assigned. Please change the process status, to enable the leadNo.
                    </UncontrolledTooltip>
                  </> : ""}
              </div>
            )
          },
          type: "text",
        },
        {
          id: "5",
          value: "leadType",
          label: "Lead Type",
          placeholder: "Enter Lead Type",
          sort: true,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "6",
          value: "companyId",
          label: "Company",
          placeholder: "Select Company",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          validation: true,
          colProps: {
            lg: "4",
            md: "4",
            style: {
              borderTop: "2px solid #eff2f7",
              borderLeft: "2px solid #eff2f7",
              borderTopLeftRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row) => {
            return (<span style={{textTransform: "uppercase"}}>{row.companyName}</span>)
          },
          type: "select",
          options: "companyOptions",
        },
        {
          id: "7",
          value: "branchId",
          label: "Branch",
          placeholder: "Select Branch",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          validation: true,
          disabled: record.companyId ? false : true,
          colProps: {
            lg: "4",
            md: "4",
            
            style: {
              borderTop: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row) => {
            return (<span style={{textTransform: "uppercase"}}>{row.branchName}</span>
             
            )
          },
          type: "select",
          options: branchOptions,
        },
        {
          id: "8",
          value: "leadServiceId",
          label: "Service",
          placeholder: "Select Lead Service",
          sort: true,
          editRecord: true,
          viewRecord: false,
          disabled: record.companyId ? false : true,
          required: true,
          colProps: {
            lg: "4",
            md: "4",
            style: {
              borderTop: "2px solid #eff2f7",
              borderRight: "2px solid #eff2f7",
              borderTopRightRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row) => {
            return (
            <span style={{textTransform: "uppercase"}}>{row.leadServiceName}</span>
            )
          },
          type: "select",
          options: serviceOptions,
          validation: true,
        },
        {
          id: "9",
          value: "leadSourceId",
          label: "Source",
          placeholder: "Select Lead Source",
          sort: true,
          editRecord: true,
          viewRecord: false,
          required: true,
          colProps: {
            lg: "4",
            md: "4",
            style: {
              borderLeft: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              //  paddingBottom: '0px',
            },
            className: "",
          },
          formatter: (cellContent, row) => {
            return (
              <span style={{textTransform: "uppercase"}}>{row.leadSourceName}</span>
              )
          },
          type: "select",
          options: "sourceOptions",
          validation: true,
        },
        {
          id: '10',
          value: 'leadSubSourceId',
          label: 'Sub Source',
          placeholder: 'Select Lead Sub Source',
          disabled: record.leadSourceId ? false : true,
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: '4',
            md: '4',
            style: {
              padding: '15px',
              backgroundColor: '#d3d3d321',
              paddingBottom: '0px',
            },
            className: '',
          },
          formatter: (cellContent, row) => {
            return (
              <span style={{textTransform: "uppercase"}}>{row.leadSubSourceName}</span>
              )
          },
          type: 'select',
          options: subSourceOptions,
        },
        {
          id: "11",
          value: "clientName",
          label: "Client",
          sort: true,
          editRecord: false,
          viewRecord: true,
          formatter: (cell, row) => {
            return (
              <div style={{textTransform: "uppercase"}}>{`${(row && row.clientDetails && row.clientDetails.firstName) || ""
                } ${(row && row.clientDetails && row.lastName) || ""}`}</div>
            )
          },
          type: "text",
        },
        {
          id: "12",
          value: "leadStatus",
          label: "Lead Assign",
          sort: true,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex, metaData, actions) => {
            console.log(row, "row from lead status")
            console.log(rowIndex, "rowIndex from lead status")
            const cellColorCode =
              metaData &&
              Object.keys(metaData).length > 0 &&
              metaData.processStatusOptions &&
              metaData.processStatusOptions.length > 0 &&
              metaData.processStatusOptions.find(
                (_) =>
                  row &&
                  row.processStatus &&
                  row.processStatus.processStatusId &&
                  _.value.toString() ===
                  row.processStatus.processStatusId.toString()
              ) &&
              metaData.processStatusOptions.find(
                (_) =>
                  row &&
                  row.processStatus &&
                  row.processStatus.processStatusId &&
                  _.value.toString() ===
                  row.processStatus.processStatusId.toString()
              ).colorCode
            return (
              <LeadStatus
                btnStyle={{ padding: "6px" }}
                colorCode={cellColorCode}
                cellContent={cellContent}
                row={row}
                rowIndex={rowIndex}
                metaData={metaData}
                actions={actions}
              />
            )
          },
          type: "text",
        },
        {
          id: "13",
          value: "salesUrge",
          label: "Sales Urge",
          placeholder: "Select Sales Urge",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          //  width: 80,
          colProps: {
            lg: "4",
            md: "4",
            style: {
              padding: "15px",
              backgroundColor: "#d3d3d321",
              //  paddingBottom: '0px',
            },
            className: "",
          },
          formatter: (val) => (
            <div style={{ display: "flex", flexWrap: "wrap", textTransform: "uppercase" }}>{val}</div>
          ),
          type: "select",
          options: [
            {
              label: "hot",
              value: "hot",
            },
            {
              label: "warm",
              value: "warm",
            },
            {
              label: "cold",
              value: "cold",
            },
          ],
        },
        {
          id: "14",
          value: "clientProfile",
          label: "Client Profile",
          placeholder: "Select Client Profile",
          sort: true,
          editRecord: true,
          viewRecord: true,
          colProps: {
            lg: "4",
            md: "4",
            style: {
              borderLeft: '2px solid #eff2f7',
              borderBottom: '2px solid #eff2f7',
              borderBottomLeftRadius: '6px',
              padding: '15px',
              backgroundColor: '#d3d3d321',
            },
          },
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.clientProfileOptions &&
                metaData.clientProfileOptions.length > 0 &&
                metaData.clientProfileOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.clientProfileOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: "clientProfileOptions",
        },
        {
           id: '15',
           value: 'clientProfileRemarks',
           label: 'Client Profile Remarks',
           placeholder: 'Enter Client Profile Remarks',
           sort: true,
           editRecord: true,
           viewRecord: false,
           colProps: {
             lg: '4',
             md: '4',
             style: {
               borderBottom: '2px solid #eff2f7',
               padding: '15px',
               backgroundColor: '#d3d3d321',
             },
             className: "employee-input"
           },
           type: 'text',
         },
         {
           id: '16',
           value: 'attachment',
           label: 'Media Attachment',
           placeholder: 'Choose Media Attachment',
           sort: true,
           editRecord: true,
           viewRecord: false,
           colProps: {
             lg: '4',
             md: '4',
             style: {
               borderBottom: '2px solid #eff2f7',
               borderRight: '2px solid #eff2f7',
               borderBottomRightRadius: '6px',
               padding: '15px',
               backgroundColor: '#d3d3d321',
             },
           },
          type: "upload",
        },
        {
          id: "17",
          value: "firstName",
          label: "First Name",
          placeholder: "Enter First Name",
          sort: true,
          editRecord: true,
          viewRecord: false,
          required: true,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderTop: "2px solid #eff2f7",
              borderLeft: "2px solid #eff2f7",
              borderTopLeftRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          type: "textOnly",
          validations: "textOnly"
        },
        {
          id: "18",
          value: "lastName",
          label: "Last Name",
          placeholder: "Enter Last Name",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderTop: "2px solid #eff2f7",
              borderRight: "2px solid #eff2f7",
              borderTopRightRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              width: "24%",
              marginRight: "auto",
              paddingBottom: "0px",
            },
            className: "",
          },
          type: "textOnly",
          validations: "textOnly"
        },
        {
          id: "19",
          value: "clientLocation",
          label: "Client Location",
          placeholder: "Enter Client Location",
          sort: true,
         // required:true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderTop: "2px solid #eff2f7",
              borderLeft: "2px solid #eff2f7",
              borderTopLeftRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          type: "textOnly",
          validations: "textOnly"
        },
        {
          id: "20",
          value: "primaryMobile",
          label: "Primary No",
          placeholder: "Enter Primary No",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          onInputChange: ({ inputValue, setFieldValue }) => {
            const obj = inputValue.val
            // const value = inputValue.val&& inputValue.val.length ===12 ? inputValue.val.slice(2):inputValue.val.length ===11 ? inputValue.val.slice(1):inputValue.val.length ===10 ? inputValue.val.slice(2):inputValue.val.length ===14 ? inputValue.val.slice(2):inputValue.val.length ===15 ? inputValue.val.slice(3): ""
            console.log(obj, "Response")
            api
              .post("/get_client", {
                status: "active",
                id: "",
                mobileNo: obj ? "+" + obj : [],
              })
              .then((res) => {
                console.log(res, "response")
                if (
                  res &&
                  res.data &&
                  res.data.data &&
                  res.data.data.length > 0
                ) {
                  setFieldValue("primaryMobileConfirm", true)
                  setFieldValue(
                    "clientId",
                    res.data.data && res.data.data[0] && res.data.data[0]._id
                  )
                } else {
                  setFieldValue("primaryMobileConfirm", false)
                }
              })
              .catch(() => {
                setFieldValue("primaryMobileConfirm", false)
              })
          },
          prefix: ({ setFieldValue }) => {
            return (
              <div
                style={{ display: "flex", alignItems: "center", width: "32px" }}
              >
                <input
                  type="checkbox"
                  id="check1"
                  onClick={(e) =>{
                    if(  e.target.checked){
                      setFieldValue("whatsAppNo", record.primaryMobile)
                      document.getElementById('check2').checked=false
                    }
                  else{
                    setFieldValue("whatsAppNo","")
                  }}
                   
                }
              
                ></input>
              </div>
            )
          },
          defaultCountry: (selCountry && selCountry.shortName) || "IN",
          //defaultValue: record && record.primaryMobile && record.primaryMobile.toString() && `+${record.primaryMobile.toString()}` || '',
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderTop: "2px solid #eff2f7",
              borderRight: "2px solid #eff2f7",
              borderTopRightRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          type: "phone",
          validations: "phone",
        },
        {
          id: "21",
          value: "country",
          label: "Country",
          placeholder: "Enter Country",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderLeft: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.countryOptions &&
                metaData.countryOptions.length > 0 &&
                metaData.countryOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.countryOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: "countryOptions",
        },
        {
          id: "22",
          value: "state",
          label: "State",
          placeholder: "Enter State",
          sort: true,
          editRecord: true,
          disabled: record.country ? false : true,
          viewRecord: false,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderRight: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              width: "24%",
              marginRight: "auto",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.stateOptions &&
                metaData.stateOptions.length > 0 &&
                metaData.stateOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.stateOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: stateOptions,
        },
        {
          id: "23",
          value: "secondaryMobile",
          label: "Secondary No",
          placeholder: "Enter Secondary No",
          sort: true,
          editRecord: true,
          viewRecord: false,
          onInputChange: ({ inputValue, setFieldValue }) => {
            const obj = inputValue.val
            console.log(obj, "Response")
            api
              .post("/get_client", {
                status: "active",
                id: "",
                mobileNo: obj ? obj : [],
              })
              .then((res) => {
                if (
                  res &&
                  res.data &&
                  res.data.data &&
                  res.data.data.length > 0
                ) {
                  setFieldValue("secondaryMobileConfirm", true)
                  setFieldValue(
                    "clientId",
                    res.data.data && res.data.data[0] && res.data.data[0]._id
                  )
                } else {
                  setFieldValue("secondaryMobileConfirm", false)
                }
              })
              .catch(() => {
                setFieldValue("secondaryMobileConfirm", false)
              })
          },
          prefix: ({ setFieldValue }) => {
            return (
              <div
                style={{ display: "flex", alignItems: "center", width: "32px" }}
             >
                <input
                  type="checkbox"
                  id="check2"
                  onChange={(e) =>{
                    if( e.target.checked){
                      setFieldValue("whatsAppNo", record.secondaryMobile)
                      document.getElementById('check1').checked=false
                    }
                  else{
                    setFieldValue("whatsAppNo", "")
                  }}
                   
                  }
                 // checked={checked}
                ></input>
              </div>
            )
          },
          defaultCountry: (selCountry && selCountry.shortName) || "IN",
          //defaultValue: record && record.secondaryMobile && record.secondaryMobile.toString() && `+${record.secondaryMobile.toString()}` || '',
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderLeft: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          type: "phone",
        },

        {
          id: "24",
          value: "whatsAppNo",
          label: "Whats App No",
          placeholder: "Enter Whats App No",
          sort: true,
          editRecord: true,
          viewRecord: false,
          required: true,
          defaultCountry: (selCountry && selCountry.shortName) || "IN",
          //defaultValue: record && record.whatsAppNo && record.whatsAppNo.toString() && `+${record.whatsAppNo.toString()}` || '',
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderRight: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          onInputChange: ({ inputValue, setFieldValue }) => {
            const obj = inputValue.val
            console.log(obj, "Response")
            api
              .post("/get_client", {
                status: "active",
                id: "",
                mobileNo: obj ? obj : [],
              })
              .then((res) => {
                if (
                  res &&
                  res.data &&
                  res.data.data &&
                  res.data.data.length > 0
                ) {
                  setFieldValue("whatsAppNoConfirm", true)
                  setFieldValue(
                    "clientId",
                    res.data.data && res.data.data[0] && res.data.data[0]._id
                  )
                } else {
                  setFieldValue("whatsAppNoConfirm", false)
                }
              })
              .catch(() => {
                setFieldValue("whatsAppNoConfirm", false)
              })
          },
          type: "phone",
          validations: "phone",
        },
        {
          id: "25",
          value: "city",
          label: "City",
          placeholder: "Enter City",
          sort: true,
          editRecord: true,
          disabled: record.state ? false : true,
          viewRecord: false,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderLeft: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.cityOptions &&
                metaData.cityOptions.length > 0 &&
                metaData.cityOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.cityOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: cityOptions,
        },
        {
          id: "26",
          value: "pincode",
          label: "Pincode",
          placeholder: "Enter Pincode",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderRight: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              width: "24%",
              marginRight: "auto",
              paddingBottom: "0px",
            },
            className: "employee-input",
          },
          type: "zipCode",
          validations: "zipCode"
        },
        {
          id: "27",
          value: "emailId",
          label: "Email ID",
          placeholder: "Enter Email ID",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderLeft: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          type: "email",
        },
        {
          id: "28",
          value: "priorityStatusId",
          label: "Priority Status",
          placeholder: "Select Priority Status",
          sort: true,
          editRecord: true,
          viewRecord: false,
          required: true,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderRight: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.priorityStatusOptions &&
                metaData.priorityStatusOptions.length > 0 &&
                metaData.priorityStatusOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.priorityStatusOptions.find(
                  (_) => cellContent === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: "priorityStatusOptions",
        },
        {
          id: "29",
          value: "primaryAddress",
          label: "Address",
          placeholder: "Enter Address",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "6",
            md: "6",
            style: {
              borderLeft: "2px solid #eff2f7",
              borderRight: "2px solid #eff2f7",
              borderBottom: "2px solid #eff2f7",
              borderBottomLeftRadius: "6px",
              borderBottomRightRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              width: "49%",
              marginRight: "auto",
            },
          },
          type: "textarea",
        },
        {
          id: "30",
          value: "descriptions",
          label: "Remarks",
          placeholder: "Enter Remarks",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "6",
            md: "6",
            style: {
              borderLeft: "2px solid #eff2f7",
              borderRight: "2px solid #eff2f7",
              borderBottom: "2px solid #eff2f7",
              borderBottomLeftRadius: "6px",
              borderBottomRightRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
            },
          },
          type: "textarea",
        },
        {
          id: "31",
          value: "crossPromotion",
          label: "Cross Promotions",
          placeholder: "Select Cross Promotions",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "6",
            md: "6",
            style: {
              border: "2px solid #eff2f7",
              borderRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              width: "49%",
              marginRight: "auto",
              paddingBottom: "0px",
            },
          },
          type: "table",
          labelStyle: {
            fontSize: "18px",
            textTransform: "uppercase",
          },
          formatter: () => {
            return <div>NA</div>
          },
          tableColumns: [
            {
              dataField: "name",
              text: "Company Name",
            },
            {
              dataField: "action",
              text: "Action",
              formatter: (value, onChange, fieldValues, row) => {
                const options = [
                  {
                    label: "Yes",
                    value: true,
                  },
                  {
                    label: "No",
                    value: false,
                  },
                ]
                return (
                  <React.Fragment>
                    <FormGroup className="mb-3">
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          flexWrap: "wrap",
                        }}
                      >
                        {(options || []).map((opt, index) => {
                         return (
                            <div
                              key={index}
                              className="form-check"
                              style={{ marginRight: "15px" }}
                            >
                              <input
                                className="form-check-input"
                                type="radio"
                                name={row._id}
                                id={`${row._id}-${opt.value}`}
                                value={opt.value}
                                onChange={() => {
                                  const isExist =
                                    fieldValues.find(
                                      (a) =>
                                        a &&
                                        row &&
                                        a.companyId &&
                                        row._id &&
                                        a.companyId.toString() ===
                                        row._id.toString()
                                    ) || false

                                  if (isExist) {
                                    onChange({
                                      target: {
                                        value: fieldValues.filter(_=> _.status === 1).map((el) =>
                                          el.companyId.toString() ===
                                            row._id.toString()
                                            ? Object.assign({}, el, {
                                              action: opt.value,
                                            })
                                            : el
                                        ),
                                      },
                                    })
                                  } else {
                                    onChange({
                                      target: {
                                        value: [
                                          ...fieldValues,
                                          Object.assign(
                                            {},
                                            {
                                              companyId: row._id,
                                              action: opt.value,
                                            }
                                          ),
                                        ],
                                      },
                                    })
                                  }
                                }}
                                checked={value === opt.value ? true : false}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`${row._id}-${opt.value}`}
                              >
                                {" "}
                                {opt.label}
                              </label>
                            </div>
                          )
                        })}
                      </div>
                    </FormGroup>
                  </React.Fragment>
                )
              },
            },
          ],
          options: companyTableOptions,
        },
        {
          id: "33",
          value: "isSelfAssign",
          label: "Self Assign",
          sort: true,
          editRecord: true,
          viewRecord: false,
          type: "checkbox",
          labelStyle: {
            fontSize: "12px",
            textTransform: "uppercase",
          },
          colProps: {
            lg: "6",
            md: "6",
            style: {
              border: "2px solid #eff2f7",
              borderRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
              height: "10%",
              fontSize: "14px"
            },
          },
          // options: [{label: "YES", value: true}, {label: "NO", value: false}]
        },
        {
          id: "32",
          value: "customField",
          label: "Custom Field",
          placeholder: "Select Custom Field",
          sort: true,
          editRecord:
            customFieldOptions && customFieldOptions.length > 0 ? true : false,
          viewRecord: false,
          labelStyle: {
            fontSize: "18px",
            textTransform: "uppercase",
          },
          colProps: {
            lg: "6",
            md: "6",
            style: {
              border: "2px solid #eff2f7",
              borderRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
              height: "90%"
            },
            className: "custom-field-style"
          },
          formatter: () => {
            return <div>NA</div>
          },
          type: "custom",
          options: customFieldOptions,
        },

        {
          id: "34",
          value:  "agingDate",
          label: "Aging/Re-assigning",
          headerStyle: {
            minWidth: "230px"
          },
          sort: true,
          editRecord: false,
          viewRecord: true,
           formatter: (cellContent, row) => {

            return (row && (row.leadAge) && (row.reassignAge)?`${row.leadAge}/${row.reassignAge} days`:"" ) || ""
          },
          type: "date",
        },
        {
          id: "34",
          value: "salesAgent",
          label: "Sales Agent Name",
          sort: true,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex, metaData) => {
            const agentDetails =
              row &&
                row.leadAssign &&
                Array.isArray(row.leadAssign) &&
                row.leadAssign.length > 0 &&
                metaData &&
                metaData.employeeListOptions &&
                metaData.employeeListOptions.length > 0
                ? metaData.employeeListOptions.find(
                  (k) =>
                    row.leadAssign[row.leadAssign.length - 1] &&
                    row.leadAssign[row.leadAssign.length - 1].assignedTo &&
                    k.value.toString() ===
                    row.leadAssign[
                      row.leadAssign.length - 1
                    ].assignedTo.toString()
                )
                : false
            return <div style={{textTransform: "uppercase"}}>{(agentDetails && agentDetails.name) || ""}</div>
          },
          type: "text",
          validations: "textOnly"
        },
        {
          id: "35",
          value: "budget",
          label: "Budget",
          sort: true,
          editRecord: false,
          viewRecord: true,
          type: "text",
        },
        {
          id: "36",
          value: "leadSourceId",
          label: "Lead Source",
          sort: true,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.sourceOptions &&
                metaData.sourceOptions.length > 0 &&
                metaData.sourceOptions.find(
                  (_) => cellContent === _.value.toString()
                ) &&
                metaData.sourceOptions.find(
                  (_) => cellContent === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "text",
        },
        {
          id: "37",
          value: "insertedBy",
          label: "Created By",
          sort: true,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) => {
            return (row && row.insertedBy && row.insertedBy.name) || ""
          },
          type: "text",
        },
        {
          id: "38",
          value: "leadDate",
          label: "Lead Date",
          sort: true,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) => {

            return (row && (row.leadDate)) || ""
          },
          type: "date",
        },
        {
          id: "39",
          value: "leadStatus",
          label: "Lead Status",
          sort: true,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex, metaData) => {
            const cellColorCode =
              metaData &&
              Object.keys(metaData).length > 0 &&
              metaData.processStatusOptions &&
              metaData.processStatusOptions.length > 0 &&
              metaData.processStatusOptions.find(
                (_) =>
                  row &&
                  row.processStatus &&
                  row.processStatus.processStatusId &&
                  _.value.toString() ===
                  row.processStatus.processStatusId.toString()
              ) &&
              metaData.processStatusOptions.find(
                (_) =>
                  row &&
                  row.processStatus &&
                  row.processStatus.processStatusId &&
                  _.value.toString() ===
                  row.processStatus.processStatusId.toString()
              ).colorCode
            return (
              <Badge
                className={`font-size-12`}
                style={{
                  backgroundColor: cellColorCode || "#34c38f",
                  padding: "4px",
                }}
                color={cellColorCode}
              >
                {(row &&
                  row.processStatus &&
                  row.processStatus.processStatusName) ||
                  ""}
              </Badge>
            )
          },
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "b8a14fb3",
    name: "mylead",
    title: "New Lead",
    formTitle: "New Lead",
    path: "/new-my-lead",
    visible: true,
    ...b8a14fb3,
    page: "MyLead",
    className: "lead-counter",
    enableTableFilter: true,
    grid: [
      {
        id: 1,
        component: LeadHeader,
      },
      {
        id: 2,
        component: "Counter",
        onLoad: async (filterData) => {
          return await api
            .post("/get_lead_count_by_status_new", filterData)
            .then((response) => response.data && response.data.data)
            .catch((error) => Promise.reject(error))
        },
        columns: () => [
          {
            id: "2",
            filterId: "PS2",
            value: "openLeads",
            label: "Unactioned",
            customLabel: "Unactioned - Today’s | MTD | Overall",
            editRecord: false,
            viewRecord: true,
            getValues: (records) => {
              return (records || [])
                .filter(
                  (s) =>
                    s._id &&
                    s._id.processStatusId &&
                    s._id.processStatusId === "PS2"
                )
                .reduce(
                  (a, el) =>
                    Object.assign({}, a, {
                      monthTillDate:
                        parseInt(a.monthTillDate) + parseInt(el.monthTillDate),
                      todayLead: parseInt(a.todayLead) + parseInt(el.todayLead),
                      totalLead: parseInt(a.totalLead) + parseInt(el.totalLead),
                    }),
                  { todayLead: 0, monthTillDate: 0, totalLead: 0 }
                )
            },
            cardStyle: {
              backgroundColor: "#F1B54C",
              marginBottom: "0px",
              display: "inline-block",
              width: "100%",
            },
            type: "text",
          },
          {
            id: "2",
            filterId: "PS16",
            value: "UnactionedFolowup",
            label: "Unactioned Follow -ups",
            customLabel: "Unactioned Follow -ups - Today / MTD",
            editRecord: false,
            viewRecord: true,
            getValues: (records) => {
              return (records || [])
                .filter(
                  (s) =>
                    s._id &&
                    s._id.processStatus &&
                    s._id.processStatusId === "PS16"
                )
                .reduce(
                  (a, el) =>
                    Object.assign({}, a, {
                      monthTillDate:
                        parseInt(a.monthTillDate) + parseInt(el.monthTillDate),
                      todayLead: parseInt(a.todayLead) + parseInt(el.todayLead),
                    }),
                  { todayLead: 0, monthTillDate: 0 }
                )
            },
            colProps: {
              style: { width: "20%" },
            },
            cardStyle: {
              backgroundColor: "#50A5F0",
              marginBottom: "0px",
              display: "inline-block",
              width: "100%",
            },
            type: "text",
          },
          {
            id: "3",
            filterId: "PS3",
            value: "convertedLeads",
            label: "Conversions",
            customLabel: "Conversions - Today’s | MTD | Overall",
            editRecord: false,
            viewRecord: true,
            getValues: (records) => {
              return (records || [])
                .filter(
                  (s) =>
                    s._id &&
                    s._id.processStatusId &&
                    s._id.processStatusId === "PS3"
                )
                .reduce(
                  (a, el) =>
                    Object.assign({}, a, {
                      monthTillDate:
                        parseInt(a.monthTillDate) + parseInt(el.monthTillDate),
                      todayLead: parseInt(a.todayLead) + parseInt(el.todayLead),
                      totalLead: parseInt(a.totalLead) + parseInt(el.totalLead),
                    }),
                  { todayLead: 0, monthTillDate: 0, totalLead: 0 }
                )
            },
            cardStyle: {
              backgroundColor: "#34C28F",
              marginBottom: "0px",
              display: "inline-block",
              width: "100%",
            },
            type: "text",
          },
          {
            id: "4",
            filterId: "PS32",
            value: "performance",
            label: "Performance",
            customLabel: "Performance - Current RR / Required RR",
            editRecord: false,
            viewRecord: true,
            getValues: (records) => {
              return (records || [])
                .filter(
                  (s) =>
                    s._id &&
                    s._id.processStatus &&
                    s._id.processStatusId === "PS32"
                )
                .reduce(
                  (a, el) =>
                    Object.assign({}, a, {
                      monthTillDate:
                        parseInt(a.monthTillDate) + parseInt(el.monthTillDate),
                      todayLead: parseInt(a.todayLead) + parseInt(el.todayLead),
                    }),
                  { todayLead: 0, monthTillDate: 0 }
                )
            },
            colProps: {
              style: { width: "20%" },
            },
            cardStyle: {
              backgroundColor: "#353A40",
              marginBottom: "0px",
              display: "inline-block",
              width: "100%",
            },
            type: "text",
          },
          {
            id: "4",
            filterId: "PS10",
            value: "rejectedLeads",
            label: "Rejected",
            customLabel: "Rejected - Today’s | MTD | Overall",
            editRecord: false,
            viewRecord: true,
            getValues: (records) => {
              return (records || [])
                .filter(
                  (s) =>
                    s._id &&
                    s._id.processStatusId &&
                    s._id.processStatusId === "PS10"
                )
                .reduce(
                  (a, el) =>
                    Object.assign({}, a, {
                      monthTillDate:
                        parseInt(a.monthTillDate) + parseInt(el.monthTillDate),
                      todayLead: parseInt(a.todayLead) + parseInt(el.todayLead),
                      totalLead: parseInt(a.totalLead) + parseInt(el.totalLead),
                    }),
                  { todayLead: 0, monthTillDate: 0, totalLead: 0 }
                )
            },
            cardStyle: {
              backgroundColor: "#F46969",
              marginBottom: "0px",
              display: "inline-block",
              width: "100%",
            },
            type: "text",
          },
        ],
      },
      {
        id: 3,
        component: "DynamicFilter",
        onSubmit: ({ dispatch, actions,submitData, setSubmitting }) => {

          console.log("submitDatga f", submitData)

          dispatch(
            actions.loadRecords(
              Object.assign({}, submitData, { status: "active" }),
              true
            )
          )
          setTimeout(() => {
            setSubmitting(false)
          }, 3000)
        },
        
        initialValues: {
          status: "active",
          id: "",
          mobileNo: "",
          leadType: "",
          companyId: "",
          branchId: "",
          priorityStatusId: "",
          processStatusId: "",
          leadServiceId: "",
          leadSourceId: "",
          leadSubSourceId: "",
          employeeId: "",
        },
        columns: (record = {}, metaData) => {
          const branchOptions =
            record &&
              record.companyId &&
              metaData &&
              Object.keys(metaData).length > 0 &&
              metaData.branchOptions &&
              metaData.branchOptions.length > 0
              ? metaData.branchOptions.filter(
                (_) => _.companyId.toString() === record.companyId.toString()
              )
              : metaData &&
                Object.keys(metaData).length > 0 &&
                metaData.branchOptions &&
                metaData.branchOptions.length > 0
                ? metaData.branchOptions
                : []
                console.log(branchOptions, "branchOptions")

          return [
            {
              id: "1",
              value: "_id",
              label: "Id",
              editRecord: false,
              viewRecord: false,
              type: "text",
            },
            {
              id: "2",
               value: "companyId",
              label: "Company",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "multiSelect",
               options: "companyOptions",
            },
            {
              id: "3",
              value: "branchId",
              label: "Branch",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "multiSelect",
              options: branchOptions,
            },
            {
              id: "4",
              value: "salesUrge",
              label: "Sales Urge",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "select",
              options: [
                {
                  label: "hot",
                  value: "hot",
                },
                {
                  label: "warm",
                  value: "warm",
                },
                {
                  label: "cold",
                  value: "cold",
                },
              ],
            },
            {
              id: "5",
              value: "leadSourceId",
              label: "Source",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "select",
              options: "sourceOptions",
            },
            {
              id: "6",
              value: "leadStatus",
              label: "Lead Status",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "select",
              options: "processStatusOptions",
            },
            {
              id: "10",
              value: "leadNo",
              label: "Lead No",
              editRecord: true,
              viewRecord: false,
              placeholder: "Enter Lead No",
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "text",
            },
            {
              id: "7",
              value: "leadFromDate",
              label: "Lead From Date",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "date",
            },
            {
              id: "8",
              value: "leadToDate",
              label: "Lead To Date",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "date",
            },
            {
              id: "13",
              value: "employeeId",
              label: "Sales Agent",
              editRecord: true,
              viewRecord: false,
              placeholder: "Enter Sales Agent",
              colProps: {
                lg: "3",
                md: "6",
                className: "multiselect-field",
                style: { fontSize: "11px",}
            },
            type: 'autocomplete',
            fuseOptions: { keys: ['empCode', 'name']},
            options: 'employeeListOptions'
            },
            {
              id: "9",
              value: "status",
              label: "Status",
              editRecord: false,
              viewRecord: false,
              type: "text",
            },
            {
              id: "10",
              value: "saleStatus",
              label: "Sale Status",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "select",
              options: [],
            },
            {
              id: "11",
              value: "budget",
              label: "Budget",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "select",
              options: [],
            },
          ]
        },
      },
    ],
    submitButton: ({
      values,
      setFieldValue,
      handleSubmit,
      submitBtnText,
      isSubmitting,
    }) => {
      console.log(values, "values")
      return values &&
        (values.primaryMobileConfirm ||
          values.secondaryMobileConfirm ||
          values.whatsAppNoConfirm) ? (
        <ConfirmButton
          body={
            "This lead already exists, would you like to create this lead under the existing lead?"
          }
          closeBtnText="No"
          confirmBtnText="Yes"
          disableCloseBtn
          buttonLayout={({ updateState }) => {
            return (
              <React.Fragment>
                <button
                  type="button"
                  style={{ height: "46px" }}
                  className="btn btn-primary"
                  onClick={() => {
                    updateState({ openDialog: false })
                  }}
                >
                  {"Cancel"}
                </button>
                <button
                  type="button"
                  style={{ height: "46px" }}
                  className="btn btn-light"
                  onClick={() => {
                    updateState({ openDialog: false })
                    setFieldValue("isRequiredNewClientEntry", true)
                    // setFieldValue("clientId", "")
                    // handleSubmit()
                  }}
                >
                  {"No"}
                </button>
                <button
                  type="button"
                  style={{ height: "46px" }}
                  className="btn btn-primary"
                  onClick={() => {
                    updateState({ openDialog: false })
                    setFieldValue("isRequiredNewClientEntry", false)
                    handleSubmit()
                  }}
                >
                  {"Yes"}
                </button>
              </React.Fragment>
            )
          }}
        >
          {(open) => (
            <button
              key={"showConfirm"}
              id="showConfirm"
              disabled={isSubmitting}
              type="button"
              onClick={open}
              className="btn btn-success btn-label simple-form-submit-btn"
            >
              <i className="bx bx-check-double label-icon"></i>
              {isSubmitting ? <ButtonSpinner /> : submitBtnText || "Submit"}
            </button>
          )}
        </ConfirmButton>
      ) : (
        <button
          type="submit"
          disabled={isSubmitting}
          onClick={() => handleSubmit()}
          className="btn btn-success btn-label simple-form-submit-btn"
        >
          <i className="bx bx-check-double label-icon"></i>
          {isSubmitting ? <ButtonSpinner /> : submitBtnText || "Submit"}
        </button>
      )
    },
    onSubmitValues: (data, record = {},metaData) => {
      console.log(record, "metaData sss from manage lead")
      console.log(metaData,"my meta")
      console.log(data,"my data")
      var today = new Date()
      const time = today.getFullYear() + '-' +
        ((today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1)) + '-' +
        (today.getDate() < 10 ? '0' + today.getDate() : today.getDate()) + ' ' +
        (today.getHours()) + ':' +
        (today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()) + ':' +
        (today.getSeconds() < 10 ? '0' + today.getSeconds() : today.getSeconds())
      console.log(time, "time")
      const status =
        (record &&
          record.processStatus &&
          record.processStatus.processStatus)
      console.log(status)
      const modifyData = data
      modifyData.leadType = "wedding"
      modifyData.companyId = data.companyId || ""
      // modifyData.companyName = data.companyId.label || ""
      modifyData.branchId = data.branchId || ""
      modifyData.leadSourceId = data.leadSourceId || ""
      modifyData.leadSubSourceId = "" || data.leadSubSourceId
      modifyData.leadServiceId = data.leadServiceId || ""
      modifyData.eventId = "61f0149ed6a0f0d4716e2b9b"
      modifyData.descriptions = data.descriptions || ""
      modifyData.customField = data.customField || []
      modifyData.priorityStatusId = data.priorityStatusId || ""
      modifyData.processStatus = {
        id: "620be8a53f52687300b1f3fe",
        statusName: "open",
      }
      modifyData.crossPromotion = data.crossPromotion || []
      modifyData.isRequiredNewClientEntry =
        data.isRequiredNewClientEntry === undefined
          ? true
          : data.isRequiredNewClientEntry || false
     modifyData.leadNo = data.leadNo || "",
      modifyData.leadDate = time || ""
      modifyData.clientDetails = {
        firstName: data.firstName || "",
        lastName: data.lastName || "",
        contact: {
          primaryMobile: {
            // code: data.primaryMobile && data.primaryMobile inputValue.data.dialCode,
            //code:  data.primaryMobile.substr(-10),
            // number:  data.primaryMobile,
            code :data.primaryMobile&& data.primaryMobile.length === 10 ? "+"+data.primaryMobile.slice(0,-8):data.primaryMobile.length === 12 ? "+"+data.primaryMobile.slice(0,-10):data.whatsAppNo.length === 11 ? "+"+data.primaryMobile.slice(0,-10):data.primaryMobile.length === 14 ? "+"+data.primaryMobile.slice(0,-12):data.primaryMobile.length === 15 ? "+"+data.primaryMobile.slice(0,-12):"",
             number:  data.primaryMobile&& data.primaryMobile.length ===12 ? data.primaryMobile.slice(2):data.primaryMobile.length ===11 ? data.primaryMobile.slice(1):data.whatsAppNo.length ===10 ? data.primaryMobile.slice(2):data.primaryMobile.length ===14 ? data.primaryMobile.slice(2):data.primaryMobile.length ===15 ? data.primaryMobile.slice(3): "",
           }, 
          
           secondaryMobile: "" || {
             code :data.secondaryMobile&& data.secondaryMobile.length === 10 ? "+"+data.secondaryMobile.slice(0,-8):data.secondaryMobile.length === 12 ? "+"+data.secondaryMobile.slice(0,-10):data.secondaryMobile.length === 11 ? "+"+data.secondaryMobile.slice(0,-10):data.secondaryMobile.length === 14 ? "+"+data.secondaryMobile.slice(0,-12):data.secondaryMobile.length === 15 ? "+"+data.secondaryMobile.slice(0,-12):"",
              //code :data.secondaryMobile&& data.secondaryMobile.length > 10 ? data.secondaryMobile.slice(0,-11):data.secondaryMobile.slice(0,-10),
             //code: "" || data.secondaryMobile !== "undefined" ? data.secondaryMobile.slice(0,-10) : "",
             number:  data.secondaryMobile&& data.secondaryMobile.length ===12 ? data.secondaryMobile.slice(2):data.secondaryMobile.length ===11 ? data.secondaryMobile.slice(1):data.secondaryMobile.length ===10 ? data.secondaryMobile.slice(2):data.secondaryMobile.length ===14 ? data.secondaryMobile.slice(2):data.secondaryMobile.length ===15 ? data.secondaryMobile.slice(3): "",
 
     
            },
           whatsAppNo: {
            
              code :data.whatsAppNo&& data.whatsAppNo.length === 10 ? "+"+data.whatsAppNo.slice(0,-8):data.whatsAppNo.length === 12 ? "+"+data.whatsAppNo.slice(0,-10):data.whatsAppNo.length === 11 ? "+"+data.whatsAppNo.slice(0,-10):data.whatsAppNo.length === 14 ? "+"+data.whatsAppNo.slice(0,-12):data.secondaryMobile.length === 15 ? "+"+data.whatsAppNo.slice(0,-12):"",
             number:data.whatsAppNo&& data.whatsAppNo.length ===12 ? data.whatsAppNo.slice(2):data.whatsAppNo.length ===11 ? data.whatsAppNo.slice(1):data.whatsAppNo.length ===10 ? data.whatsAppNo.slice(2):data.whatsAppNo.length ===14 ? data.whatsAppNo.slice(2):data.whatsAppNo.length ===15 ? data.whatsAppNo.slice(3): "",
         },
        },
        clientLocation: data.clientLocation || "",
        emailId: data.emailId || "",
        address: {
          primary: data.primaryAddress || "",
          secondary: data.primaryAddress || "",
        },
        city: "" || data.city,
        state: "" || data.state,
        country: "" || data.country,
        pincode: data.pincode || "",
      }
      modifyData.clientProfileRemarks = data.clientProfileRemarks || ""
      modifyData.clientProfile = data.clientProfile || ""
      modifyData.isSelfAssign = "" || data.isSelfAssign ? true : false
      modifyData.salesUrge = data.salesUrge || ""
      modifyData.clientId = data.clientId || ""
      modifyData.attachment = data.attachment || ""
      return modifyData
    },
    exact: true,
    initialValues:{
    companyId:"",
    branchId:"",
    leadServiceId:"",
    leadSourceId:"",
    firstName:"",
    saleSurge:"",
    clientProfile:"",
    primaryMobile:"",
    secondaryMobile:"",
    whatsAppNo:"",
    priorityStatusId:""

    }
    ,
    columns: (record = {}, metaData) => {

      // console.log(metaData, "records from api manage lead")
      const branchOptions =
        record &&
          record.companyId &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.branchOptions &&
          metaData.branchOptions.length > 0
          ? metaData.branchOptions.filter(
            (_) => _.companyId === undefined ? [] : _.companyId.toString() === record.companyId.toString()
          )
          : metaData &&
            Object.keys(metaData).length > 0 &&
            metaData.branchOptions &&
            metaData.branchOptions.length > 0
            ? metaData.branchOptions
            : []
      const serviceOptions =
        record &&
          record.companyId &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.serviceOptions &&
          metaData.serviceOptions.length > 0
          ? metaData.serviceOptions.filter((_) =>
            _.companyId.includes(record.companyId)
          )
          : metaData &&
            Object.keys(metaData).length > 0 &&
            metaData.serviceOptions &&
            metaData.serviceOptions.length > 0
            ? metaData.serviceOptions
            : []
      const subSourceOptions =
        record &&
          record.leadSourceId &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.subSourceOptions &&
          metaData.subSourceOptions.length > 0
          ? metaData.subSourceOptions.filter(
            (_) => _.sourceId.toString() === record.leadSourceId.toString()
          )
          : metaData &&
            Object.keys(metaData).length > 0 &&
            metaData.subSourceOptions &&
            metaData.subSourceOptions.length > 0
            ? metaData.subSourceOptions
            : []
      const selCountry =
        record &&
          record.country &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.countryOptions &&
          metaData.countryOptions.length > 0
          ? metaData.countryOptions.find(
            (c) => c.value !== undefined ? c.value.toString() === record.country.toString() : []
          )
          : metaData &&
            Object.keys(metaData).length > 0 &&
            metaData.countryOptions &&
            metaData.countryOptions.length > 0
          ? metaData.countryOptions
          : []
      const stateOptions =
        record &&
        record.country &&
        metaData &&
        Object.keys(metaData).length > 0 &&
        metaData.stateOptions &&
        metaData.stateOptions.length > 0
          ? metaData.stateOptions.filter(
              (c) => c.countryId !== undefined ? c.countryId.toString() === record.country.toString() : []
            )
          : metaData &&
            Object.keys(metaData).length > 0 &&
            metaData.stateOptions &&
            metaData.stateOptions.length > 0
          ? metaData.stateOptions
          : []
      const cityOptions =
        record &&
          record.state &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.cityOptions &&
          metaData.cityOptions.length > 0
          ? metaData.cityOptions.filter(
            (c) => c.stateId !== undefined ? c.stateId.toString() === record.state.toString() : []
          )
          : metaData &&
            Object.keys(metaData).length > 0 &&
            metaData.cityOptions &&
            metaData.cityOptions.length > 0
            ? metaData.cityOptions
            : []
      const customFieldOptions =
        record &&
          record.leadServiceId &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.customFieldOptions &&
          metaData.customFieldOptions.length > 0
          ? metaData.customFieldOptions.filter(
            (c) => c.serviceId.toString() === record.leadServiceId.toString()
          )
          : []
      const companyTableOptions =
        record &&
          record.companyId &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.companyTableOptions &&
          metaData.companyTableOptions.length > 0
          ? metaData.companyTableOptions.filter(
            (c) => c._id.toString() !== record.companyId.toString()
          )
          : metaData &&
            Object.keys(metaData).length > 0 &&
            metaData.serviceOptions &&
            metaData.serviceOptions.length > 0
          ? metaData.serviceOptions
          : []
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: true,
          editRecord: false,
          viewRecord: false,
          colProps: {
            lg: "6",
            md: "6",
            style: { paddingRight: "15px" },
          },
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          colProps: {
            lg: "6",
            md: "6",
            style: { paddingRight: "15px" },
          },
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          customEditBtn: ({openModal, record = {} })=> {
            const processStatus = record &&
            record.processStatus &&
            record.processStatus.processStatusId 
            return (
              <button
                onClick={openModal}
                disabled={processStatus && processStatus === "PS1" ? false : processStatus === "PS10" ? true : false}
                type="button"
                className="btn btn-success edit-table-btn"
              >
                 <i className="mdi mdi-pencil d-block font-size-16"></i>
              </button>
            )
          },
          customDeleteBtn: ({ openDialog, record = {} }) => {
            const status =
              (record &&
                record.processStatus &&
                record.processStatus.processStatusName) ||
              false
            return (
              <button
                onClick={openDialog}
                disabled={status && status === "Unassigned" ? false : true}
                type="button"
                className="btn btn-danger delete-table-btn mx-3"
              >
                <i className="mdi mdi-trash-can d-block font-size-16"></i>
              </button>
            )
          },
          formatterStyle: { width: "100%" },
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "leadNo",
          label: "Lead No",
          placeholder: "Enter Lead No",
          sort: true,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) => {
            console.log(row.processStatus.processStatusName, "process status")
            return (
              <div>
                <Link
                  to={{ pathname: `client-details/${row._id}`, state: { row ,mode: 'SALES', leadClientId: row} }}
                  className={row.processStatus.processStatusId === "PS1" || row.processStatus.processStatusId === "PS10" ? "disabled-button" : ""}
                  style={{ textTransform: "uppercase" }}
                >
                   {row.leadNo}
                </Link>
                {row.processStatus.processStatusId === "PS1" ?
                  <>
                    <i
                      style={{ color: "grey" }}
                      id="quoteInfo"
                      aria-hidden="true"
                      className="fa fa-info-circle ms-1"
                    ></i>
                    <UncontrolledTooltip placement="right" target="quoteInfo">
                      This lead is not yet assigned. Please change the process status, to enable the leadNo.
                    </UncontrolledTooltip>
                  </> : ""}
              </div>
            )
          },
          type: "text",
        },
        {
          id: "5",
          value: "leadType",
          label: "Lead Type",
          placeholder: "Enter Lead Type",
          sort: true,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "6",
          value: "companyId",
          label: "Company",
          placeholder: "Select Company",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          validation: true,
          colProps: {
            lg: "4",
            md: "4",
            style: {
              borderTop: "2px solid #eff2f7",
              borderLeft: "2px solid #eff2f7",
              borderTopLeftRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row) => {
            return (<span style={{textTransform: "uppercase"}}>{row.companyName}</span>)
          },
          type: "select",
          options: "companyOptions",
        },
        {
          id: "7",
          value: "branchId",
          label: "Branch",
          placeholder: "Select Branch",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          validation: true,
          disabled: record.companyId ? false : true,
          colProps: {
            lg: "4",
            md: "4",
            style: {
              borderTop: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row) => {
            return (<span style={{textTransform: "uppercase"}}>{row.branchName}</span>
             
            )
          },
          type: "select",
          options: branchOptions,
        },
        {
          id: "8",
          value: "leadServiceId",
          label: "Service",
          placeholder: "Select Lead Service",
          sort: true,
          editRecord: true,
          viewRecord: false,
          disabled: record.companyId ? false : true,
          required: true,
          colProps: {
            lg: "4",
            md: "4",
            style: {
              borderTop: "2px solid #eff2f7",
              borderRight: "2px solid #eff2f7",
              borderTopRightRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row) => {
            return (
            <span style={{textTransform: "uppercase"}}>{row.leadServiceName}</span>
            )
          },
          type: "select",
          options: serviceOptions,
          validation: true,
        },
        {
          id: "9",
          value: "leadSourceId",
          label: "Source",
          placeholder: "Select Lead Source",
          sort: true,
          editRecord: true,
          viewRecord: false,
          required: true,
          colProps: {
            lg: "4",
            md: "4",
            style: {
              borderLeft: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              //  paddingBottom: '0px',
            },
            className: "",
          },
          formatter: (cellContent, row) => {
            return (
              <span style={{textTransform: "uppercase"}}>{row.leadSourceName}</span>
              )
          },
          type: "select",
          options: "sourceOptions",
          validation: true,
        },
        {
          id: '10',
          value: 'leadSubSourceId',
          label: 'Sub Source',
          placeholder: 'Select Lead Sub Source',
          disabled: record.leadSourceId ? false : true,
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: '4',
            md: '4',
            style: {
              padding: '15px',
              backgroundColor: '#d3d3d321',
              paddingBottom: '0px',
            },
            className: '',
          },
          formatter: (cellContent, row) => {
            return (
              <span style={{textTransform: "uppercase"}}>{row.leadSubSourceName}</span>
              )
          },
          type: 'select',
          options: subSourceOptions,
        },
        {
          id: "11",
          value: "clientName",
          label: "Client",
          sort: true,
          editRecord: false,
          viewRecord: true,
          formatter: (cell, row) => {
            return (
              <div style={{textTransform: "uppercase"}}>{`${(row && row.clientDetails && row.clientDetails.firstName) || ""
                } ${(row && row.clientDetails && row.lastName) || ""}`}</div>
            )
          },
          type: "text",
        },
        {
          id: "12",
          value: "leadStatus",
          label: "Lead Assign",
          sort: true,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex, metaData, actions) => {
            console.log(row, "row from lead status")
            const cellColorCode =
              metaData &&
              Object.keys(metaData).length > 0 &&
              metaData.processStatusOptions &&
              metaData.processStatusOptions.length > 0 &&
              metaData.processStatusOptions.find(
                (_) =>
                  row &&
                  row.processStatus &&
                  row.processStatus.processStatusId &&
                  _.value.toString() ===
                  row.processStatus.processStatusId.toString()
              ) &&
              metaData.processStatusOptions.find(
                (_) =>
                  row &&
                  row.processStatus &&
                  row.processStatus.processStatusId &&
                  _.value.toString() ===
                  row.processStatus.processStatusId.toString()
              ).colorCode
            return (
              <LeadStatus
                btnStyle={{ padding: "6px" }}
                colorCode={cellColorCode}
                cellContent={cellContent}
                row={row}
                rowIndex={rowIndex}
                metaData={metaData}
                actions={actions}
              />
            )
          },
          type: "text",
        },
        {
          id: "13",
          value: "salesUrge",
          label: "Sales Urge",
          placeholder: "Select Sales Urge",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          //  width: 80,
          colProps: {
            lg: "4",
            md: "4",
            style: {
              padding: "15px",
              backgroundColor: "#d3d3d321",
              //  paddingBottom: '0px',
            },
            className: "",
          },
          formatter: (val) => (
            <div style={{ display: "flex", flexWrap: "wrap", textTransform: "uppercase" }}>{val}</div>
          ),
          type: "select",
          options: [
            {
              label: "hot",
              value: "hot",
            },
            {
              label: "warm",
              value: "warm",
            },
            {
              label: "cold",
              value: "cold",
            },
          ],
        },
        {
          id: "14",
          value: "clientProfile",
          label: "Client Profile",
          placeholder: "Select Client Profile",
          sort: true,
          editRecord: true,
          viewRecord: true,
          colProps: {
            lg: "4",
            md: "4",
            style: {
              borderLeft: '2px solid #eff2f7',
              borderBottom: '2px solid #eff2f7',
              borderBottomLeftRadius: '6px',
              padding: '15px',
              backgroundColor: '#d3d3d321',
            },
          },
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.clientProfileOptions &&
                metaData.clientProfileOptions.length > 0 &&
                metaData.clientProfileOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.clientProfileOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: "clientProfileOptions",
        },
        {
           id: '15',
           value: 'clientProfileRemarks',
           label: 'Client Profile Remarks',
           placeholder: 'Enter Client Profile Remarks',
           sort: true,
           editRecord: true,
           viewRecord: false,
           colProps: {
             lg: '4',
             md: '4',
             style: {
               borderBottom: '2px solid #eff2f7',
               padding: '15px',
               backgroundColor: '#d3d3d321',
             },
             className: "employee-input"
           },
           type: 'text',
         },
         {
           id: '16',
           value: 'attachment',
           label: 'Media Attachment',
           placeholder: 'Choose Media Attachment',
           sort: true,
           editRecord: true,
           viewRecord: false,
           colProps: {
             lg: '4',
             md: '4',
             style: {
               borderBottom: '2px solid #eff2f7',
               borderRight: '2px solid #eff2f7',
               borderBottomRightRadius: '6px',
               padding: '15px',
               backgroundColor: '#d3d3d321',
             },
           },
          type: "upload",
        },
        {
          id: "17",
          value: "firstName",
          label: "First Name",
          placeholder: "Enter First Name",
          sort: true,
          editRecord: true,
          viewRecord: false,
          required: true,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderTop: "2px solid #eff2f7",
              borderLeft: "2px solid #eff2f7",
              borderTopLeftRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          type: "textOnly",
          validations: "textOnly"
        },
        {
          id: "18",
          value: "lastName",
          label: "Last Name",
          placeholder: "Enter Last Name",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderTop: "2px solid #eff2f7",
              borderRight: "2px solid #eff2f7",
              borderTopRightRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              width: "24%",
              marginRight: "auto",
              paddingBottom: "0px",
            },
            className: "",
          },
          type: "textOnly",
          validations: "textOnly"
        },
        {
          id: "19",
          value: "clientLocation",
          label: "Client Location",
          placeholder: "Enter Client Location",
          sort: true,
         // required:true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderTop: "2px solid #eff2f7",
              borderLeft: "2px solid #eff2f7",
              borderTopLeftRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          type: "textOnly",
          validations: "textOnly"
        },
        {
          id: "20",
          value: "primaryMobile",
          label: "Primary No",
          placeholder: "Enter Primary No",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          onInputChange: ({ inputValue, setFieldValue }) => {
            const obj = inputValue.val
            console.log(obj, "Response")
            api
              .post("/get_client", {
                status: "active",
                id: "",
                mobileNo: obj ? "+" + obj : [],
              })
              .then((res) => {
                if (
                  res &&
                  res.data &&
                  res.data.data &&
                  res.data.data.length > 0
                ) {
                  setFieldValue("primaryMobileConfirm", true)
                  setFieldValue(
                    "clientId",
                    res.data.data && res.data.data[0] && res.data.data[0]._id
                  )
                } else {
                  setFieldValue("primaryMobileConfirm", false)
                }
              })
              .catch(() => {
                setFieldValue("primaryMobileConfirm", false)
              })
          },
          prefix: ({ setFieldValue }) => {
            return (
              <div
                style={{ display: "flex", alignItems: "center", width: "32px" }}
              >
                <input
                  type="checkbox"
                  id="check1"
                  onClick={(e) =>{
                    if(  e.target.checked){
                      setFieldValue("whatsAppNo", record.primaryMobile)
                      document.getElementById('check2').checked=false
                    }
                  else{
                    setFieldValue("whatsAppNo","")
                  }}
                   
                }
              
                ></input>
              </div>
            )
          },
          defaultCountry: (selCountry && selCountry.shortName) || "IN",
          //defaultValue: record && record.primaryMobile && record.primaryMobile.toString() && `+${record.primaryMobile.toString()}` || '',
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderTop: "2px solid #eff2f7",
              borderRight: "2px solid #eff2f7",
              borderTopRightRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          type: "phone",
          validations: "phone",
        },
        {
          id: "21",
          value: "country",
          label: "Country",
          placeholder: "Enter Country",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderLeft: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.countryOptions &&
                metaData.countryOptions.length > 0 &&
                metaData.countryOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.countryOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: "countryOptions",
        },
        {
          id: "22",
          value: "state",
          label: "State",
          placeholder: "Enter State",
          sort: true,
          editRecord: true,
          disabled: record.country ? false : true,
          viewRecord: false,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderRight: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              width: "24%",
              marginRight: "auto",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.stateOptions &&
                metaData.stateOptions.length > 0 &&
                metaData.stateOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.stateOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: stateOptions,
        },
        {
          id: "23",
          value: "secondaryMobile",
          label: "Secondary No",
          placeholder: "Enter Secondary No",
          sort: true,
          editRecord: true,
          viewRecord: false,
          onInputChange: ({ inputValue, setFieldValue }) => {
            const obj = inputValue.val
            console.log(obj, "Response")
            api
              .post("/get_client", {
                status: "active",
                id: "",
                mobileNo: obj ? obj : [],
              })
              .then((res) => {
                if (
                  res &&
                  res.data &&
                  res.data.data &&
                  res.data.data.length > 0
                ) {
                  setFieldValue("secondaryMobileConfirm", true)
                  setFieldValue(
                    "clientId",
                    res.data.data && res.data.data[0] && res.data.data[0]._id
                  )
                } else {
                  setFieldValue("secondaryMobileConfirm", false)
                }
              })
              .catch(() => {
                setFieldValue("secondaryMobileConfirm", false)
              })
          },
          prefix: ({ setFieldValue }) => {
            return (
              <div
                style={{ display: "flex", alignItems: "center", width: "32px" }}
             >
                <input
                  type="checkbox"
                  id="check2"
                  onChange={(e) =>{
                    if( e.target.checked){
                      setFieldValue("whatsAppNo", record.secondaryMobile)
                      document.getElementById('check1').checked=false
                    }
                  else{
                    setFieldValue("whatsAppNo", "")
                  }}
                   
                  }
                 // checked={checked}
                ></input>
              </div>
            )
          },
          defaultCountry: (selCountry && selCountry.shortName) || "IN",
          //defaultValue: record && record.secondaryMobile && record.secondaryMobile.toString() && `+${record.secondaryMobile.toString()}` || '',
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderLeft: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          type: "phone",
        },

        {
          id: "24",
          value: "whatsAppNo",
          label: "Whats App No",
          placeholder: "Enter Whats App No",
          sort: true,
          editRecord: true,
          viewRecord: false,
          required: true,
          defaultCountry: (selCountry && selCountry.shortName) || "IN",
          //defaultValue: record && record.whatsAppNo && record.whatsAppNo.toString() && `+${record.whatsAppNo.toString()}` || '',
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderRight: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          onInputChange: ({ inputValue, setFieldValue }) => {
            const obj = inputValue.val
            console.log(obj, "Response")
            api
              .post("/get_client", {
                status: "active",
                id: "",
                mobileNo: obj ? obj : [],
              })
              .then((res) => {
                if (
                  res &&
                  res.data &&
                  res.data.data &&
                  res.data.data.length > 0
                ) {
                  setFieldValue("whatsAppNoConfirm", true)
                  setFieldValue(
                    "clientId",
                    res.data.data && res.data.data[0] && res.data.data[0]._id
                  )
                } else {
                  setFieldValue("whatsAppNoConfirm", false)
                }
              })
              .catch(() => {
                setFieldValue("whatsAppNoConfirm", false)
              })
          },
          type: "phone",
          validations: "phone",
        },
        {
          id: "25",
          value: "city",
          label: "City",
          placeholder: "Enter City",
          sort: true,
          editRecord: true,
          disabled: record.state ? false : true,
          viewRecord: false,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderLeft: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.cityOptions &&
                metaData.cityOptions.length > 0 &&
                metaData.cityOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.cityOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: cityOptions,
        },
        {
          id: "26",
          value: "pincode",
          label: "Pincode",
          placeholder: "Enter Pincode",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderRight: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              width: "24%",
              marginRight: "auto",
              paddingBottom: "0px",
            },
            className: "employee-input",
          },
          type: "zipCode",
          validations: "zipCode"
        },
        {
          id: "27",
          value: "emailId",
          label: "Email ID",
          placeholder: "Enter Email ID",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderLeft: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          type: "email",
        },
        {
          id: "28",
          value: "priorityStatusId",
          label: "Priority Status",
          placeholder: "Select Priority Status",
          sort: true,
          editRecord: true,
          viewRecord: false,
          required: true,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderRight: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.priorityStatusOptions &&
                metaData.priorityStatusOptions.length > 0 &&
                metaData.priorityStatusOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.priorityStatusOptions.find(
                  (_) => cellContent === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: "priorityStatusOptions",
        },
        {
          id: "29",
          value: "primaryAddress",
          label: "Address",
          placeholder: "Enter Address",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "6",
            md: "6",
            style: {
              borderLeft: "2px solid #eff2f7",
              borderRight: "2px solid #eff2f7",
              borderBottom: "2px solid #eff2f7",
              borderBottomLeftRadius: "6px",
              borderBottomRightRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              width: "49%",
              marginRight: "auto",
            },
          },
          type: "textarea",
        },
        {
          id: "30",
          value: "descriptions",
          label: "Remarks",
          placeholder: "Enter Remarks",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "6",
            md: "6",
            style: {
              borderLeft: "2px solid #eff2f7",
              borderRight: "2px solid #eff2f7",
              borderBottom: "2px solid #eff2f7",
              borderBottomLeftRadius: "6px",
              borderBottomRightRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
            },
          },
          type: "textarea",
        },
        {
          id: "31",
          value: "crossPromotion",
          label: "Cross Promotions",
          placeholder: "Select Cross Promotions",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "6",
            md: "6",
            style: {
              border: "2px solid #eff2f7",
              borderRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              width: "49%",
              marginRight: "auto",
              paddingBottom: "0px",
            },
          },
          type: "table",
          labelStyle: {
            fontSize: "18px",
            textTransform: "uppercase",
          },
          formatter: () => {
            return <div>NA</div>
          },
          tableColumns: [
            {
              dataField: "name",
              text: "Company Name",
            },
            {
              dataField: "action",
              text: "Action",
              formatter: (value, onChange, fieldValues, row) => {
                const options = [
                  {
                    label: "Yes",
                    value: true,
                  },
                  {
                    label: "No",
                    value: false,
                  },
                ]
                return (
                  <React.Fragment>
                    <FormGroup className="mb-3">
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          flexWrap: "wrap",
                        }}
                      >
                        {(options || []).map((opt, index) => {
                         return (
                            <div
                              key={index}
                              className="form-check"
                              style={{ marginRight: "15px" }}
                            >
                              <input
                                className="form-check-input"
                                type="radio"
                                name={row._id}
                                id={`${row._id}-${opt.value}`}
                                value={opt.value}
                                onChange={() => {
                                  const isExist =
                                    fieldValues.find(
                                      (a) =>
                                        a &&
                                        row &&
                                        a.companyId &&
                                        row._id &&
                                        a.companyId.toString() ===
                                        row._id.toString()
                                    ) || false

                                  if (isExist) {
                                    onChange({
                                      target: {
                                        value: fieldValues.filter(_=> _.status === 1).map((el) =>
                                          el.companyId.toString() ===
                                            row._id.toString()
                                            ? Object.assign({}, el, {
                                              action: opt.value,
                                            })
                                            : el
                                        ),
                                      },
                                    })
                                  } else {
                                    onChange({
                                      target: {
                                        value: [
                                          ...fieldValues,
                                          Object.assign(
                                            {},
                                            {
                                              companyId: row._id,
                                              action: opt.value,
                                            }
                                          ),
                                        ],
                                      },
                                    })
                                  }
                                }}
                                checked={value === opt.value ? true : false}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`${row._id}-${opt.value}`}
                              >
                                {" "}
                                {opt.label}
                              </label>
                            </div>
                          )
                        })}
                      </div>
                    </FormGroup>
                  </React.Fragment>
                )
              },
            },
          ],
          options: companyTableOptions,
        },
        {
          id: "33",
          value: "isSelfAssign",
          label: "Self Assign",
          sort: true,
          editRecord: true,
          viewRecord: false,
          type: "checkbox",
          labelStyle: {
            fontSize: "12px",
            textTransform: "uppercase",
          },
          colProps: {
            lg: "6",
            md: "6",
            style: {
              border: "2px solid #eff2f7",
              borderRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
              height: "10%",
              fontSize: "14px"
            },
          },
          // options: [{label: "YES", value: true}, {label: "NO", value: false}]
        },
        {
          id: "32",
          value: "customField",
          label: "Custom Field",
          placeholder: "Select Custom Field",
          sort: true,
          editRecord:
            customFieldOptions && customFieldOptions.length > 0 ? true : false,
          viewRecord: false,
          labelStyle: {
            fontSize: "18px",
            textTransform: "uppercase",
          },
          colProps: {
            lg: "6",
            md: "6",
            style: {
              border: "2px solid #eff2f7",
              borderRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
              height: "90%"
            },
            className: "custom-field-style"
          },
          formatter: () => {
            return <div>NA</div>
          },
          type: "custom",
          options: customFieldOptions,
        },
        {
          id: "34",
          value:  "agingDate",
          label: "Aging/Re-assigning",
          headerStyle: {
            minWidth: "230px"
          },
          sort: true,
          editRecord: false,
          viewRecord: true,
           formatter: (cellContent, row) => {

            return (row && (row.leadAge) && (row.reassignAge)?`${row.leadAge}/${row.reassignAge} days`:"" ) || ""
          },
          type: "date",
        },

        {
          id: "34",
          value: "salesAgent",
          label: "Sales Agent Name",
          sort: true,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex, metaData) => {
            const agentDetails =
              row &&
                row.leadAssign &&
                Array.isArray(row.leadAssign) &&
                row.leadAssign.length > 0 &&
                metaData &&
                metaData.employeeListOptions &&
                metaData.employeeListOptions.length > 0
                ? metaData.employeeListOptions.find(
                  (k) =>
                    row.leadAssign[row.leadAssign.length - 1] &&
                    row.leadAssign[row.leadAssign.length - 1].assignedTo &&
                    k.value.toString() ===
                    row.leadAssign[
                      row.leadAssign.length - 1
                    ].assignedTo.toString()
                )
                : false
            return <div style={{textTransform: "uppercase"}}>{(agentDetails && agentDetails.name) || ""}</div>
          },
          type: "text",
          validations: "textOnly"
        },
        {
          id: "35",
          value: "budget",
          label: "Budget",
          sort: true,
          editRecord: false,
          viewRecord: true,
          type: "text",
        },
        {
          id: "36",
          value: "leadSourceId",
          label: "Lead Source",
          sort: true,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.sourceOptions &&
                metaData.sourceOptions.length > 0 &&
                metaData.sourceOptions.find(
                  (_) => cellContent === _.value.toString()
                ) &&
                metaData.sourceOptions.find(
                  (_) => cellContent === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "text",
        },
        {
          id: "37",
          value: "insertedBy",
          label: "Created By",
          sort: true,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) => {
            return (row && row.insertedBy && row.insertedBy.name) || ""
          },
          type: "text",
        },
        {
          id: "38",
          value: "leadDate",
          label: "Lead Date",
          sort: true,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) => {

            return (row && (row.leadDate)) || ""
          },
          type: "date",
        },
        {
          id: "39",
          value: "leadStatus",
          label: "Lead Status",
          sort: true,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex, metaData) => {
            const cellColorCode =
              metaData &&
              Object.keys(metaData).length > 0 &&
              metaData.processStatusOptions &&
              metaData.processStatusOptions.length > 0 &&
              metaData.processStatusOptions.find(
                (_) =>
                  row &&
                  row.processStatus &&
                  row.processStatus.processStatusId &&
                  _.value.toString() ===
                  row.processStatus.processStatusId.toString()
              ) &&
              metaData.processStatusOptions.find(
                (_) =>
                  row &&
                  row.processStatus &&
                  row.processStatus.processStatusId &&
                  _.value.toString() ===
                  row.processStatus.processStatusId.toString()
              ).colorCode
            return (
              <Badge
                className={`font-size-12`}
                style={{
                  backgroundColor: cellColorCode || "#34c38f",
                  padding: "4px",
                }}
                color={cellColorCode}
              >
                {(row &&
                  row.processStatus &&
                  row.processStatus.processStatusName) ||
                  ""}
              </Badge>
            )
          },
          type: "text",
        },
      ]
    },
  },
  
  {
    schemaId: "RW1wbG95ZWVSZXF1ZXN0",
    name: "employeeRequest",
    title: "Employee Request",
    path: "/employee-request",
    visible: true,
    formTitle: "Employee Request",
    page: "EmployeeRequest",
    ...RW1wbG95ZWVSZXF1ZXN0,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "code",
        label: "State Code",
        placeholder: "Enter State Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
      },
      {
        id: "4",
        value: "name",
        label: "State Name",
        placeholder: "Enter State Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "text",
      },
      {
        id: "5",
        value: "countryName",
        label: "Country Name",
        sort: true,
        editRecord: false,
        viewRecord: true,
        type: "text",
      },
      {
        id: "6",
        value: "companyId",
        label: "Company",
        placeholder: "Select Company",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "select",
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
            (metaData &&
              metaData.companyOptions &&
              metaData.companyOptions.length > 0 &&
              metaData.companyOptions.find(
                (_) => _.value.toString() === cellContent.toString()
              ) &&
              metaData.companyOptions.find((_) => _.value === cellContent)
                .label) ||
            ""
          )
        },
        options: "companyOptions",
      },
      {
        id: "7",
        value: "venueLocation",
        label: "Venue Location",
        placeholder: "Select Venue Location",
        sort: false,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "6",
          md: "6",
          style: {
            paddingRight: "10px",
          },
        },
        formatter: (cellContent, row, rowIndex, metaData) => {
          return (
            (cellContent &&
              metaData &&
              metaData.cityOptions &&
              metaData.cityOptions.length > 0 &&
              metaData.cityOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ) &&
              metaData.cityOptions.find(
                (_) => cellContent.toString() === _.value.toString()
              ).label) ||
            ""
          )
        },
        type: "select",
        options: "cityOptions",
      },
      {
        id: "8",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "9",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
  {
    schemaId: 'cGVybWlzc2lvbg',
    name: 'permissionrequest',
    title: 'Permission Request',
    path: '/permission-request',
    visible: true,
    formTitle: 'Permission Request',
    page: 'PermissionRequest',
    ...cGVybWlzc2lvbg,
    columns: () => [
      {
        id: '1',
        value: '_id',
        label: 'Id',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '2',
        value: 'sno',
        label: 'S.No',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: 'text',
      },
      {
        id: '3',
        value: 'actions',
        label: 'Actions',
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: 'actions',
        type: 'text',
      },
      {
        id: '4',
        value: 'code',
        label: 'EmployeeRequest Code',
        placeholder: 'Enter EmployeeRequest Code',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
      },
      {
        id: '5',
        value: 'name',
        label: 'EmployeeRequest Name',
        placeholder: 'Enter EmployeeRequest Name',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
      },
      {
        id: '6',
        value: 'status',
        label: 'Status',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? 'bg-success badge-soft-success'
                : 'bg-danger badge-soft-danger'
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? 'Active' : 'Inactive'}
            </Badge>
          ),
        type: 'text',
      },
      {
        id: '7',
        value: 'branches',
        label: 'Branches',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '8',
        value: 'insertedBy',
        label: 'Inserted By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '9',
        value: 'updatedBy',
        label: 'Updated By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '10',
        value: 'createdAt',
        label: 'Created Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '11',
        value: 'updatedAt',
        label: 'Updated Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
    ],
  },
  {
    schemaId: 'bGVhdmU',
    name: 'leaverequest',
    title: 'Leave Request',
    path: '/leave-request',
    visible: true,
    formTitle: 'Leave Request',
    page: 'LeaveRequest',
    ...bGVhdmU,
    columns: () => [
      {
        id: '1',
        value: '_id',
        label: 'Id',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '2',
        value: 'sno',
        label: 'S.No',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: 'text',
      },
      {
        id: '3',
        value: 'actions',
        label: 'Actions',
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: 'actions',
        type: 'text',
      },
      {
        id: '4',
        value: 'code',
        label: 'EmployeeRequest Code',
        placeholder: 'Enter EmployeeRequest Code',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
      },
      {
        id: '5',
        value: 'name',
        label: 'EmployeeRequest Name',
        placeholder: 'Enter EmployeeRequest Name',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
      },
      {
        id: '6',
        value: 'status',
        label: 'Status',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? 'bg-success badge-soft-success'
                : 'bg-danger badge-soft-danger'
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? 'Active' : 'Inactive'}
            </Badge>
          ),
        type: 'text',
      },
      {
        id: '7',
        value: 'branches',
        label: 'Branches',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '8',
        value: 'insertedBy',
        label: 'Inserted By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '9',
        value: 'updatedBy',
        label: 'Updated By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '10',
        value: 'createdAt',
        label: 'Created Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '11',
        value: 'updatedAt',
        label: 'Updated Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
    ],
  },
  {
    schemaId: "bXlwcm9maWxl",
    name: "myprofile",
    title: "Profile",
    formTitle: "Profile",
    path: "/my-profile",
    visible: true,
    ...bXlwcm9maWxl,
    page: "Muhurtham",
    exact: true,
    columns: (record = [], metaData) => {
     console.log(record, "record from api")
     console.log(metaData, "record from api")
     const codeValueMetaData = metaData && metaData.codeOptions
     console.log(codeValueMetaData, "record from api")
     const branchOptions =
     record &&
     record.companyId &&
     metaData &&
     Object.keys(metaData).length > 0 &&
     metaData.branchOptions &&
     metaData.branchOptions.length > 0
       ? metaData.branchOptions.filter(
           (_) => _.companyid=== record.companyId
         ) : metaData &&
         Object.keys(metaData).length > 0 &&
         metaData.branchOptions &&
         metaData.branchOptions.length > 0
       ? metaData.branchOptions
       : []
       //console.log("branch",metaData.branchOptions)
     return[
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "companyId",
        label: "Company",
        placeholder: "Enter Company Name",
        sort: true,
        editRecord: true,
        viewRecord: false,
        required: true,
        type: "select",
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },
        options: "companyOptions",
      },
      {
        id: "4",
        value: "companyName",
        label: "Company",
        placeholder: "Enter Company Name",
        sort: true,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) => {
          return (
           <span style={{textTransform: "uppercase"}}>{row.companyName}</span>
          )
        },
        required: true,
      },
      {
        id: "4",
        value: "branchId",
        label: "Branch",
        placeholder: "Enter Branch Name",
        sort: true,
        editRecord: record.companyId ? true : false,
        viewRecord: false,
        required: true,
        type: "multiSelect",
        validations: "arrayField",
        colProps: {
          lg: "6",
          md: "6",
        },
        // options:  record.companyId?branch:'branchOptions',
        options: record.companyId ? branchOptions : branchOptions,
      },
      {
        id: "4",
        value: "branchName",
        label: "Branch",
        placeholder: "Enter Branch Name",
        sort: true,
        editRecord:  false,
        viewRecord: true,
        formatter: (cellContent, row) => {
          var branchList = row.branchName
         const branchId = row.branchName.map(branch=> branch)
         // return <span>{row.branchId}</span>
         return <span>{branchList.length > 1 ? branchId +"," : branchId}</span>
       },
      },
      {
        id: "6",
        value: "muhurthanCode",
        autofillValue: codeValueMetaData,
        label: "Muhurtham Code",
        placeholder: "Enter Muhurtham Code",
        sort: true,
       // required:true,
        editRecord: true,
        viewRecord: true,
        type: "code",
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },
        formatter: (cellContent, row) => {
         return <span style={{textTransform: "uppercase"}}>{row.muhurthanCode} </span>
         },
      },
      {
        id: "6",
        value: "muhurthan",
        label: "Muhurtham",
        placeholder: "Enter Muhurtham",
        sort: true,
        required:true,
        editRecord: true,
        viewRecord: true,
        type: "text",
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },
        formatter: (cellContent, row) => {
         console.log(row, "row from api")
         return (
           <>
             <p style={{ textTransform: "uppercase" }}>{row.muhurthan}</p>
           </>
         )},
      },
      {
        id: "5",
        value: "date",
        label: "Date",
        placeholder: "Enter Date",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
       //  disabled: false,
        type: "date",
        formatter: (cellContent, row)=> {
         const date = moment(row.date).format("DD-MM-YYYY")
         return (<>
             <span style={{textTransform: "uppercase"}}>{date}</span>
         </>)
        },
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },
      },
      {
        id: "4",
        value: "priorityStatusId",
        label: "Priority Status",
        placeholder: "Enter Priority Status",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: false,
        type: "select",
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },

       formatter: (cellContent, row) => {
         return (
          <span style={{textTransform: "uppercase"}}>{row.priorityStatusName}</span> 
        )
       },
        options: "priorityStatusOptions",
      },

      {
        id: "5",
        value: "description",
        label: "Description",
        placeholder: "Enter Description ",
        sort: true,
        editRecord: true,
        viewRecord: true,
        formatter: (cellContent, row) => {
         return <span style={{textTransform: "uppercase"}}>{row.description} </span>
         },
        type: "textarea",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "10",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "12",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "13",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]},
  },
  {
    schemaId: "bGVhdmVPcHRpb25z",
    name: "leaveOptions",
    title: "Leave Options",
    path: "/employee-default",
    visible: true,
    formTitle: "Leave Options",
    page: "LeaveOptions",
    ...bGVhdmVPcHRpb25z,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  {
    schemaId: 'RGVsZWdh',
    name: 'delegation',
    title: 'Delegation',
    path: '/delegation',
    visible: true,
    formTitle: 'Delegation',
    page: 'Delegation',
    ...RGVsZWdh,
    columns: () => [
      {
        id: '1',
        value: '_id',
        label: 'Id',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '2',
        value: 'sno',
        label: 'S.No',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: 'text',
      },
      {
        id: '3',
        value: 'actions',
        label: 'Actions',
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: 'actions',
        type: 'text',
      },
      {
        id: '4',
        value: 'code',
        label: 'EmployeeRequest Code',
        placeholder: 'Enter EmployeeRequest Code',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
      },
      {
        id: '5',
        value: 'name',
        label: 'EmployeeRequest Name',
        placeholder: 'Enter EmployeeRequest Name',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
      },
      {
        id: '6',
        value: 'status',
        label: 'Status',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? 'bg-success badge-soft-success'
                : 'bg-danger badge-soft-danger'
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? 'Active' : 'Inactive'}
            </Badge>
          ),
        type: 'text',
      },
      {
        id: '7',
        value: 'branches',
        label: 'Branches',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '8',
        value: 'insertedBy',
        label: 'Inserted By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '9',
        value: 'updatedBy',
        label: 'Updated By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '10',
        value: 'createdAt',
        label: 'Created Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '11',
        value: 'updatedAt',
        label: 'Updated Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
    ],
  },
  {
    schemaId: 'TmlnaHRz',
    name: 'nightshift',
    title: 'NightShift',
    path: '/night-shift',
    visible: true,
    formTitle: 'NightShift',
    page: 'NightShift',
    ...TmlnaHRz,
    columns: () => [
      {
        id: '1',
        value: '_id',
        label: 'Id',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '2',
        value: 'sno',
        label: 'S.No',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: 'text',
      },
      {
        id: '3',
        value: 'actions',
        label: 'Actions',
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: 'actions',
        type: 'text',
      },
      {
        id: '4',
        value: 'code',
        label: 'EmployeeRequest Code',
        placeholder: 'Enter EmployeeRequest Code',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
      },
      {
        id: '5',
        value: 'name',
        label: 'EmployeeRequest Name',
        placeholder: 'Enter EmployeeRequest Name',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
      },
      {
        id: '6',
        value: 'status',
        label: 'Status',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? 'bg-success badge-soft-success'
                : 'bg-danger badge-soft-danger'
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? 'Active' : 'Inactive'}
            </Badge>
          ),
        type: 'text',
      },
      {
        id: '7',
        value: 'branches',
        label: 'Branches',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '8',
        value: 'insertedBy',
        label: 'Inserted By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '9',
        value: 'updatedBy',
        label: 'Updated By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '10',
        value: 'createdAt',
        label: 'Created Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '11',
        value: 'updatedAt',
        label: 'Updated Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
    ],
  },
  {
    schemaId: 'bm90aWZp',
    name: 'notification',
    title: 'Notification',
    path: '/notification',
    visible: true,
    formTitle: 'Notification',
    page: 'Notification',
    ...bm90aWZp,
    columns: () => [
      {
        id: '1',
        value: '_id',
        label: 'Id',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '2',
        value: 'sno',
        label: 'S.No',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: 'text',
      },
      {
        id: '3',
        value: 'actions',
        label: 'Actions',
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: 'actions',
        type: 'text',
      },
      {
        id: '4',
        value: 'code',
        label: 'EmployeeRequest Code',
        placeholder: 'Enter EmployeeRequest Code',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
      },
      {
        id: '5',
        value: 'name',
        label: 'EmployeeRequest Name',
        placeholder: 'Enter EmployeeRequest Name',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
      },
      {
        id: '6',
        value: 'status',
        label: 'Status',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status
                ? 'bg-success badge-soft-success'
                : 'bg-danger badge-soft-danger'
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status ? 'Active' : 'Inactive'}
            </Badge>
          ),
        type: 'text',
      },
      {
        id: '7',
        value: 'branches',
        label: 'Branches',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '8',
        value: 'insertedBy',
        label: 'Inserted By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '9',
        value: 'updatedBy',
        label: 'Updated By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '10',
        value: 'createdAt',
        label: 'Created Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '11',
        value: 'updatedAt',
        label: 'Updated Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
    ],
  },

  // Followup Audit
  {
    schemaId: "c2FsZXNG",
    name: "salesfollowup",
    title: "salesFollowup",
    path: "/salesfollowupaudit",
    visible: true,
    formTitle: "salesFollowup",
    page: "Sales Followup",
    ...c2FsZXNG,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")
      
      const codeValueMetaData = metaData && metaData.codeOptions
      
   console.log(codeValueMetaData, "codeValueMetaData")
    return[
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "code",
        autofillValue: codeValueMetaData,
        label: "Department Code",
        placeholder: "Enter Department Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        // required: true,
        formatter: (cellContent, row)=> {
          return (
            <span style={{textTransform: "uppercase"}}>
            {row.code}
            </span> )
          },
        type: "code",
      },
      {
        id: "5",
        value: "name",
        label: "Department Name",
        placeholder: "Enter Department Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row)=> {
          return (
            <span style={{textTransform: "uppercase"}}>
            {row.name}
            </span> )
        },
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${
                row.status && row.status === 1 
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
              }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1  ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]}
  },
  // Booking complete
  {
    schemaId: 'Ym9va2luZw',
    name: 'bookingComplete',
    title: 'Booking Complete',
    path: '/booking-complete',
    visible: true,
    formTitle: 'Booking Complete',
    page: 'BookingComplete',
    ...Ym9va2luZw,
    columns: () => [
      {
        id: '1',
        value: '_id',
        label: 'Id',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '2',
        value: 'sno',
        label: 'S.No',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: 'text',
      },
      {
        id: '3',
        value: 'actions',
        label: 'Actions',
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: 'actions',
        type: 'text',
      },
      {
        id: '4',
        value: 'code',
        label: 'EmployeeRequest Code',
        placeholder: 'Enter EmployeeRequest Code',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
      },
      {
        id: '5',
        value: 'name',
        label: 'EmployeeRequest Name',
        placeholder: 'Enter EmployeeRequest Name',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
      },
      {
        id: '6',
        value: 'status',
        label: 'Status',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? 'bg-success badge-soft-success'
                : 'bg-danger badge-soft-danger'
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? 'Active' : 'Inactive'}
            </Badge>
          ),
        type: 'text',
      },
      {
        id: '7',
        value: 'branches',
        label: 'Branches',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '8',
        value: 'insertedBy',
        label: 'Inserted By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '9',
        value: 'updatedBy',
        label: 'Updated By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '10',
        value: 'createdAt',
        label: 'Created Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '11',
        value: 'updatedAt',
        label: 'Updated Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
    ],
  },
  //Alter Quote list
  {
    schemaId: 'YWx0ZXJRdW90ZUxpc3Q',
    name: 'alterQuoteList',
    title: 'Alter Quote List',
    path: '/alter-quotelist',
    visible: true,
    formTitle: 'Alter Quote List',
    page: 'AlterQuoteList',
    ...YWx0ZXJRdW90ZUxpc3Q,
    columns: () => [
      {
        id: '1',
        value: '_id',
        label: 'Id',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '2',
        value: 'sno',
        label: 'S.No',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: 'text',
      },
      {
        id: '3',
        value: 'actions',
        label: 'Actions',
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: 'actions',
        type: 'text',
      },
      {
        id: '4',
        value: 'code',
        label: 'EmployeeRequest Code',
        placeholder: 'Enter EmployeeRequest Code',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
      },
      {
        id: '5',
        value: 'name',
        label: 'EmployeeRequest Name',
        placeholder: 'Enter EmployeeRequest Name',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
      },
      {
        id: '6',
        value: 'status',
        label: 'Status',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? 'bg-success badge-soft-success'
                : 'bg-danger badge-soft-danger'
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? 'Active' : 'Inactive'}
            </Badge>
          ),
        type: 'text',
      },
      {
        id: '7',
        value: 'branches',
        label: 'Branches',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '8',
        value: 'insertedBy',
        label: 'Inserted By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '9',
        value: 'updatedBy',
        label: 'Updated By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '10',
        value: 'createdAt',
        label: 'Created Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '11',
        value: 'updatedAt',
        label: 'Updated Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
    ],
  },
  //My Followup
  {
    schemaId: 'TXlGb2xsb3d1cA',
    name: 'myFollowup',
    title: 'My Followup',
    path: '/my-followup',
    visible: true,
    formTitle: 'My Followup',
    page: 'MyFollowup',
    ...TXlGb2xsb3d1cA,
    columns: () => [
      {
        id: '1',
        value: '_id',
        label: 'Id',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '2',
        value: 'sno',
        label: 'S.No',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: 'text',
      },
      {
        id: '3',
        value: 'actions',
        label: 'Actions',
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: 'actions',
        type: 'text',
      },
      {
        id: '4',
        value: 'code',
        label: 'EmployeeRequest Code',
        placeholder: 'Enter EmployeeRequest Code',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
      },
      {
        id: '5',
        value: 'name',
        label: 'EmployeeRequest Name',
        placeholder: 'Enter EmployeeRequest Name',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
      },
      {
        id: '6',
        value: 'status',
        label: 'Status',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? 'bg-success badge-soft-success'
                : 'bg-danger badge-soft-danger'
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? 'Active' : 'Inactive'}
            </Badge>
          ),
        type: 'text',
      },
      {
        id: '7',
        value: 'branches',
        label: 'Branches',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '8',
        value: 'insertedBy',
        label: 'Inserted By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '9',
        value: 'updatedBy',
        label: 'Updated By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '10',
        value: 'createdAt',
        label: 'Created Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '11',
        value: 'updatedAt',
        label: 'Updated Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
    ],
  },
  //Manage Followup
  {
    schemaId: 'bWFuYWdlRm9sbG93',
    name: 'manageFollowup',
    title: 'Manage Followup',
    path: '/manage-followup',
    visible: true,
    formTitle: 'Manage Followup',
    page: 'ManageFollowup',
    ...bWFuYWdlRm9sbG93,
    columns: () => [
      {
        id: '1',
        value: '_id',
        label: 'Id',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '2',
        value: 'sno',
        label: 'S.No',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: 'text',
      },
      {
        id: '3',
        value: 'actions',
        label: 'Actions',
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: 'actions',
        type: 'text',
      },
      {
        id: '4',
        value: 'code',
        label: 'EmployeeRequest Code',
        placeholder: 'Enter EmployeeRequest Code',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
      },
      {
        id: '5',
        value: 'name',
        label: 'EmployeeRequest Name',
        placeholder: 'Enter EmployeeRequest Name',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
      },
      {
        id: '6',
        value: 'status',
        label: 'Status',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? 'bg-success badge-soft-success'
                : 'bg-danger badge-soft-danger'
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? 'Active' : 'Inactive'}
            </Badge>
          ),
        type: 'text',
      },
      {
        id: '7',
        value: 'branches',
        label: 'Branches',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '8',
        value: 'insertedBy',
        label: 'Inserted By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '9',
        value: 'updatedBy',
        label: 'Updated By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '10',
        value: 'createdAt',
        label: 'Created Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '11',
        value: 'updatedAt',
        label: 'Updated Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
    ],
  },
  //Manage Reject
  {
    schemaId: 'bWFuYWdlUmVqZWN0',
    name: 'manageReject',
    title: 'Manage Reject',
    path: '/manage-reject',
    visible: true,
    formTitle: 'Manage Reject',
    page: 'ManageReject',
    ...bWFuYWdlUmVqZWN0,
    columns: () => [
      {
        id: '1',
        value: '_id',
        label: 'Id',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '2',
        value: 'sno',
        label: 'S.No',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: 'text',
      },
      {
        id: '3',
        value: 'actions',
        label: 'Actions',
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: 'actions',
        type: 'text',
      },
      {
        id: '4',
        value: 'code',
        label: 'EmployeeRequest Code',
        placeholder: 'Enter EmployeeRequest Code',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
      },
      {
        id: '5',
        value: 'name',
        label: 'EmployeeRequest Name',
        placeholder: 'Enter EmployeeRequest Name',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
      },
      {
        id: '6',
        value: 'status',
        label: 'Status',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? 'bg-success badge-soft-success'
                : 'bg-danger badge-soft-danger'
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? 'Active' : 'Inactive'}
            </Badge>
          ),
        type: 'text',
      },
      {
        id: '7',
        value: 'branches',
        label: 'Branches',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '8',
        value: 'insertedBy',
        label: 'Inserted By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '9',
        value: 'updatedBy',
        label: 'Updated By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '10',
        value: 'createdAt',
        label: 'Created Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '11',
        value: 'updatedAt',
        label: 'Updated Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
    ],
  },
  //My Reject
  {
    schemaId: 'bXlSZWplY3Q',
    name: 'myReject',
    title: 'My Reject',
    path: '/my-reject',
    visible: true,
    formTitle: 'My Reject',
    page: 'MyReject',
    ...bXlSZWplY3Q,
    columns: () => [
      {
        id: '1',
        value: '_id',
        label: 'Id',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '2',
        value: 'sno',
        label: 'S.No',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: 'text',
      },
      {
        id: '3',
        value: 'actions',
        label: 'Actions',
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: 'actions',
        type: 'text',
      },
      {
        id: '4',
        value: 'code',
        label: 'EmployeeRequest Code',
        placeholder: 'Enter EmployeeRequest Code',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
      },
      {
        id: '5',
        value: 'name',
        label: 'EmployeeRequest Name',
        placeholder: 'Enter EmployeeRequest Name',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'text',
      },
      {
        id: '6',
        value: 'status',
        label: 'Status',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? 'bg-success badge-soft-success'
                : 'bg-danger badge-soft-danger'
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? 'Active' : 'Inactive'}
            </Badge>
          ),
        type: 'text',
      },
      {
        id: '7',
        value: 'branches',
        label: 'Branches',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '8',
        value: 'insertedBy',
        label: 'Inserted By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '9',
        value: 'updatedBy',
        label: 'Updated By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '10',
        value: 'createdAt',
        label: 'Created Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '11',
        value: 'updatedAt',
        label: 'Updated Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
    ],
  },

//Lead metrics
{
  schemaId: 'bGVhZE1ldHJpY3M',
  name: 'leadMetrics',
  title: 'Lead Metrics',
  path: '/lead-metrics',
  visible: true,
  formTitle: 'Lead Metrics',
  page: 'LeadMetrics',
  ...bGVhZE1ldHJpY3M,
  columns: () => [
    {
      id: '1',
      value: '_id',
      label: 'Id',
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: 'text',
    },
    {
      id: '2',
      value: 'sno',
      label: 'S.No',
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row, rowIndex) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          rowIndex + 1
        ),
      type: 'text',
    },
    {
      id: '3',
      value: 'actions',
      label: 'Actions',
      sort: false,
      editRecord: false,
      viewRecord: true,
      editFormatter: 'actions',
      type: 'text',
    },
    {
      id: '4',
      value: 'code',
      label: 'EmployeeRequest Code',
      placeholder: 'Enter EmployeeRequest Code',
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      type: 'text',
    },
    {
      id: '5',
      value: 'name',
      label: 'EmployeeRequest Name',
      placeholder: 'Enter EmployeeRequest Name',
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      type: 'text',
    },
    {
      id: '6',
      value: 'status',
      label: 'Status',
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          <Badge
            className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
              ? 'bg-success badge-soft-success'
              : 'bg-danger badge-soft-danger'
              }`}
            color={row.badgeclass}
            pill
          >
            {row.status && row.status === 1 ? 'Active' : 'Inactive'}
          </Badge>
        ),
      type: 'text',
    },
    {
      id: '7',
      value: 'branches',
      label: 'Branches',
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: 'text',
    },
    {
      id: '8',
      value: 'insertedBy',
      label: 'Inserted By',
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: 'text',
    },
    {
      id: '9',
      value: 'updatedBy',
      label: 'Updated By',
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: 'text',
    },
    {
      id: '10',
      value: 'createdAt',
      label: 'Created Date',
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: 'text',
    },
    {
      id: '11',
      value: 'updatedAt',
      label: 'Updated Date',
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: 'text',
    },
  ],
},
//Followup metrics
{
  schemaId: 'Zm9sbG93dXBNZXRya',
  name: 'followupMetrics',
  title: 'Followup Metrics',
  path: '/followup-metrics',
  visible: true,
  formTitle: 'Followup Metrics',
  page: 'FollowupMetrics',
  ...Zm9sbG93dXBNZXRya,
  columns: () => [
    {
      id: '1',
      value: '_id',
      label: 'Id',
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: 'text',
    },
    {
      id: '2',
      value: 'sno',
      label: 'S.No',
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row, rowIndex) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          rowIndex + 1
        ),
      type: 'text',
    },
    {
      id: '3',
      value: 'actions',
      label: 'Actions',
      sort: false,
      editRecord: false,
      viewRecord: true,
      editFormatter: 'actions',
      type: 'text',
    },
    {
      id: '4',
      value: 'code',
      label: 'EmployeeRequest Code',
      placeholder: 'Enter EmployeeRequest Code',
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      type: 'text',
    },
    {
      id: '5',
      value: 'name',
      label: 'EmployeeRequest Name',
      placeholder: 'Enter EmployeeRequest Name',
      sort: true,
      editRecord: true,
      viewRecord: true,
      required: true,
      type: 'text',
    },
    {
      id: '6',
      value: 'status',
      label: 'Status',
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          <Badge
            className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
              ? 'bg-success badge-soft-success'
              : 'bg-danger badge-soft-danger'
              }`}
            color={row.badgeclass}
            pill
          >
            {row.status && row.status === 1 ? 'Active' : 'Inactive'}
          </Badge>
        ),
      type: 'text',
    },
    {
      id: '7',
      value: 'branches',
      label: 'Branches',
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: 'text',
    },
    {
      id: '8',
      value: 'insertedBy',
      label: 'Inserted By',
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: 'text',
    },
    {
      id: '9',
      value: 'updatedBy',
      label: 'Updated By',
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: 'text',
    },
    {
      id: '10',
      value: 'createdAt',
      label: 'Created Date',
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: 'text',
    },
    {
      id: '11',
      value: 'updatedAt',
      label: 'Updated Date',
      sort: false,
      editRecord: false,
      viewRecord: false,
      type: 'text',
    },
  ],
},
   //freelancer

   {
    schemaId: "ZnJlZWxh",
    name: 'freelancer',
    title: 'freelancer',
    path: '/manage-freelancer',
    visible: true,
    formTitle: 'freelancer',
    page: "ManageFrelancer",
    ...ZnJlZWxh, 
    exact: true,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: true,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow" >
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: true,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "shiftName",
        label: "Shift Name",
        placeholder: "Enter Shift Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.shiftName} </span>
          },
        type: "text",
      },
      {
        id: "5",
        value: "fromTiming",
        label: "From Timing",
        placeholder: "Enter From Timing",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "time",
      },
    
       {
        id: "6",
        value: "toTiming",
        label: "To Timing",
        placeholder: "Enter To Timing",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "time",
      },
       {
      id: '7',
      value: 'status',
      label: 'Status',
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          <Badge
            className={`font-size-12 badge rounded-pill ${
              row.status === 1
                ? 'bg-success badge-soft-success'
                : 'bg-danger badge-soft-danger'
            }`}
            color={row.badgeclass}
            pill
          >
            {row.status === 1 ? 'Active' : 'Inactive'}
          </Badge>
        ),
      type: 'text',
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
  {
    schemaId: "c2hpZnQ",
    name: "shift",
    title: "Work Shift",
    formTitle: "Work Shift",
    path: "/shift",
    visible: true,
    ...c2hpZnQ,
    page: "WorkShift",
    exact: true,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: true,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow" >
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: true,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "shiftName",
        label: "Shift Name",
        placeholder: "Enter Shift Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.shiftName} </span>
          },
        type: "text",
      },
      {
        id: "5",
        value: "fromTiming",
        label: "From Timing",
        placeholder: "Enter From Timing",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "time",
      },
    
       {
        id: "6",
        value: "toTiming",
        label: "To Timing",
        placeholder: "Enter To Timing",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "time",
      },
       {
      id: '7',
      value: 'status',
      label: 'Status',
      sort: false,
      editRecord: false,
      viewRecord: true,
      formatter: (cellContent, row) =>
        row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : (
          <Badge
            className={`font-size-12 badge rounded-pill ${
              row.status === 1
                ? 'bg-success badge-soft-success'
                : 'bg-danger badge-soft-danger'
            }`}
            color={row.badgeclass}
            pill
          >
            {row.status === 1 ? 'Active' : 'Inactive'}
          </Badge>
        ),
      type: 'text',
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
  {
    schemaId: "aHJtc19wb2xpY3lfc2V0dGluZw",
    name: "hrmsPolicySetting",
    title: "HRMS Policy Setting",
    formTitle: "HRMS Policy Setting",
    path: "/hrmspolicysetting",
    visible: true,
    ...aHJtc19wb2xpY3lfc2V0dGluZw,
    page: "HRPolicySetting",
    exact: true,
    columns: (record = {}) => {
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: '4',
          value: 'policyNo',
          label: 'Policy No',
          placeholder: 'Enter Policy No',
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          type: 'text',
        },
        {
          id: "6",
          value: "companyId",
          label: "Company",
          placeholder: "Select Company",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          type: "select",
          colProps: {
            lg: "12",
            md: "12",
            style: { paddingRight: "15px" },
          },
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (metaData &&
                metaData.companyOptions &&
                metaData.companyOptions.length > 0 &&
                metaData.companyOptions.find(
                  (_) => _.value.toString() === cellContent.toString()
                ) &&
                metaData.companyOptions.find((_) => _.value === cellContent)
                  .label) ||
              ""
            )
          },
          options: "companyOptions",
        },
        {
          id: "5",
          value: "year",
          label: "Year",
          placeholder: "Enter Year",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          colProps: {
            lg: "12",
            md: "12",
            style: {
              marginBottom: "10px"
            },
            className: "employee-input"
          },
          type: "number",
        },
        {
          id: "6",
          value: "sl",
          label: "Sick Leave",
          placeholder: "Enter Sick Leave",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          colProps: {
            lg: "12",
            md: "12",
            style: {
              marginBottom: "10px"
            },
            className: "employee-input"
          },
          type: "number",
        },
        {
          id: "7",
          value: "slCarry",
          label: "SL Carry",
          placeholder: "Enter Sick Leave Carry",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          type: "radio",
          options: [
            {
              label: "Yes",
              value: "Yes",
            },
            {
              label: "No",
              value: "No",
            },
          ],
        },
        {
          id: "8",
          value: "slBundle",
          label: "SL Bundle",
          placeholder: "Enter SL Bundle",
          sort: true,
          editRecord: record.slCarry === 'Yes' ? true : false,
          viewRecord: true,
          required: true,
          colProps: {
            lg: "12",
            md: "12",
            style: {
              marginBottom: "10px",
              marginTop: "-10px"
            },
            className: "employee-input"
          },
          type: "number",
        },
        {
          id: "9",
          value: "cl",
          label: "Casual Leave",
          placeholder: "Enter Casual Leave",
          sort: true,
          editRecord: record.slCarry === 'Yes' ? true : false,
          viewRecord: true,
          required: true,
          colProps: {
            lg: "12",
            md: "12",
            style: {
              marginBottom: "10px"
            },
            className: "employee-input"
          },
          type: "number",
        },
        {
          id: "10",
          value: "clCarry",
          label: "CL Carry",
          placeholder: "Enter Casual Leave Carry",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          type: "radio",
          options: [
            {
              label: "Yes",
              value: "Yes",
            },
            {
              label: "No",
              value: "No",
            },
          ],
        },
        {
          id: "11",
          value: "clBundle",
          label: "CL Bundle",
          placeholder: "Enter CL Bundle",
          sort: true,
          editRecord: record.clCarry === 'Yes' ? true : false,
          viewRecord: true,
          required: true,
          colProps: {
            lg: "12",
            md: "12",
            style: {
              marginBottom: "10px",
              marginTop: "-10px"
            },
            className: "employee-input"
          },
          type: "number",
        },
        {
          id: "12",
          value: "permissionPerMonth",
          label: "Permission Per Month",
          placeholder: "Enter Permission Per Month",
          sort: false,
          editRecord: record.clCarry === 'Yes' ? true : false,
          viewRecord: true,
          colProps: {
            lg: "12",
            md: "12",
            style: {
              marginBottom: "10px"
            },
            className: "employee-input"
          },
          type: "number",
        },
        {
          id: "13",
          value: "permissionCarry",
          label: "Permission Carry",
          sort: false,
          editRecord: true,
          viewRecord: true,
          type: "radio",
          options: [
            {
              label: "Yes",
              value: "Yes",
            },
            {
              label: "No",
              value: "No",
            },
          ],
        },
        {
          id: "14",
          value: "continuesPermission",
          label: "Joined permission",
          placeholder: "Enter Joined permission",
          sort: false,
          editRecord: true,
          viewRecord: false,
          required: true,
          colProps: {
            style: {
              marginTop: "-10px"
            },
            className: "employee-input"
          },
          type: "number",
        },
        {
          id: "15",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
      ]
    }
  },
  {
    schemaId: "aHJfcmVxdWVzdA",
    name: "hr_request",
    title: "Employee Default Setting",
    formTitle: "Employee Default Setting",
    path: "/hr_request",
    visible: true,
    ...aHJfcmVxdWVzdA,
    page: "HRRequestType",
    exact: true,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "requestName",
        label: "Request Name",
        placeholder: "Enter Request Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.requestName} </span>
          },
        type: "text",
      },
      {
        id: "5",
        value: "requestValue",
        label: "Duration(Hours)",
        placeholder: "Enter Request Value",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        colProps: {
          className: "employee-input",
        },
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.requestValue} </span>
          },
        type: "number",
      },
      {
        id: "6",
        value: "description",
        label: "Description",
        placeholder: "Enter Description",
        sort: true,
        editRecord: true,
        viewRecord: true,
        colProps: {
           style: {
            marginTop: "10px"
          }
        },
        required: true,
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.description} </span>
          },
        type: "text",
      },
      {
        id: "7",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${
                row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
              }`}
              color={row.badgeclass}
              pill
            >
              {row.status ===1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
    ],
  },
  {
    schemaId: "ZW1wbG95ZWVfdHlwZQ",
    name: "employee_type",
    title: "Employee Type",
    path: "/employee_type",
    visible: true,
    formTitle: "Employee Type",
    page: "EmployeeType",
    ...ZW1wbG95ZWVfdHlwZQ,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "employeeType",
          label: "Employee Type",
          placeholder: "Enter Employee Type",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return <span style={{textTransform: "uppercase"}}>{row.employeeType} </span>
            },
          type: "textOnly",
          validations: "textOnly"
        },
        {
          id: "5",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Code",
          placeholder: "Enter Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          formatter: (cellContent, row) => {
            return <span style={{textTransform: "uppercase"}}>{row.code} </span>
            },
          // required: true,
          type: "code",
        },
        {
          id: "6",
          value: "description",
          label: "Description",
          placeholder: "Enter Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          formatter: (cellContent, row) => {
            return <span style={{textTransform: "uppercase"}}>{row.description} </span>
            },
          required: true,
          type: "text",
        },
        {
          id: "7",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "dmVuZG9y",
    name: "vendor",
    title: "Vendor",
    path: "/manage-vendor",
    visible: true,
    formTitle: "Vendor",
    page: "ManageVendor",
    ...dmVuZG9y,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Department Code",
          placeholder: "Enter Department Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.code}
              </span>)
          },
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Department Name",
          placeholder: "Enter Department Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  {
    schemaId: "b80a3d64",
    name: "designation",
    title: "Designation List",
    path: "/designation",
    visible: true,
    formTitle: "Designation List",
    page: "Designation",
    ...b80a3d64,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "departmentId",
          label: "Department",
          placeholder: "Select Department",
          sort: true,
          editRecord: true,
          viewRecord: false,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.departmentName}
              </span>)
          },
          type: "select",
          options: "departmentOptions",
        },
        {
          id: "4",
          value: "departmentName",
          label: "Department",
          placeholder: "Select Department",
          sort: true,
          editRecord: false,
          viewRecord: true,
          required: true,
        },
        {
          id: "6",
          value: "code",
          autofillValue: codeValueMetaData,
          label: "Designation Code",
          placeholder: "Enter Designation Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          type: "code",
        },
        {
          id: "5",
          value: "name",
          label: "Designation Name",
          placeholder: "Enter Designation Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.name}
              </span>)
          },
          required: true,
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "7",
          value: "isPhotographer",
          label: "Is Photographer",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: false,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.isPhotographer == 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.isPhotographer == 1 ? "YES" : "NO"}
              </Badge>
            ),
          type: "checkbox",
        },
        {
          id: "7",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  {
    schemaId: "c4ddb684",
    name: "role",
    title: "Role List",
    formTitle: "Role List",
    path: "/userrole",
    visible: true,
    ...c4ddb684,
    page: "Role",
    exact: true,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        formatterStyle: { width: "100%" },
        type: "text",
      },
      {
        id: "4",
        value: "name",
        label: "Role Name",
        placeholder: "Enter Role Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        style: { width: "20%" },
        type: "text",
      },
      {
        id: "5",
        value: "shortName",
        label: "Code",
        placeholder: "Enter Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        style: { width: "20%" },
        type: "text",
      },
      {
        id: "6",
        value: "mode",
        label: "Mode",
        placeholder: "Enter Mode",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "radio",
        options: [
          {
            label: "Primary User",
            value: "primary",
          },
          {
            label: "Secondary User",
            value: "secondary",
          },
        ],
      },
      {
        id: "7",
        value: "description",
        label: "Description",
        placeholder: "Enter Description",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        style: { width: "40%" },
        type: "textarea",
      },
      {
        id: "8",
        value: "permission",
        label: "Permission",
        placeholder: "Enter Permission",
        editRecord: true,
        viewRecord: false,
        type: "customTable",
      },
      {
        id: "9",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "10",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "12",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "13",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
  {
    schemaId: "d9024f94",
    name: "access",
    title: "Access List",
    formTitle: "Access List",
    path: "/access",
    visible: true,
    ...d9024f94,
    page: "Access",
    exact: true,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "4",
        value: "accessName",
        label: "Access Name",
        placeholder: "Enter Access Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          console.log(row, "row from api")
          return (
            <>
              <p style={{ textTransform: "uppercase" }}>{row.accessName}</p>
            </>
          )},
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "5",
        value: "accessDescription",
        label: "Access Description",
        placeholder: "Enter Access Description",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          console.log(row, "row from api")
          return (
            <>
              <p style={{ textTransform: "uppercase" }}>{row.accessDescription}</p>
            </>
          )},
        type: "textOnly",
        validations: "textOnly",
      },
      {
        id: "6",
        value: "isDefault",
        label: "Is Default",
        editRecord: true,
        viewRecord: true,
        formatter:(cellContent, row)=>{
          return(<><span >{row.isDefault === true ? "YES" : "NO"}</span> </>)
          },  
        type: "checkbox",
      },
      {
        id: "7",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
  {
    schemaId: "bfa4b9a6",
    name: "menu",
    title: "Menu List",
    formTitle: "Menu List",
    path: "/menu",
    visible: true,
    ...bfa4b9a6,
    page: "Menu",
    exact: true,
    columns: (record = {}, metaData = {}) => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: false,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Action",
        sort: false,
        editRecord: false,
        viewRecord: false,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "3",
        value: "menuType",
        label: "Menu Type",
        placeholder: "Enter Menu Type",
        sort: true,
        editRecord: true,
        viewRecord: false,
        required: true,
        type: "select",
        options: [
          {
            label: "Menu Header",
            value: "menuHeader",
          },
          {
            label: "Menu Sub Header",
            value: "menuSubHeader",
          },
          {
            label: "Menu Item",
            value: "menuItem",
          },
        ],
      },
      {
        id: "4",
        value: "menuReferenceId",
        label: "Header Menu",
        placeholder: "Select Header Menu",
        sort: true,
        editRecord:
          record.menuType && record.menuType === "menuSubHeader" ? true : false,
        viewRecord: false,
        required: true,
        type: "select",
        options: "menuHeaderOptions",
      },
      {
        id: "5",
        value: "menuReferenceId",
        label: "Sub Header Menu",
        placeholder: "Select Sub Header Menu",
        sort: true,
        editRecord:
          record.menuType && record.menuType === "menuItem" ? true : false,
        viewRecord: false,
        required: true,
        type: "select",
        options: "menuSubHeaderOptions",
      },
      {
        id: "6",
        value: "menuName",
        label: "Menu Name",
        placeholder: "Enter Menu Name",
        sort: true,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },
        type: "text",
      },
      {
        id: "7",
        value: "menukey",
        label: "Menu Key",
        placeholder: "Enter Menu Key",
        sort: true,
        editRecord: true,
        viewRecord: false,
        required: true,
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },
        type: "text",
      },
      {
        id: "8",
        value: "accMain",
        label: "Access Main",
        placeholder: "Enter Access Main",
        sort: true,
        editRecord: false,
        viewRecord: false,
        type: "checkbox",
      },
      {
        id: "9",
        value: "isNew",
        label: "Is New",
        placeholder: "Enter Access Main",
        sort: true,
        editRecord: true,
        viewRecord: false,
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },
        type: "checkbox",
      },
      {
        id: "10",
        value: "tagname",
        label: "Tag Name",
        placeholder: "Enter Tag Name",
        sort: true,
        editRecord: record.isNew ? true : false,
        defaultValue: "New",
        viewRecord: false,
        colProps: {
          lg: "6",
          md: "6",
          style: { paddingRight: "15px" },
        },
        type: "text",
      },
      {
        id: "11",
        value: "access",
        label: "Menu Permission",
        placeholder: "Enter Menu Permission",
        sort: true,
        editRecord: true,
        viewRecord: false,
        type: "multiSelect",
        options: "accessOptions",
      },
      {
        id: "11",
        value: "sequence",
        label: "Sequence",
        placeholder: "Enter Sequence",
        sort: true,
        editRecord: false,
        viewRecord: false,
        disabled: true,
        required: true,
        colProps: {
          className: "employee-input"
        },
        defaultValue:
          (metaData &&
            metaData.menuCount &&
            record &&
            record.menuType &&
            metaData.menuCount[record.menuType] + 1) ||
          1,
        type: "number",
      },
      {
        id: '16',
        value: 'menuMode',
        label: 'Mode Type',
        placeholder: 'Enter Mode Type',
        sort: true,
        editRecord: true,
        viewRecord: false,
        required: true,
        type: 'select',
        options: [
          {
            label: 'Menu',
            value: 'Menu',
          },
          {
            label: 'Page',
            value: 'Page',
          },

        ],
      },
      {
        id: "12",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "13",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "14",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "15",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
  {
    schemaId: "ca3b000f",
    name: "unassignedlead",
    title: "New Lead",
    formTitle: "New Lead",
    path: "/unassigned-lead",
    visible: true,
    ...ca3b000f,
    page: "UnassignedLead",
    className: "lead-counter",
    enableTableFilter: true,
    grid: [
      {
        id: 1,
        component: LeadHeader,
      },
      {
        id: 2,
        component: "Counter",
        onLoad: async (filterData) => {
          return await api
            .post("/get_lead_count_by_status_new", filterData)
            .then((response) => response.data && response.data.data)
            .catch((error) => Promise.reject(error))
        },
        columns: () => [
          {
            id: "1",
            filterId: "PS1",
            value: "unassigned",
            label: "Unassigned",
            customLabel: "Unassigned - Today and Overall",
            editRecord: false,
            viewRecord: true,
            getValues: (records) => {
              return (records || [])
                .filter(
                  (s) =>
                    s._id &&
                    s._id.processStatus &&
                    s._id.processStatus === "PS1"
                )
                .reduce(
                  (a, el) =>
                    Object.assign({}, a, {
                      todayLead: parseInt(a.todayLead) + parseInt(el.todayLead),
                      totalLead: parseInt(a.totalLead) + parseInt(el.totalLead),
                    }),
                  { todayLead: 0, totalLead: 0 }
                )
            },
            colProps: {
              lg: 4,
            },
            cardStyle: {
              backgroundColor: "#F1B54C",
              marginBottom: "0px",
              display: "inline-block",
              width: "100%",
            },
            type: "text",
          },
          {
            id: "2",
            filterId: "PS19",
            value: "saleUrge",
            label: "Sale Urge",
            customLabel: "Sale Urge - HOT / WARM / COLD  - Today and Overall",
            editRecord: false,
            viewRecord: true,
            getValues: (records) => {
              return (records || [])
                .filter(
                  (s) =>
                    s._id &&
                    s._id.processStatus &&
                    s._id.processStatus === "PS19"
                )
                .reduce(
                  (a, el) =>
                    Object.assign({}, a, {
                      todayLead: parseInt(a.todayLead) + parseInt(el.todayLead),
                      totalLead: parseInt(a.totalLead) + parseInt(el.totalLead),
                    }),
                  { todayLead: 0, totalLead: 0 }
                )
            },
            colProps: {
              lg: 4,
            },
            cardStyle: {
              backgroundColor: "#34C28F",
              marginBottom: "0px",
              display: "inline-block",
              width: "100%",
            },
            type: "text",
          },
          {
            id: "3",
            filterId: "PS20",
            value: "leadSource",
            label: "Lead Source",
            customLabel: "Lead Source - Today and Overall",
            editRecord: false,
            viewRecord: true,
            getValues: (records) => {
              return (records || [])
                .filter(
                  (s) =>
                    s._id &&
                    s._id.processStatus &&
                    s._id.processStatus === "PS20"
                )
                .reduce(
                  (a, el) =>
                    Object.assign({}, a, {
                      todayLead: parseInt(a.todayLead) + parseInt(el.todayLead),
                      totalLead: parseInt(a.totalLead) + parseInt(el.totalLead),
                    }),
                  { todayLead: 0, totalLead: 0 }
                )
            },
            colProps: {
              lg: 4,
            },
            cardStyle: {
              backgroundColor: "#353A40",
              marginBottom: "0px",
              display: "inline-block",
              width: "100%",
            },
            type: "text",
          },
        ],
      },
      {
        id: 3,
        component: "DynamicFilter",
        onSubmit: ({ dispatch, actions, submitData, setSubmitting }) => {
          console.log(submitData, "submitData")
          dispatch(
            actions.loadRecords(
              Object.assign({}, submitData),
              true
            )
          )
          setTimeout(() => {
            setSubmitting(false)
          }, 3000)
        },
        initialValues: {
          status: "active",
          id: "",
          mobileNo: "",
          leadType: "",
          companyId: "",
          branchId: "",
          priorityStatusId: "",
          processStatusId: "",
          leadServiceId: "",
          leadSourceId: "",
          leadSubSourceId: "",
          employeeId: "",
        },
        columns: (record = {}, metaData) => {
          const branchOptions =
            record &&
              record.companyId &&
              metaData &&
              Object.keys(metaData).length > 0 &&
              metaData.branchOptions &&
              metaData.branchOptions.length > 0
              ? metaData.branchOptions.filter(
                (_) => _.companyId.toString() === record.companyId.toString()
              )
              : metaData &&
                Object.keys(metaData).length > 0 &&
                metaData.branchOptions &&
                metaData.branchOptions.length > 0
                ? metaData.branchOptions
                : []
          const serviceOptions =
            record &&
              record.companyId &&
              metaData &&
              Object.keys(metaData).length > 0 &&
              metaData.serviceOptions &&
              metaData.serviceOptions.length > 0
              ? metaData.serviceOptions.filter((_) =>
                _.companyId.includes(record.companyId)
              )
              : metaData &&
                Object.keys(metaData).length > 0 &&
                metaData.serviceOptions &&
                metaData.serviceOptions.length > 0
                ? metaData.serviceOptions
                : []

          return [
            {
              id: "1",
              value: "_id",
              label: "Id",
              editRecord: false,
              viewRecord: false,
              type: "text",
            },
            {
              id: "2",
              value: "companyId",
              label: "Company",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "filterMultiSelect",
              options: "companyOptions",
            },
            {
              id: "3",
              value: "branchId",
              label: "Branch",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "filterMultiSelect",
              options: branchOptions,
            },
            {
              id: "4",
              value: "salesUrge",
              label: "Sales Urge",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "filterSelect",
              options: [
                {
                  label: "hot",
                  value: "hot",
                },
                {
                  label: "warm",
                  value: "warm",
                },
                {
                  label: "cold",
                  value: "cold",
                },
              ],
            },
            {
              id: "5",
              value: "salesAgent",
              label: "Sales Agent Name",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "text",
            },
            {
              id: "6",
              value: "leadServiceId",
              label: "Service",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "filterSelect",
              options: serviceOptions,
            },
            {
              id: "7",
              value: "leadSourceId",
              label: "Source",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "filterSelect",
              options: "sourceOptions",
            },
            {
              id: "10",
              value: "leadNo",
              label: "Lead No",
              editRecord: true,
              viewRecord: false,
              placeholder: "Enter Lead No",
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "text",
            },
            {
              id: "8",
              value: "leadFromDate",
              label: "Lead From Date",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "date",
            },
            {
              id: "9",
              value: "leadToDate",
              label: "Lead To Date",
              editRecord: true,
              viewRecord: false,
              colProps: {
                lg: "3",
                md: "6",
                className: "filter-field",
              },
              type: "date",
            },
            {
              id: "10",
              value: "status",
              label: "Status",
              editRecord: false,
              viewRecord: false,
              type: "text",
            },
          ]
        },
      },
    ],
    submitButton: ({
      values,
      setFieldValue,
      handleSubmit,
      submitBtnText,
      isSubmitting,
    }) => {
      return values &&
      (values.primaryMobileConfirm ||
        values.secondaryMobileConfirm ||
        values.whatsAppNoConfirm) ? (
        <ConfirmButton
          body={
            "This lead already exists, would you like to create this lead under the existing lead?"
          }
          closeBtnText="No"
          confirmBtnText="Yes"
          disableCloseBtn
          buttonLayout={({ updateState }) => {
            return (
              <React.Fragment>
                <button
                  type="button"
                  style={{ height: "46px" }}
                  className="btn btn-primary"
                  onClick={() => {
                    updateState({ openDialog: false })
                  }}
                >
                  {"Cancel"}
                </button>
                <button
                  type="button"
                  style={{ height: "46px" }}
                  className="btn btn-light"
                  onClick={() => {
                    updateState({ openDialog: false })
                    setFieldValue("isRequiredNewClientEntry", true)
                    // setFieldValue("clientId", "")
                    // handleSubmit()
                  }}
                >
                  {"No"}
                </button>
                <button
                  type="button"
                  style={{ height: "46px" }}
                  className="btn btn-primary"
                  onClick={() => {
                    updateState({ openDialog: false })
                    setFieldValue("isRequiredNewClientEntry", false)
                    handleSubmit()
                  }}
                >
                  {"Yes"}
                </button>
              </React.Fragment>
            )
          }}
        >
          {(open) => (
            <button
              key={"showConfirm"}
              id="showConfirm"
              disabled={isSubmitting}
              type="button"
              onClick={open}
              className="btn btn-success btn-label simple-form-submit-btn"
            >
              <i className="bx bx-check-double label-icon"></i>
              {isSubmitting ? <ButtonSpinner /> : submitBtnText || "Submit"}
            </button>
          )}
        </ConfirmButton>
      ) : (
        <button
          type="submit"
          disabled={isSubmitting}
          onClick={() => handleSubmit()}
          className="btn btn-success btn-label simple-form-submit-btn"
        >
          <i className="bx bx-check-double label-icon"></i>
          {isSubmitting ? <ButtonSpinner /> : submitBtnText || "Submit"}
        </button>
      )
    },
    onSubmitValues: (data) => {
      console.log(data, "data")
      var today = new Date()
      const time = today.getFullYear() + '-' +
        ((today.getMonth() + 1) < 10 ? '0' + (today.getMonth() + 1) : (today.getMonth() + 1)) + '-' +
        (today.getDate() < 10 ? '0' + today.getDate() : today.getDate()) + ' ' +
        (today.getHours() < 10 ? '0' + today.getHours() : today.getHours()) + ':' +
        (today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()) + ':' +
        (today.getSeconds() < 10 ? '0' + today.getSeconds() : today.getSeconds())
      console.log(time, "time")
      const modifyData = data
      modifyData.leadType = "wedding"
      modifyData.companyId = data.companyId || ""
      modifyData.branchId = data.branchId || ""
      modifyData.leadSourceId = data.leadSourceId || ""
      modifyData.leadSubSourceId = "" || data.leadSubSourceId
      modifyData.leadServiceId = data.leadServiceId || ""
      modifyData.eventId = "61f0149ed6a0f0d4716e2b9b"
      modifyData.descriptions = data.descriptions || ""
      modifyData.customField = data.customField || []
      modifyData.priorityStatusId = data.priorityStatusId || ""
      modifyData.processStatus = {
        id: "620be8a53f52687300b1f3fe",
        statusName: "open",
      }
      modifyData.crossPromotion = data.crossPromotion || []
      modifyData.isRequiredNewClientEntry =
        data.isRequiredNewClientEntry === undefined
          ? true
          : data.isRequiredNewClientEntry || false
      modifyData.leadNo = data.leadNo || ""
      modifyData.leadDate = time || ""
      modifyData.clientDetails = {
        firstName: data.firstName || "",
        lastName: data.lastName || "",
        contact: {
          primaryMobile: {
            // code: data.primaryMobile && data.primaryMobile inputValue.data.dialCode,
            //code:  data.primaryMobile.substr(-10),
            // number:  data.primaryMobile,
            code :data.primaryMobile&& data.primaryMobile.length === 10 ? "+"+data.primaryMobile.slice(0,-8):data.primaryMobile.length === 12 ? "+"+data.primaryMobile.slice(0,-10):data.whatsAppNo.length === 11 ? "+"+data.primaryMobile.slice(0,-10):data.primaryMobile.length === 14 ? "+"+data.primaryMobile.slice(0,-12):data.primaryMobile.length === 15 ? "+"+data.primaryMobile.slice(0,-12):"",
             number:  data.primaryMobile&& data.primaryMobile.length ===12 ? data.primaryMobile.slice(2):data.primaryMobile.length ===11 ? data.primaryMobile.slice(1):data.whatsAppNo.length ===10 ? data.primaryMobile.slice(2):data.primaryMobile.length ===14 ? data.primaryMobile.slice(2):data.primaryMobile.length ===15 ? data.primaryMobile.slice(3): "",
           }, 
          
           secondaryMobile: "" || {
             code :data.secondaryMobile&& data.secondaryMobile.length === 10 ? "+"+data.secondaryMobile.slice(0,-8):data.secondaryMobile.length === 12 ? "+"+data.secondaryMobile.slice(0,-10):data.secondaryMobile.length === 11 ? "+"+data.secondaryMobile.slice(0,-10):data.secondaryMobile.length === 14 ? "+"+data.secondaryMobile.slice(0,-12):data.secondaryMobile.length === 15 ? "+"+data.secondaryMobile.slice(0,-12):"",
              //code :data.secondaryMobile&& data.secondaryMobile.length > 10 ? data.secondaryMobile.slice(0,-11):data.secondaryMobile.slice(0,-10),
             //code: "" || data.secondaryMobile !== "undefined" ? data.secondaryMobile.slice(0,-10) : "",
             number:  data.secondaryMobile&& data.secondaryMobile.length ===12 ? data.secondaryMobile.slice(2):data.secondaryMobile.length ===11 ? data.secondaryMobile.slice(1):data.secondaryMobile.length ===10 ? data.secondaryMobile.slice(2):data.secondaryMobile.length ===14 ? data.secondaryMobile.slice(2):data.secondaryMobile.length ===15 ? data.secondaryMobile.slice(3): "",
 
     
            },
           whatsAppNo: {
            
              code :data.whatsAppNo&& data.whatsAppNo.length === 10 ? "+"+data.whatsAppNo.slice(0,-8):data.whatsAppNo.length === 12 ? "+"+data.whatsAppNo.slice(0,-10):data.whatsAppNo.length === 11 ? "+"+data.whatsAppNo.slice(0,-10):data.whatsAppNo.length === 14 ? "+"+data.whatsAppNo.slice(0,-12):data.secondaryMobile.length === 15 ? "+"+data.whatsAppNo.slice(0,-12):"",
             number:data.whatsAppNo&& data.whatsAppNo.length ===12 ? data.whatsAppNo.slice(2):data.whatsAppNo.length ===11 ? data.whatsAppNo.slice(1):data.whatsAppNo.length ===10 ? data.whatsAppNo.slice(2):data.whatsAppNo.length ===14 ? data.whatsAppNo.slice(2):data.whatsAppNo.length ===15 ? data.whatsAppNo.slice(3): "",
         },
        },
        clientLocation: data.clientLocation || "",
        emailId: data.emailId || "",
        address: {
          primary: data.primaryAddress || "",
          secondary: data.primaryAddress || "",
        },
        city: "" || data.city,
        state: "" || data.state,
        country: "" || data.country,
        pincode: data.pincode || "",
      }
      modifyData.clientProfileRemarks = data.clientProfileRemarks || ""
      modifyData.clientProfile = data.clientProfile || ""
      modifyData.salesUrge = data.salesUrge || ""
      modifyData.clientId = data.clientId || ""
      modifyData.attachment = data.attachment || ""
      return modifyData
    },
    exact: true,
    initialValues:{
      companyId:"",
      branchId:"",
      leadServiceId:"",
      leadSourceId:"",
      firstName:"",
      saleSurge:"",
      clientProfile:"",
      primaryMobile:"",
      secondaryMobile:"",
      whatsAppNo:"",
      priorityStatusId:""
  
      },
    columns: (record = {}, metaData) => {
      const branchOptions =
        record &&
          record.companyId &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.branchOptions &&
          metaData.branchOptions.length > 0
          ? metaData.branchOptions.filter(
            (_) => _.companyId.toString() === record.companyId.toString()
          )
          : metaData &&
            Object.keys(metaData).length > 0 &&
            metaData.branchOptions &&
            metaData.branchOptions.length > 0
            ? metaData.branchOptions
            : []
      const serviceOptions =
        record &&
          record.companyId &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.serviceOptions &&
          metaData.serviceOptions.length > 0
          ? metaData.serviceOptions.filter((_) =>
            _.companyId.includes(record.companyId)
          )
          : metaData &&
            Object.keys(metaData).length > 0 &&
            metaData.serviceOptions &&
            metaData.serviceOptions.length > 0
            ? metaData.serviceOptions
            : []
      const subSourceOptions =
        record &&
          record.leadSourceId &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.subSourceOptions &&
          metaData.subSourceOptions.length > 0
          ? metaData.subSourceOptions.filter(
            (_) => _.sourceId.toString() === record.leadSourceId.toString()
          )
          : metaData &&
            Object.keys(metaData).length > 0 &&
            metaData.subSourceOptions &&
            metaData.subSourceOptions.length > 0
            ? metaData.subSourceOptions
            : []
            const selCountry =
            record &&
              record.country &&
              metaData &&
              Object.keys(metaData).length > 0 &&
              metaData.countryOptions &&
              metaData.countryOptions.length > 0
              ? metaData.countryOptions.find(
                (c) => c.value !== undefined ? c.value.toString() === record.country.toString() : []
              )
              : metaData &&
                Object.keys(metaData).length > 0 &&
                metaData.countryOptions &&
                metaData.countryOptions.length > 0
              ? metaData.countryOptions
              : []
            const cityOptions =
            record &&
              record.state &&
              metaData &&
              Object.keys(metaData).length > 0 &&
              metaData.cityOptions &&
              metaData.cityOptions.length > 0
              ? metaData.cityOptions.filter(
                (c) => c.stateId !== undefined ? c.stateId.toString() === record.state.toString() : []
              )
              : metaData &&
                Object.keys(metaData).length > 0 &&
                metaData.cityOptions &&
                metaData.cityOptions.length > 0
                ? metaData.cityOptions
                : []
      const customFieldOptions =
        record &&
          record.leadServiceId &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.customFieldOptions &&
          metaData.customFieldOptions.length > 0
          ? metaData.customFieldOptions.filter(
            (c) => c.serviceId.toString() === record.leadServiceId.toString()
          )
          : []
      const companyTableOptions =
        record &&
          record.companyId &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.companyTableOptions &&
          metaData.companyTableOptions.length > 0
          ? metaData.companyTableOptions.filter(
            (c) => c._id.toString() !== record.companyId.toString()
          )
          : metaData &&
            Object.keys(metaData).length > 0 &&
            metaData.serviceOptions &&
            metaData.serviceOptions.length > 0
            ? metaData.serviceOptions
            : []
      // const [checked, setChecked] = useState(false)
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: true,
          editRecord: false,
          viewRecord: false,
          colProps: {
            lg: "6",
            md: "6",
            style: { paddingRight: "15px" },
          },
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          colProps: {
            lg: "6",
            md: "6",
            style: { paddingRight: "15px" },
          },
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Action",
          sort: false,
          editRecord: false,
          viewRecord: true,
          customDeleteBtn: ({ openDialog, record = {} }) => {
            const status =
              (record &&
                record.processStatus &&
                record.processStatus.processStatus) ||
              false
            return (
              <button
                onClick={openDialog}
                disabled={status && status === "Unassigned" ? false : true}
                type="button"
                className="btn btn-danger delete-table-btn"
              >
                <i className="mdi mdi-trash-can d-block font-size-16"></i>
              </button>
            )
          },
          formatterStyle: { width: "100%" },
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "leadNo",
          label: "Lead No",
          placeholder: "Enter Lead No",
          sort: true,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) => {
            console.log(row.processStatus.processStatusId, "process status")
            return (
              <div>
                <Link
                  to={{ pathname: `client-details/${row._id}`, state: { row } }}
                  className={row.processStatus.processStatusId === "PS1" ? "disabled-button" : ""}
                  style={{ textTransform: "uppercase" }}
                >
                  {row.leadNo}
                </Link>
                {row.processStatus.processStatusId === "PS1" ?
                  <>
                    <i
                      style={{ color: "grey" }}
                      id="quoteInfo"
                      aria-hidden="true"
                      className="fa fa-info-circle ms-1"
                    ></i>
                    <UncontrolledTooltip placement="right" target="quoteInfo">
                      This lead is unassigned. Please change the process status, to enable the leadNo.
                    </UncontrolledTooltip>
                  </> : ""}
              </div>
            )
          },
          type: "text",
        },
        {
          id: "5",
          value: "leadType",
          label: "Lead Type",
          placeholder: "Enter Lead Type",
          sort: true,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "6",
          value: "companyId",
          label: "Company",
          placeholder: "Select Company",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          colProps: {
            lg: "4",
            md: "4",
            style: {
              borderTop: "2px solid #eff2f7",
              borderLeft: "2px solid #eff2f7",
              borderTopLeftRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row) => {
            return (<span style={{textTransform: "uppercase"}}>{row.companyName}</span>
             
            )
          },
          type: "select",
          options: "companyOptions",
        },
        {
          id: "7",
          value: "branchId",
          label: "Branch",
          placeholder: "Select Branch",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          colProps: {
            lg: "4",
            md: "4",
            style: {
              borderTop: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row) => {
            return (<span style={{textTransform: "uppercase"}}>{row.branchName}</span>
             
            )
          },
          type: "select",
          options: branchOptions,
        },
        {
          id: "8",
          value: "leadServiceId",
          label: "Service",
          placeholder: "Select Lead Service",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          colProps: {
            lg: "4",
            md: "4",
            style: {
              borderTop: "2px solid #eff2f7",
              borderRight: "2px solid #eff2f7",
              borderTopRightRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row) => {
            return (
            <span style={{textTransform: "uppercase"}}>{row.leadServiceName}</span>
            )
          },
          type: "select",
          options: serviceOptions,
        },
        {
          id: "9",
          value: "leadSourceId",
          label: "Source",
          placeholder: "Select Lead Source",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          colProps: {
            lg: "4",
            md: "4",
            style: {
              borderLeft: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row) => {
            return (
              <span style={{textTransform: "uppercase"}}>{row.leadSourceName}</span>
              )
          },
          type: "select",
          options: "sourceOptions",
        },
        {
          id: "10",
          value: "leadSubSourceId",
          label: "Sub Source",
          placeholder: "Select Lead Sub Source",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "4",
            md: "4",
            style: {
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row) => {
            return (
              <span style={{textTransform: "uppercase"}}>{row.leadSubSourceName}</span>
              )
          },
          type: "select",
          options: subSourceOptions,
        },
        {
          id: "11",
          value: "clientName",
          label: "Client",
          sort: true,
          editRecord: false,
          viewRecord: true,
          formatter: (cell, row) => {
            return (
              <div>{`${(row && row.clientDetails && row.clientDetails.firstName) || ""
                } ${(row && row.clientDetails && row.lastName) || ""}`}</div>
            )
          },
          type: "text",
        },
        {
          id: "12",
          value: "leadStatus",
          label: "Lead Assign",
          sort: true,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex, metaData, actions) => {
            const cellColorCode =
              metaData &&
              Object.keys(metaData).length > 0 &&
              metaData.processStatusOptions &&
              metaData.processStatusOptions.length > 0 &&
              metaData.processStatusOptions.find(
                (_) =>
                  row &&
                  row.processStatus &&
                  row.processStatus.processStatusId &&
                  _.value.toString() ===
                  row.processStatus.processStatusId.toString()
              ) &&
              metaData.processStatusOptions.find(
                (_) =>
                  row &&
                  row.processStatus &&
                  row.processStatus.processStatusId &&
                  _.value.toString() ===
                  row.processStatus.processStatusId.toString()
              ).colorCode
            return (
              <LeadStatus
                btnStyle={{ padding: "6px" }}
                colorCode={cellColorCode}
                cellContent={cellContent}
                row={row}
                rowIndex={rowIndex}
                metaData={metaData}
                actions={actions}
              />
            )
          },
          type: "text",
        },
        {
          id: "13",
          value: "salesUrge",
          label: "Sales Urge",
          placeholder: "Select Sales Urge",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          width: 80,
          colProps: {
            lg: "4",
            md: "4",
            style: {
              borderRight: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (val) => (
            <div style={{ display: "flex", flexWrap: "wrap" }}>{val}</div>
          ),
          type: "select",
          options: [
            {
              label: "hot",
              value: "hot",
            },
            {
              label: "warm",
              value: "warm",
            },
            {
              label: "cold",
              value: "cold",
            },
          ],
        },
        {
          id: "14",
          value: "clientProfile",
          label: "Client Profile",
          placeholder: "Select Client Profile",
          sort: true,
          editRecord: true,
          viewRecord: false,
          required: false,
          colProps: {
            lg: "4",
            md: "4",
            style: {
              borderLeft: "2px solid #eff2f7",
              borderBottom: "2px solid #eff2f7",
              borderBottomLeftRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
            },
          },
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.clientProfileOptions &&
                metaData.clientProfileOptions.length > 0 &&
                metaData.clientProfileOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.clientProfileOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: "clientProfileOptions",
        },
        {
          id: "15",
          value: "clientProfileRemarks",
          label: "Client Profile Remarks",
          placeholder: "Enter Profile Remarks",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "4",
            md: "4",
            style: {
              borderBottom: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
            },
          },
          type: "text",
        },
        {
          id: "16",
          value: "attachment",
          label: "Media Attachment",
          placeholder: "Choose Media Attachment",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "4",
            md: "4",
            style: {
              borderBottom: "2px solid #eff2f7",
              borderRight: "2px solid #eff2f7",
              borderBottomRightRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
            },
          },
          type: "upload",
        },
        {
          id: "17",
          value: "firstName",
          label: "First Name",
          placeholder: "Enter First Name",
          sort: true,
          editRecord: true,
          viewRecord: false,
          required: true,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderTop: "2px solid #eff2f7",
              borderLeft: "2px solid #eff2f7",
              borderTopLeftRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          type: "text",
        },
        {
          id: "18",
          value: "lastName",
          label: "Last Name",
          placeholder: "Enter Last Name",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderTop: "2px solid #eff2f7",
              borderRight: "2px solid #eff2f7",
              borderTopRightRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              width: "24%",
              marginRight: "auto",
              paddingBottom: "0px",
            },
            className: "",
          },
          type: "text",
        },
        {
          id: "19",
          value: "clientLocation",
          label: "Client Location",
          placeholder: "Enter Client Location",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderTop: "2px solid #eff2f7",
              borderLeft: "2px solid #eff2f7",
              borderTopLeftRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          type: "text",
        },
        {
          id: "20",
          value: "primaryMobile",
          label: "Primary No",
          placeholder: "Enter Primary No",
          sort: true,
          editRecord: true,
          viewRecord: false,
          required: true,
          onInputChange: ({ inputValue, setFieldValue }) => {
            const obj = inputValue.val
            // const value = inputValue.val&& inputValue.val.length ===12 ? inputValue.val.slice(2):inputValue.val.length ===11 ? inputValue.val.slice(1):inputValue.val.length ===10 ? inputValue.val.slice(2):inputValue.val.length ===14 ? inputValue.val.slice(2):inputValue.val.length ===15 ? inputValue.val.slice(3): ""
            console.log(obj, "Response")
            api
              .post("/get_client", {
                status: "active",
                id: "",
                mobileNo: obj ? "+" + obj : [],
              })
              .then((res) => {
                console.log(res, "response")
                if (
                  res &&
                  res.data &&
                  res.data.data &&
                  res.data.data.length > 0
                ) {
                  setFieldValue("primaryMobileConfirm", true)
                  setFieldValue(
                    "clientId",
                    res.data.data && res.data.data[0] && res.data.data[0]._id
                  )
                } else {
                  setFieldValue("primaryMobileConfirm", false)
                }
              })
              .catch(() => {
                setFieldValue("primaryMobileConfirm", false)
              })
          },
          prefix: ({ setFieldValue }) => {
            return (
              <div
                style={{ display: "flex", alignItems: "center", width: "32px" }}
              >
                <input
                  type="checkbox"
                  id="check1"
                  onClick={(e) =>{
                    if(  e.target.checked){
                      setFieldValue("whatsAppNo", record.primaryMobile)
                      document.getElementById('check2').checked=false
                    }
                  else{
                    setFieldValue("whatsAppNo","")
                  }}
                   
                }
              
                ></input>
              </div>
            )
          },
          defaultCountry: (selCountry && selCountry.shortName) || "IN",
          //defaultValue: record && record.primaryMobile && record.primaryMobile.toString() && `+${record.primaryMobile.toString()}` || '',
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderTop: "2px solid #eff2f7",
              borderRight: "2px solid #eff2f7",
              borderTopRightRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          type: "phone",
        },
        {
          id: "21",
          value: "country",
          label: "Country",
          placeholder: "Enter Country",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderLeft: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.countryOptions &&
                metaData.countryOptions.length > 0 &&
                metaData.countryOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.countryOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: "countryOptions",
        },
        {
          id: "22",
          value: "state",
          label: "State",
          placeholder: "Enter State",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderRight: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              width: "24%",
              marginRight: "auto",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.stateOptions &&
                metaData.stateOptions.length > 0 &&
                metaData.stateOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.stateOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options:
            selCountry && selCountry.states && selCountry.states.length > 0
              ? selCountry.states.map((s) =>
                Object.assign({}, { label: s.name, value: s._id })
              )
              : metaData &&
                Object.keys(metaData).length > 0 &&
                metaData.stateOptions &&
                metaData.stateOptions.length > 0
                ? metaData.stateOptions
                : [],
        },
        {
          id: "23",
          value: "secondaryMobile",
          label: "Secondary No",
          placeholder: "Enter Secondary No",
          sort: true,
          editRecord: true,
          viewRecord: false,
          onInputChange: ({ inputValue, setFieldValue }) => {
            const obj = inputValue.val
            console.log(obj, "Response")
            api
              .post("/get_client", {
                status: "active",
                id: "",
                mobileNo: obj ? obj : [],
              })
              .then((res) => {
                if (
                  res &&
                  res.data &&
                  res.data.data &&
                  res.data.data.length > 0
                ) {
                  setFieldValue("secondaryMobileConfirm", true)
                  setFieldValue(
                    "clientId",
                    res.data.data && res.data.data[0] && res.data.data[0]._id
                  )
                } else {
                  setFieldValue("secondaryMobileConfirm", false)
                }
              })
              .catch(() => {
                setFieldValue("secondaryMobileConfirm", false)
              })
          },
          prefix: ({ setFieldValue }) => {
            return (
              <div
                style={{ display: "flex", alignItems: "center", width: "32px" }}
             >
                <input
                  type="checkbox"
                  id="check2"
                  onChange={(e) =>{
                    if( e.target.checked){
                      setFieldValue("whatsAppNo", record.secondaryMobile)
                      document.getElementById('check1').checked=false
                    }
                  else{
                    setFieldValue("whatsAppNo", "")
                  }}
                   
                  }
                 // checked={checked}
                ></input>
              </div>
            )
          },
          defaultCountry: (selCountry && selCountry.shortName) || "IN",
          //defaultValue: record && record.secondaryMobile && record.secondaryMobile.toString() && `+${record.secondaryMobile.toString()}` || '',
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderLeft: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          type: "phone",
        },
        {
          id: "24",
          value: "whatsAppNo",
          label: "Whats App No",
          placeholder: "Enter Whats App No",
          sort: true,
          editRecord: true,
          viewRecord: false,
          required: true,
          defaultCountry: (selCountry && selCountry.shortName) || "IN",
          //defaultValue: record && record.whatsAppNo && record.whatsAppNo.toString() && `+${record.whatsAppNo.toString()}` || '',
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderRight: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          onInputChange: ({ inputValue, setFieldValue }) => {
            const obj = inputValue.val
            console.log(obj, "Response")
            api
              .post("/get_client", {
                status: "active",
                id: "",
                mobileNo: obj ? obj : [],
              })
              .then((res) => {
                if (
                  res &&
                  res.data &&
                  res.data.data &&
                  res.data.data.length > 0
                ) {
                  setFieldValue("whatsAppNoConfirm", true)
                  setFieldValue(
                    "clientId",
                    res.data.data && res.data.data[0] && res.data.data[0]._id
                  )
                } else {
                  setFieldValue("whatsAppNoConfirm", false)
                }
              })
              .catch(() => {
                setFieldValue("whatsAppNoConfirm", false)
              })
          },
          type: "phone",
        },
        {
          id: "25",
          value: "city",
          label: "City",
          placeholder: "Enter City",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderLeft: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.cityOptions &&
                metaData.cityOptions.length > 0 &&
                metaData.cityOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.cityOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
          options: cityOptions,
        },
        {
          id: "26",
          value: "pincode",
          label: "Pincode",
          placeholder: "Enter Pincode",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderRight: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              width: "24%",
              marginRight: "auto",
              paddingBottom: "0px",
            },
            className: "",
          },
          type: "zipCode",
          validations: "zipCode"
        },
        {
          id: "27",
          value: "emailId",
          label: "Email ID",
          placeholder: "Enter Email ID",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderLeft: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          type: "email",
        },
        {
          id: "28",
          value: "priorityStatusId",
          label: "Priority Status",
          placeholder: "Select Priority Status",
          sort: true,
          editRecord: true,
          viewRecord: false,
          required: true,
          colProps: {
            lg: "3",
            md: "3",
            style: {
              borderRight: "2px solid #eff2f7",
              padding: "15px",
              backgroundColor: "#d3d3d321",
              paddingBottom: "0px",
            },
            className: "",
          },
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.priorityStatusOptions &&
                 metaData.priorityStatusOptions.length > 0 &&
                metaData.priorityStatusOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.priorityStatusOptions.find(
                  (_) => cellContent === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "select",
           options: "priorityStatusOptions",
         },
         {
           id: "29",
           value: "primaryAddress",
           label: "Address",
           placeholder: "Enter Address",
           sort: true,
           editRecord: true,
           viewRecord: false,
           colProps: {
             lg: "6",
             md: "6",
             style: {
               borderLeft: "2px solid #eff2f7",
               borderRight: "2px solid #eff2f7",
               borderBottom: "2px solid #eff2f7",
               borderBottomLeftRadius: "6px",
               borderBottomRightRadius: "6px",
               padding: "15px",
               backgroundColor: "#d3d3d321",
               width: "49%",
               marginRight: "auto",
             },
           },
           type: "textarea",
         },
         {
           id: "30",
           value: "descriptions",
           label: "Remarks",
           placeholder: "Enter Remarks",
           sort: true,
           editRecord: true,
           viewRecord: false,
           colProps: {
             lg: "6",
             md: "6",
             style: {
               borderLeft: "2px solid #eff2f7",
               borderRight: "2px solid #eff2f7",
               borderBottom: "2px solid #eff2f7",
               borderBottomLeftRadius: "6px",
               borderBottomRightRadius: "6px",
               padding: "15px",
               backgroundColor: "#d3d3d321",
             },
           },
           type: "textarea",
         },
         {
           id: "31",
           value: "crossPromotion",
           label: "Cross Promotions",
           placeholder: "Select Cross Promotions",
           sort: true,
           editRecord: true,
           viewRecord: false,
           colProps: {
             lg: "6",
             md: "6",
             style: {
               border: "2px solid #eff2f7",
               borderRadius: "6px",
               padding: "15px",
               backgroundColor: "#d3d3d321",
               width: "49%",
               marginRight: "auto",
               paddingBottom: "0px",
             },
           },
           type: "table",
           labelStyle: {
             fontSize: "18px",
             textTransform: "uppercase",
           },
           formatter: () => {
             return <div>NA</div>
           },
           tableColumns: [
             {
               dataField: "name",
               text: "Company Name",
             },
             {
               dataField: "action",
               text: "Action",
               formatter: (value, onChange, fieldValues, row) => {
                 const options = [
                   {
                     label: "Yes",
                     value: true,
                   },
                   {
                     label: "No",
                     value: false,
                   },
                 ]
                 return (
                   <React.Fragment>
                     <FormGroup className="mb-3">
                       <div
                         style={{
                           display: "flex",
                           width: "100%",
                           flexWrap: "wrap",
                         }}
                       >
                         {(options || []).map((opt, index) => {
                           return (
                             <div
                               key={index}
                               className="form-check"
                               style={{ marginRight: "15px" }}
                             >
                               <input
                                 className="form-check-input"
                                 type="radio"
                                 name={row._id}
                                 id={`${row._id}-${opt.value}`}
                                 value={opt.value}
                                 onChange={() => {
                                   const isExist =
                                     fieldValues.find(
                                       (a) =>
                                         a &&
                                         row &&
                                         a.companyId &&
                                         row._id &&
                                         a.companyId.toString() ===
                                         row._id.toString()
                                     ) || false
 
                                   if (isExist) {
                                     onChange({
                                       target: {
                                         value: fieldValues.map((el) =>
                                           el.companyId.toString() ===
                                             row._id.toString()
                                             ? Object.assign({}, el, {
                                               action: opt.value,
                                             })
                                             : el
                                         ),
                                       },
                                     })
                                   } else {
                                     onChange({
                                       target: {
                                         value: [
                                           ...fieldValues,
                                           Object.assign(
                                             {},
                                             {
                                               companyId: row._id,
                                               action: opt.value,
                                             }
                                           ),
                                         ],
                                       },
                                     })
                                   }
                                 }}
                                 checked={value === opt.value ? true : false}
                               />
                               <label
                                 className="form-check-label"
                                 htmlFor={`${row._id}-${opt.value}`}
                               >
                                 {" "}
                                 {opt.label}
                               </label>
                             </div>
                           )
                         })}
                       </div>
                     </FormGroup>
                   </React.Fragment>
                 )
               },
             },
           ],
           options: companyTableOptions,
         },
         {
           id: "32",
           value: "customField",
           label: "Custom Field",
           placeholder: "Select Custom Field",
           sort: true,
           editRecord:
             customFieldOptions && customFieldOptions.length > 0 ? true : false,
           viewRecord: false,
           labelStyle: {
             fontSize: "18px",
             textTransform: "uppercase",
           },
           colProps: {
             lg: "6",
             md: "6",
             style: {
               border: "2px solid #eff2f7",
               borderRadius: "6px",
               padding: "15px",
               backgroundColor: "#d3d3d321",
               paddingBottom: "0px",
             },
           },
           formatter: () => {
             return <div>NA</div>
           },
           type: "custom",
           options: customFieldOptions,
         },
         {
           id: "33",
           value: "salesAgent",
           label: "Sales Agent Name",
           sort: true,
           editRecord: false,
           viewRecord: true,
           formatter: (cellContent, row, rowIndex, metaData) => {
             const agentDetails =
               row &&
                 row.leadAssign &&
                 Array.isArray(row.leadAssign) &&
                 row.leadAssign.length > 0 &&
                 metaData &&
                 metaData.employeeListOptions &&
                 metaData.employeeListOptions.length > 0
                 ? metaData.employeeListOptions.find(
                   (k) =>
                     row.leadAssign[row.leadAssign.length - 1] &&
                     row.leadAssign[row.leadAssign.length - 1].assignedTo &&
                     k.value.toString() ===
                     row.leadAssign[
                       row.leadAssign.length - 1
                     ].assignedTo.toString()
                 )
                 : false
             return <div>{(agentDetails && agentDetails.name) || ""}</div>
           },
           type: "text",
         },
         {
           id: "34",
           value: "budget",
           label: "Budget",
           sort: true,
           editRecord: false,
           viewRecord: false,
           type: "text",
         },
         {
           id: "35",
           value: "leadSourceId",
           label: "Lead Source",
           sort: true,
           editRecord: false,
           viewRecord: false,
           formatter: (cellContent, row, rowIndex, metaData) => {
             return (
               (cellContent &&
                 metaData &&
                 metaData.sourceOptions &&
                 metaData.sourceOptions.length > 0 &&
                 metaData.sourceOptions.find(
                   (_) => cellContent === _.value.toString()
                 ) &&
                 metaData.sourceOptions.find(
                   (_) => cellContent === _.value.toString()
                 ).label) ||
               ""
             )
           },
           type: "text",
         },
         {
           id: "36",
           value: "leadDate",
           label: "Lead Date",
           placeholder: "Enter Lead Date",
           sort: true,
           editRecord: false,
           viewRecord: true,
           formatter: (cellContent, row) => {
             return (row && (row.leadDate)) || ""
           },
           type: "text",
         },
         {
           id: "37",
           value: "leadStatus",
           label: "Lead Status",
           sort: true,
           editRecord: false,
           viewRecord: true,
           formatter: (cellContent, row, rowIndex, metaData) => {
             const cellColorCode =
               metaData &&
               Object.keys(metaData).length > 0 &&
               metaData.processStatusOptions &&
               metaData.processStatusOptions.length > 0 &&
               metaData.processStatusOptions.find(
                 (_) =>
                   row &&
                   row.processStatus &&
                   row.processStatus.processStatusId &&
                   _.value.toString() ===
                   row.processStatus.processStatusId.toString()
               ) &&
               metaData.processStatusOptions.find(
                 (_) =>
                   row &&
                   row.processStatus &&
                   row.processStatus.processStatusId &&
                   _.value.toString() ===
                   row.processStatus.processStatusId.toString()
               ).colorCode
             return (
               <Badge
                 className={`font-size-12`}
                 style={{
                   backgroundColor: cellColorCode || "#34c38f",
                   padding: "4px",
                 }}
                 color={cellColorCode}
               >
                 {(row &&
                   row.processStatus &&
                   row.processStatus.processStatusName) ||
                   ""}
               </Badge>
             )
           },
           type: "text",
         },
       ]
     },
   },
   {
    schemaId: "aG9saWRheQ",
    name: "holiday",
    title: "Holiday",
    path: "/holiday",
    visible: true,
    formTitle: "Holiday",
    page: "Holiday",
    ...aG9saWRheQ,

    columns: (record = {}, metaData) => {
      const branchOptions =
        record &&
          record.companyId &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.branchOptions &&
          metaData.branchOptions.length > 0
          ? metaData.branchOptions.filter(
            (_) => _.companyId.toString() === record.companyId.toString()
          )
          : metaData &&
            Object.keys(metaData).length > 0 &&
            metaData.branchOptions &&
            metaData.branchOptions.length > 0
            ? metaData.branchOptions
            : []
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "5",
          value: "holidayName",
          label: "Holiday Name",
          placeholder: "Enter Holiday Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.holidayName}</span>
            )
          },
          type: "text",
        },
        {
          id: "6",
          value: "companyId",
          label: "Company",
          placeholder: "Select Company",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          type: "multiSelect",
          validations: "arrayField",
          colProps: {
            lg: "12",
            md: "12",
            style: { paddingRight: "15px" },
          },
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.companyOptions &&
                metaData.companyOptions.length > 0 &&
                metaData.companyOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.companyOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          options: "companyOptions",
        },

        {
          id: "20",
          value: "branchId",
          label: "Branch",
          placeholder: "Select Branch",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          colProps: {
            lg: "12",
            md: "12",
            style: {
              paddingRight: "15px",
            },
          },
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.branchOptions &&
                metaData.branchOptions.length > 0 &&
                metaData.branchOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.branchOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },
          type: "multiSelect",
          validations: "arrayField",
          options: branchOptions,
        },
        {
          id: "7",
          value: "holidayList",
          label: "Holiday Date",
          editRecord: true,
          viewRecord: true,
          sort: true,
          required: true,
          colProps: {
            lg: "12",
            md: "12",
            className: "filter-field",
          },
          formatter: (cellContent, row) => {
            console.log(row.holidayList, "dateof")
            // const holiday = row.holidayList.map(holiday=> holiday.holidayDate)
            const holidayList = typeof row.holidayList === "string" ? row.holidayList : row.holidayList[0].holidayDate
            // const holidayList = row.holidayList.length > 1 ? holiday +"," : holiday
            return <span>{row && holidayList}
            </span>

          },
          // formatter: (cellContent, row) => {
          //   console.log(row.holidayList)
          //   return <span>{row && row.holidayList}
          //   </span>
          // },
          type: "dateMultiple",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  {
    schemaId: "YmFubmVy",
    name: "banner",
    title: "Banner",
    path: "/banner",
    visible: true,
    formTitle: "Banner",
    page: "Banner",
    ...YmFubmVy,
    columns: (record = {}, metaData) => {
      const branchOptions =
        record &&
          record.companyId &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.branchOptions &&
          metaData.branchOptions.length > 0
          ? metaData.branchOptions.filter(
            (_) => _.companyId.toString() === record.companyId.toString()
          )
          : metaData &&
            Object.keys(metaData).length > 0 &&
            metaData.branchOptions &&
            metaData.branchOptions.length > 0
            ? metaData.branchOptions
            : []
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "5",
          label: "Company",
          value: "companyId",
          sort: true,
          viewRecord: true,
          formatter: (cellContent, row) => {
           return (
             <span style={{textTransform: "uppercase"}}>{row.companyName}</span>
            )
          },
        },
        {
          id: "5",
          label: "Branch",
          value: "branchId",
          sort: true,
          viewRecord: true,
          formatter: (cellContent, row) => {
           return (
             <span style={{textTransform: "uppercase"}}>{row.branchId.length > 1 ? row.branchName && row.branchName.join(",") : row.branchName}</span>
            )
          },
        },
        {
          id: "6",
          value: "companyId",
          label: "Company",
          placeholder: "Select Company",
          sort: true,
          editRecord: true,
          viewRecord: false,
          required: true,
          type: "select",
          colProps: {
            lg: "12",
            md: "12",
            style: { paddingRight: "15px" },
          },
          formatter: (cellContent, row) => {
           return (
             <span style={{textTransform: "uppercase"}}>{row.companyName}</span>
            )
          },
          options: "companyOptions",
        },

        {
          id: "20",
          value: "branchId",
          label: "Branch",
          placeholder: "Select Branch",
          sort: true,
          editRecord: true,
          viewRecord: false,
          required: true,
          colProps: {
            lg: "12",
            md: "12",
            style: {
              paddingRight: "15px",
            },
          },
          type: "multiSelect",
          validations: "arrayField",
          options: branchOptions,
        },
        {
          id: "4",
          value: "bannerName",
          label: "Banner Name",
          placeholder: "Enter Banner Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return <span style={{textTransform: "uppercase"}}>{row.bannerName} </span>
            },
          type: "text",
        },
        {
          id: "5",
          value: "description",
          label: "Description",
          placeholder: "Enter Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return <span style={{textTransform: "uppercase"}}>{row.description} </span>
            },
          type: "textarea",
        },
        {
          id: "16",
          value: "attachment",
          label: "Media Attachment",
          placeholder: "Choose Media Attachment",
          sort: true,
          editRecord: true,
          viewRecord: false,
          required: true,
          colProps: {
            lg: "4",
            md: "4",
            style: {
              borderBottom: "2px solid #eff2f7",
              borderRight: "2px solid #eff2f7",
              borderBottomRightRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
            },
          },
          type: "upload",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
   {
     schemaId: "UmVmZXJyYWw",
     name: "referral",
     title: "Referral",
     path: "/referral",
     visible: true,
     formTitle: "Referral",
     page: "Referral",
     ...UmVmZXJyYWw,
     columns: () => [
       {
         id: "1",
         value: "_id",
         label: "Id",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "2",
         value: "sno",
         label: "S.No",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row, rowIndex) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             rowIndex + 1
           ),
         type: "text",
       },
       {
         id: "3",
         value: "actions",
         label: "Actions",
         sort: false,
         editRecord: false,
         viewRecord: true,
         editFormatter: "actions",
         type: "text",
       },
       {
         id: "4",
         value: "code",
         label: "Delegation Code",
         placeholder: "Enter Delegation Code",
         sort: true,
         editRecord: true,
         viewRecord: true,
         required: true,
         type: "text",
       },
       {
         id: "5",
         value: "name",
         label: "Delegation Name",
         placeholder: "Enter Delegation Name",
         sort: true,
         editRecord: true,
         viewRecord: true,
         required: true,
         type: "text",
       },
       {
         id: "6",
         value: "status",
         label: "Status",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             <Badge
               className={`font-size-12 badge rounded-pill ${row.status
                 ? "bg-success badge-soft-success"
                 : "bg-danger badge-soft-danger"
                 }`}
               color={row.badgeclass}
               pill
             >
               {row.status ? "Active" : "Inactive"}
             </Badge>
           ),
         type: "text",
       },
       {
         id: "7",
         value: "branches",
         label: "Branches",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "8",
         value: "insertedBy",
         label: "Inserted By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "9",
         value: "updatedBy",
         label: "Updated By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "10",
         value: "createdAt",
         label: "Created Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "11",
         value: "updatedAt",
         label: "Updated Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
     ],
   },
   {
     schemaId: "QmlydGhkYXkgTGlzdA",
     name: 'birthdayList',
     title: "Birthday List",
     path: "/birthday-list",
     visible: true,
     formTitle: "Birthday List",
     page: "BirthdayList",
     ...QmlydGhkYXkgTGlzdA,
     columns: () => [
       {
         id: "1",
         value: "_id",
         label: "Id",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "2",
         value: "sno",
         label: "S.No",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row, rowIndex) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             rowIndex + 1
           ),
         type: "text",
       },
       {
         id: "3",
         value: "actions",
         label: "Actions",
         sort: false,
         editRecord: false,
         viewRecord: true,
         editFormatter: "actions",
         type: "text",
       },
       {
         id: "4",
         value: "code",
         label: "Birthdat List Code",
         placeholder: "Enter Birthdat List Code",
         sort: true,
         editRecord: true,
         viewRecord: true,
         required: true,
         type: "text",
       },
       {
         id: "5",
         value: "name",
         label: "Birthday List Name",
         placeholder: "Enter Birthday List Name",
         sort: true,
         editRecord: true,
         viewRecord: true,
         required: true,
         type: "text",
       },
       {
         id: "6",
         value: "status",
         label: "Status",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             <Badge
               className={`font-size-12 badge rounded-pill ${row.status
                 ? "bg-success badge-soft-success"
                 : "bg-danger badge-soft-danger"
                 }`}
               color={row.badgeclass}
               pill
             >
               {row.status ? "Active" : "Inactive"}
             </Badge>
           ),
         type: "text",
       },
       {
         id: "7",
         value: "branches",
         label: "Branches",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "8",
         value: "insertedBy",
         label: "Inserted By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "9",
         value: "updatedBy",
         label: "Updated By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "10",
         value: "createdAt",
         label: "Created Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "11",
         value: "updatedAt",
         label: "Updated Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
     ],
   },
   {
    schemaId: "Y2xpZW50X3Byb2ZpbGU",
    name: "client_profile",
    title: "Client Profile List",
    path: "/client-profile",
    visible: true,
    formTitle: "Client Profile List",
    page: "ClientProfile",
    ...Y2xpZW50X3Byb2ZpbGU,
    columns: (record = {}, metaData) => {


      console.log(record, "record from api")
      console.log(metaData, "record from meta data")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "clientCode",
          autofillValue: codeValueMetaData,
          label: "Client Code",
          placeholder: "Enter Client Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            console.log(row, "row from api")
            return (
              <>
                <p style={{ textTransform: "uppercase" }}>{row.clientCode}</p>
              </>
            )
          },
          type: "code",
        },
        {
          id: "5",
          value: "clientProfile",
          label: "Client Profile Name",
          placeholder: "Enter Client Profile Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return <span style={{ textTransform: "uppercase" }}>{row.clientProfile} </span>
          },
          type: "text",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            )
          ,
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
   {
     schemaId: "ZGVsaXZlcnlfbW9kZQ",
     name: "delivery_mode",
     title: "Delivery Mode",
     path: "/delivery_mode",
     visible: true,
     formTitle: "Delivery Mode",
     page: "DeliveryMode",
     ...ZGVsaXZlcnlfbW9kZQ,
     columns: () => [
       {
         id: "1",
         value: "_id",
         label: "Id",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "2",
         value: "sno",
         label: "S.No",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row, rowIndex) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             rowIndex + 1
           ),
         type: "text",
       },
       {
         id: "3",
         value: "actions",
         label: "Actions",
         sort: false,
         editRecord: false,
         viewRecord: true,
         editFormatter: "actions",
         type: "text",
       },
       {
         id: "4",
         value: "deliveryMode",
         label: "Delivery Mode",
         placeholder: "Enter Delivery Mode",
         sort: true,
         editRecord: true,
         viewRecord: true,
         required: true,
         type: "text",
       },
       {
         id: "6",
         value: "status",
         label: "Status",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             <Badge
               className={`font-size-12 badge rounded-pill ${row.status == 1
                 ? "bg-success badge-soft-success"
                 : "bg-danger badge-soft-danger"
                 }`}
               color={row.badgeclass}
               pill
             >
               {row.status == 1 ? "Active" : "Inactive"}
             </Badge>
           ),
         type: "text",
       },
       {
         id: "7",
         value: "branches",
         label: "Branches",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "8",
         value: "insertedBy",
         label: "Inserted By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "9",
         value: "updatedBy",
         label: "Updated By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "10",
         value: "createdAt",
         label: "Created Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "11",
         value: "updatedAt",
         label: "Updated Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
     ],
   },
   {
    schemaId: "c2VydmljZQ",
    name: 'service',
    title: 'Event Service List',
    formTitle: 'Event Service',
    path: '/event-service',
    visible: true,
    ...c2VydmljZQ,
    page: 'EventService',
    exact: true,
    columns: (record = {}, metaData) => {
      
      console.log(record, "record from api")
      console.log(metaData, "record from meta data")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      var companyOptions = []
      if(metaData && metaData.companyOptions){
        var metaCompanyOptions = metaData.companyOptions
        companyOptions = metaCompanyOptions.map((data) => {
          return {
            value: data.value,
            label: data.label,
          }
      })
  
      //console.log("companyOptions", companyOptions)

      }
    
    const branchOptions =
    record &&
    record.companyId &&
    metaData &&
    Object.keys(metaData).length > 0 &&
    metaData.branchOptions &&
    metaData.branchOptions.length > 0
      ? metaData.branchOptions.filter(
          (_) => _.companyId.toString() === record.companyId.toString()
        ) : metaData &&
        Object.keys(metaData).length > 0 &&
        metaData.branchOptions &&
        metaData.branchOptions.length > 0
      ? metaData.branchOptions
      : []

       
    return [
      {
        id: "1",
        value: '_id',
        label: 'Id',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text'
      },
      {
        id: "2",
        value: 'sno',
        label: 'S.No',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) => row.loading ? (
          <p className="card-text placeholder-glow">
            <span className="placeholder col-7"></span>
          </p>
        ) : rowIndex + 1,
        type: 'text'
      },
      {
        id: "3",
        value: 'actions',
        label: 'Action',
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: 'actions',
        type: 'text'
      },

      {
        id: "6",
        value: "companyId",
        label: "Company",
        placeholder: "Select Company",
        sort: true,
        required:true,
        editRecord: true,
        viewRecord: true,
        type: "multiSelect",
        validations: "arrayField",
        colProps: {
          lg: "12",
          md: "12",
          style: { paddingRight: "15px" },
        },

        formatter: (cellContent, row) => {
         const company =  row && row.branchName ? row.companyName.map(company=> company) : []
         return <span>{row.companyName.length > 1 ? company +"," : company}</span>

         },
        options: companyOptions,
      },
      {
        id: "5",
        value: 'branchId',
        label: 'Branch',
        placeholder: 'Enter Branch',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required:true,
        type: 'multiSelect',
        validations: "arrayField",
        formatter: (cellContent, row) => {
         const branch = row && row.branchName ? row.branchName.map(branch=> branch) : []
         // return <span>{row.branch}</span>
         return <span>{row.branchName.length > 1 ? branch +"," : branch}</span>
       },
        options: branchOptions
      },
      {
        id: "6",
        value: 'eventId',
        label: 'Event',
        placeholder: 'Enter Event',
        sort: true,
        required:true,
        editRecord: true,
        viewRecord: true,
        type: 'multiSelect',
        validations: "arrayField",
        formatter: (cellContent, row) => {
         const event = row && row.eventName ? row.eventName.map(event=> event) : []
         // return <span>{row.event}</span>
         return <span>{event.length > 1 ? event +"," : event}</span>
        },
        options: 'eventOptions'
      },


      {
        id: "7",
        value: 'serviceCode',
        autofillValue: codeValueMetaData,
        label: 'Service Code ',
        placeholder: 'Enter Service Code',
        sort: true,
        editRecord: true,
        viewRecord: true,
      //  required: true,
        type: 'code'
      },

      {
        id: "8",
        value: 'serviceName',
        label: 'Service',
        placeholder: 'Enter Service',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required:true,
        type: 'text'
      },

      {
        id: "9",
        value: 'amount',
        label: 'Amount',
        placeholder: 'Enter Amount',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required:true,
        colProps: {
          className: "employee-input"
        },
        type: 'number'
      },
      {
       id: "8",
       value: 'isSpecialService',
       label: 'Is Special Service',
       sort: true,
       editRecord: true,
       viewRecord: true,
       type: "checkbox",
       labelStyle: {
         fontSize: "12px",
         fontWeight: 600
       },
       colProps: {
         style: {
           marginTop: "20px"
         }
       },
       formatter: (cellContent, row) => {
         return (
           <Badge style={{padding: "6px", fontSize: "12px"}} color={row.isSpecialService == true ? "success" : "danger"}>
             {row.isSpecialService == true ? "Yes" : "No"}
           </Badge>
         )
         },
       required:false,
     },
     {
       id: "8",
       value: 'isDataApplicable',
       label: 'Is Data Applicable',
       sort: true,
       editRecord: true,
       viewRecord: true,
       type: "checkbox",
       labelStyle: {
         fontSize: "12px",
         fontWeight: 600
       },
       colProps: {
         style: {
           marginTop: "20px"
         }
       },
       formatter: (cellContent, row) => {
         return (
           <Badge style={{padding: "6px", fontSize: "12px"}} color={row.isDataApplicable == true ? "success" : "danger"}>
             {row.isDataApplicable == true ? "Yes" : "No"}
           </Badge>
         )
         },
       required:false,
     },
      {
        id: "8",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${
                row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
              }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1  ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "9",
        value: 'insertedBy',
        label: 'Inserted By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text'
      },
      {
        id: "10",
        value: 'updatedBy',
        label: 'Updated By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text'
      },
      {
        id: "11",
        value: 'createdAt',
        label: 'Created Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text'
      },
      {
        id: "12",
        value: 'updatedAt',
        label: 'Updated Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text'
      }
    ]}
  },
   {
     schemaId: "c3ViX3Byb2R1Y3Q",
     name: "sub_product",
     title: "Sub-Product List",
     path: "/deliverable-sub-product",
     visible: true,
     formTitle: "Sub-Product List",
     page: "SubProduct",
     ...c3ViX3Byb2R1Y3Q,
     columns: (records = [], metaData) => {
 
       console.log(records, "record from api")
 
       const codeValueMetaData = metaData && metaData.codeOptions
 
       console.log(codeValueMetaData, "codeValueMetaData")
       return [
         {
           id: "1",
           value: "_id",
           label: "Id",
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: "text",
         },
         {
           id: "2",
           value: "sno",
           label: "S.No",
           sort: false,
           editRecord: false,
           viewRecord: true,
           formatter: (cellContent, row, rowIndex) =>
             row.loading ? (
               <p className="card-text placeholder-glow">
                 <span className="placeholder col-7"></span>
               </p>
             ) : (
               rowIndex + 1
             ),
           type: "text",
         },
         {
           id: "3",
           value: "actions",
           label: "Actions",
           sort: false,
           editRecord: false,
           viewRecord: true,
           editFormatter: "actions",
           type: "text",
         },
         {
           id: "4",
           value: "subProductCode",
           autofillValue: codeValueMetaData,
           label: "Sub Product Code",
           placeholder: "Enter Sub Product Code",
           sort: true,
           editRecord: true,
           viewRecord: true,
           // required: true,
           type: "code",
         },
         {
           id: "5",
           value: "subProductName",
           label: "Sub Product Name",
           placeholder: "Enter Sub Product Name",
           sort: true,
           editRecord: true,
           viewRecord: true,
           required: true,
           formatter: (cellContent, row) => {
             return <span style={{ textTransform: "uppercase" }}>{row.subProductName} </span>
           },
           type: "text",
         },
         {
           id: "6",
           value: "status",
           label: "Status",
           sort: false,
           editRecord: false,
           viewRecord: true,
           formatter: (cellContent, row) =>
             row.loading ? (
               <p className="card-text placeholder-glow">
                 <span className="placeholder col-7"></span>
               </p>
             ) : (
               <Badge
                 className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                   ? "bg-success badge-soft-success"
                   : "bg-danger badge-soft-danger"
                   }`}
                 color={row.badgeclass}
                 pill
               >
                 {row.status && row.status === 1 ? "Active" : "Inactive"}
               </Badge>
             ),
           type: "text",
         },
         {
           id: "7",
           value: "branches",
           label: "Branches",
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: "text",
         },
         {
           id: "8",
           value: "insertedBy",
           label: "Inserted By",
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: "text",
         },
         {
           id: "9",
           value: "updatedBy",
           label: "Updated By",
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: "text",
         },
         {
           id: "10",
           value: "createdAt",
           label: "Created Date",
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: "text",
         },
         {
           id: "11",
           value: "updatedAt",
           label: "Updated Date",
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: "text",
         },
       ]
     },
   },
   {
     schemaId: "ZGVsaXZlcmFibGU",
     name: "deliverable",
     title: "Event Deliverable List",
     path: "/event-deliverable",
     visible: true,
     formTitle: "Event Deliverable List",
     page: "Deliverable",
     ...ZGVsaXZlcmFibGU,
     columns: (records = [], metaData) => {
 
       console.log(records, "record from api")
 
       const codeValueMetaData = metaData && metaData.codeOptions
 
       console.log(codeValueMetaData, "codeValueMetaData")
       return [
         {
           id: "1",
           value: "_id",
           label: "Id",
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: "text",
         },
         {
           id: "2",
           value: "sno",
           label: "S.No",
           sort: false,
           editRecord: false,
           viewRecord: true,
           formatter: (cellContent, row, rowIndex) =>
             row.loading ? (
               <p className="card-text placeholder-glow">
                 <span className="placeholder col-7"></span>
               </p>
             ) : (
               rowIndex + 1
             ),
           type: "text",
         },
         {
           id: "3",
           value: "actions",
           label: "Actions",
           sort: false,
           editRecord: false,
           viewRecord: true,
           editFormatter: "actions",
           type: "text",
         },
         {
           id: "4",
           value: "deliverableCode",
           autofillValue: codeValueMetaData,
           label: "Deliverable Code",
           placeholder: "Enter Deliverable Code",
           sort: true,
           editRecord: true,
           viewRecord: true,
           // required: true,
           type: "code",
         },
         {
           id: "5",
           value: "deliverableName",
           label: "Deliverable Name",
           placeholder: "Enter Deliverable Name",
           sort: true,
           editRecord: true,
           viewRecord: true,
           required: true,
           formatter: (cellContent, row) => {
             return <span style={{ textTransform: "uppercase" }}>{row.deliverableName} </span>
           },
           type: "textOnly",
           validations: "textOnly"
         },
         {
           id: "6",
           value: "operationTeam",
           label: "Operation Name",
           placeholder: "Enter Operation Name",
           sort: true,
           editRecord: true,
           viewRecord: true,
           required: true,
           formatter: (cellContent, row) => {
             return <span style={{ textTransform: "uppercase" }}>{row.operationTeam} </span>
           },
           type: "textOnly",
           validations: "textOnly"
         },
         {
           id: "7",
           value: "deliverableType",
           label: "Deliverable Type",
           placeholder: "Enter Deliverable Type",
           sort: true,
           editRecord: true,
           viewRecord: true,
           required: true,
           formatter: (cellContent, row) => {
             return <span style={{ textTransform: "uppercase" }}>{row.deliverableType} </span>
           },
           type: "textOnly",
           validations: "textOnly"
         },
         {
           id: "8",
           value: "deliverableSet",
           label: "Deliverable Set",
           placeholder: "Enter Deliverable Set",
           sort: true,
           editRecord: true,
           viewRecord: true,
           required: true,
           formatter: (cellContent, row) => {
             return <span style={{ textTransform: "uppercase" }}>{row.deliverableSet} </span>
           },
           type: "textOnly",
           validations: "textOnly"
         },
         {
           id: "9",
           value: "description",
           label: "Description",
           placeholder: "Enter Description",
           sort: true,
           editRecord: true,
           viewRecord: true,
           required: false,
           formatter: (cellContent, row) => {
             return <span style={{ textTransform: "uppercase" }}>{row.description} </span>
           },
           type: "textarea",
         },
         {
           id: "10",
           value: "status",
           label: "Status",
           sort: false,
           editRecord: false,
           viewRecord: true,
           formatter: (cellContent, row) =>
             row.loading ? (
               <p className="card-text placeholder-glow">
                 <span className="placeholder col-7"></span>
               </p>
             ) : (
               <Badge
                 className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                   ? "bg-success badge-soft-success"
                   : "bg-danger badge-soft-danger"
                   }`}
                 color={row.badgeclass}
                 pill
               >
                 {row.status && row.status === 1 ? "Active" : "Inactive"}
               </Badge>
             ),
           type: "text",
         },
         {
           id: "7",
           value: "branches",
           label: "Branches",
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: "text",
         },
         {
           id: "8",
           value: "insertedBy",
           label: "Inserted By",
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: "text",
         },
         {
           id: "9",
           value: "updatedBy",
           label: "Updated By",
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: "text",
         },
         {
           id: "10",
           value: "createdAt",
           label: "Created Date",
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: "text",
         },
         {
           id: "11",
           value: "updatedAt",
           label: "Updated Date",
           sort: false,
           editRecord: false,
           viewRecord: false,
           type: "text",
         },
       ]
     },
   },
   {
     schemaId: "cGF5bWVudF90ZXJtcw",
     name: "payment_terms",
     title: "Payment Terms List",
     path: "/payment-terms",
     visible: true,
     formTitle: "Payment Terms List",
     page: "PaymentTerms",
     ...cGF5bWVudF90ZXJtcw,
     columns: () => [
       {
         id: "1",
         value: "_id",
         label: "Id",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "2",
         value: "sno",
         label: "S.No",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row, rowIndex) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             rowIndex + 1
           ),
         type: "text",
       },
       {
         id: "3",
         value: "actions",
         label: "Actions",
         sort: false,
         editRecord: false,
         viewRecord: true,
         editFormatter: "actions",
         type: "text",
       },
       {
         id: "4",
         value: "paymentTerms",
         label: "Payment Terms",
         placeholder: "Enter Payment Terms",
         sort: true,
         editRecord: true,
         viewRecord: true,
         required: true,
         formatter: (cellContent, row) => {
           return <span style={{textTransform: "uppercase"}}>{row.paymentTerms} </span>
           },
         type: "text",
       },
       {
         id: "5",
         value: "description",
         label: "Description",
         placeholder: "Enter Description",
         sort: true,
         editRecord: true,
         viewRecord: true,
         required: true,
         formatter: (cellContent, row) => {
           return <span style={{textTransform: "uppercase"}}>{row.description} </span>
           },
         type: "textarea",
       },
       {
         id: "10",
         value: "status",
         label: "Status",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             <Badge
               className={`font-size-12 badge rounded-pill ${row.status
                 ? "bg-success badge-soft-success"
                 : "bg-danger badge-soft-danger"
                 }`}
               color={row.badgeclass}
               pill
             >
               {row.status ? "Active" : "Inactive"}
             </Badge>
           ),
         type: "text",
       },
       {
         id: "7",
         value: "branches",
         label: "Branches",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "8",
         value: "insertedBy",
         label: "Inserted By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "9",
         value: "updatedBy",
         label: "Updated By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "10",
         value: "createdAt",
         label: "Created Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "11",
         value: "updatedAt",
         label: "Updated Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
     ],
   },
   {
    schemaId: "cHJvZHVjdA",
    name: "product",
    title: "Product List",
    path: "/deliverable-product",
    visible: true,
    formTitle: "Product List",
    page: "Product",
    ...cHJvZHVjdA,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "productCode",
          autofillValue: codeValueMetaData,
          label: "Product Code",
          placeholder: "Enter Product Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          type: "code",
        },
        {
          id: "4",
          value: "productName",
          label: "Product Name",
          placeholder: "Enter Product Name  ",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return <span style={{textTransform: "uppercase"}}>{row.productName} </span>
            },
          type: "text",
         // validations: "textOnly"
        },
        {
          id: "4",
          value: "productType",
          label: "Product Type",
          placeholder: "Enter Product Type",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return <span style={{textTransform: "uppercase"}}>{row.productType} </span>
            },
          type: "textOnly",
          validations: "textOnly"
        },

        {
          id: "6",
          value: "subProductId",
          label: "Sub Product",
          placeholder: "Enter Sub Product",
          sort: true,
          editRecord: true,
          viewRecord: false,
          type: "multiSelect",
          options: "subProductOptions",
        },
        {
          id: "7",
          value: "operationMode",
          label: "Operation Mode",
          placeholder: "Enter Operation Mode",
          sort: true,
          editRecord: true,
          viewRecord: true,
          type: "select",
          // formatter: (cellContent, row) => {
          //   const category = row && row.operationMode ? row.operationMode : ""
          //   return <span style={{textTransform: "uppercase"}}>{category} </span>
          //   },
          options: [
            {
              label: "PRE",
              value: "PRE"
            },
            {
              label: "POST",
              value: "POST"
            },
          ],
        },
        {
          id: "6",
          value: "deliverableProductCategory",
          label: "Product Category",
          placeholder: "Select Sub Product",
          sort: true,
          editRecord: true,
          viewRecord: true,
          formatter: (cellContent, row) => {
            const category = row && row.deliverableProductCategory ? row.deliverableProductCategory.productCategory : ""
            return <span style={{textTransform: "uppercase"}}>{category} </span>
            },
          type: "select",
          options: "productCategoryOptions",
        },

        {
          id: "4",
          value: "productQuantity",
          label: "Product Quantity",
          placeholder: "Enter Product Quantity",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          colProps: {
            className: "employee-input",
            style: {
              marginTop: "7px"
            }
          },
          type: "number",
        },

        {
          id: "6",
          value: "deliverable",
          label: "Deliverable",
          placeholder: "Select Deliverable",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          type: "select",
          colProps: {
            style: {
              marginTop: "10px"
            }
          },
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (metaData &&
                metaData.deliverableOptions &&
                metaData.deliverableOptions.length > 0 &&
                metaData.deliverableOptions.find(
                  (_) => _.value.toString() === cellContent.toString()
                ) &&
                metaData.deliverableOptions.find((_) => _.value === cellContent)
                  .label) ||
              ""
            )
          },
          options: "deliverableOptions",
        },


        {
          id: "9",
          value: "defaultQuantity",
          label: "Default Quantity",
          placeholder: "Default Quantity",
          sort: true,
          editRecord: true,
          viewRecord: true,
          formatter:(cellContent, row)=>{
           return(<><span >{row.defaultQuantity === 1 ? "YES" : "NO"}</span> </>)
           },
           type: "checkbox",
        },

        {
          id: "4",
          value: "count",
          label: "Count",
          placeholder: "Enter Count",
          sort: true,
          editRecord: true,
          viewRecord: true,
          colProps: {
            className: "employee-input"
          },
          type: "number",
        },
        {
          id: "4",
          value: "sheet",
          label: "Sheet",
          placeholder: "Enter Sheet",
          sort: true,
          editRecord: true,
          viewRecord: true,
          colProps: {
            className: "employee-input",
            style: {
              marginTop: "10px"
            }
          },
          type: "number",
        },
        {
          id: "4",
          value: "length",
          label: "Length",
          placeholder: "Enter Length",
          sort: true,
          editRecord: true,
          viewRecord: true,
          colProps: {
            className: "employee-input",
            style: {
              marginTop: "10px"
            }
          },
          type: "number",
        },
        {
          id: "4",
          value: "shutNumber",
          label: "Shut Number",
          placeholder: "Enter Shut Number",
          sort: true,
          editRecord: true,
          viewRecord: true,
          colProps: {
            className: "employee-input",
            style: {
              marginTop: "10px"
            }
          },
          type: "number",
        },
        {
          id: "4",
          value: "price",
          label: "Price",
          placeholder: "Enter  Price",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          colProps: {
            className: "employee-input",
            style: {
              marginTop: "10px"
            }
          },
          type: "number",
        },

        // {
        //   id: "6",
        //   value: "tax",
        //   label: "Tax",
        //   placeholder: "Select Tax",
        //   sort: true,
        //   editRecord: true,
        //   viewRecord: true,
        //   required: true,
        //   type: "select",
        //   colProps: {
        //     style: {
        //       marginTop: "10px"
        //     }
        //   },
        //   formatter: (cellContent, row, rowIndex, metaData) => {
        //     return (
        //       (metaData &&
        //         metaData.gstOptions &&
        //         metaData.gstOptions.length > 0 &&
        //         metaData.gstOptions.find(
        //           (_) => _.value.toString() === cellContent.toString()
        //         ) &&
        //         metaData.gstOptions.find((_) => _.value === cellContent)
        //           .label) ||
        //       ""
        //     )
        //   },
        // },
        {
          id: "16",
          value: "productImage",
          label: "Product Image",
          placeholder: "Choose Product Image",
          sort: true,
          editRecord: true,
          viewRecord: false,
          colProps: {
            lg: "4",
            md: "4",
            style: {
              borderBottom: "2px solid #eff2f7",
              borderRight: "2px solid #eff2f7",
              borderBottomRightRadius: "6px",
              padding: "15px",
              backgroundColor: "#d3d3d321",
            },
          },
          type: "upload",
        },

        {
          id: "10",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
   {
     schemaId: "cGF5bWVudF9tb2Rl",
     name: "payment_mode",
     title: "Payment Mode List",
     path: "/payment-mode",
     visible: true,
     formTitle: "Payment Mode List",
     page: "PaymentMode",
     ...cGF5bWVudF9tb2Rl,
     columns: (record = {}) => {
 
       console.log("record", record)
       
       return [
       {
         id: "1",
         value: "_id",
         label: "Id",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "2",
         value: "sno",
         label: "S.No",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row, rowIndex) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             rowIndex + 1
           ),
         type: "text",
       },
       {
         id: "3",
         value: "actions",
         label: "Actions",
         sort: false,
         editRecord: false,
         viewRecord: true,
         editFormatter: "actions",
         type: "text",
       },
       {
         id: "4",
         value: "paymentMode",
         label: "Payment Mode",
         placeholder: "Enter Payment Mode",
         sort: true,
         editRecord: true,
         viewRecord: true,
         
         required: true,
         formatter: (cellContent, row) => {
           return <span style={{textTransform: "uppercase"}}>{row.paymentMode} </span>
           },
         type: "text",
       },
       {
         id: "5",
         value: "description",
         label: "Description",
         placeholder: "Enter Description",
         sort: true,
         editRecord: true,
         viewRecord: true,
         required: false,
         formatter: (cellContent, row) => {
           return <span style={{textTransform: "uppercase"}}>{row.description} </span>
           },
         type: "textarea",
       },
       {
         id: "5",
         value: "mode",
         label: "Is Link With Bank",
         placeholder: "Enter Mode",
         sort: true,
         editRecord: true,
         viewRecord: true,
         required: false,
        formatter:(cellContent, row)=>{
         return(<><span >{row.mode === 1 ? "YES" : "NO"}</span> </>)
         },
         type: "checkbox",
       },
       //{
         //id: "5",
        // value: "mode",
        // label: "mode",
        // placeholder: "Enter Mode",   cellContent - this is important for to use the formatter in schema
        // sort: true,
        // viewRecord: true,
       //},
       {
         id: "6",
         value: "status",
         label: "Status",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             <Badge
               className={`font-size-12 badge rounded-pill ${
                 row.status && row.status === 1
                   ? "bg-success badge-soft-success"
                   : "bg-danger badge-soft-danger"
               }`}
               color={row.badgeclass}
               pill
             >
               {row.status && row.status === 1  ? "Active" : "Inactive"}
             </Badge>
           ),
         type: "text",
       },
       {
         id: "7",
         value: "branches",
         label: "Branches",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "8",
         value: "insertedBy",
         label: "Inserted By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "9",
         value: "updatedBy",
         label: "Updated By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "10",
         value: "createdAt",
         label: "Created Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "11",
         value: "updatedAt",
         label: "Updated Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
     ]
   }
   },
   {
     schemaId: "YmFua19kZXRhaWw",
     name: "sales_bank",
     title: "Bank List",
     path: "/bank",
     visible: true,
     formTitle: "Bank List",
     page: "Bank",
     ...YmFua19kZXRhaWw,
     columns: () => [
       {
         id: "1",
         value: "_id",
         label: "Id",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "2",
         value: "sno",
         label: "S.No",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row, rowIndex) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             rowIndex + 1
           ),
         type: "text",
       },
       {
         id: "3",
         value: "actions",
         label: "Actions",
         sort: false,
         editRecord: false,
         viewRecord: true,
         editFormatter: "actions",
         type: "text",
       },
       {
         id: "4",
         value: "bankCode",
         label: "Bank Code",
         placeholder: "Enter Bank Code",
         sort: true,
         editRecord: true,
         viewRecord: true,
         required: true,
         type: "text",
         formatter: (cellContent, row)=>{
           return(
             <>
             <p style ={{textTransform:"uppercase"}}>
               {row.bankCode}
             </p>
             </>
           )
         },
       },
       {
         id: "5",
         value: "bankName",
         label: "Bank Name",
         placeholder: "Enter Bank Name",
         sort: true,
         editRecord: true,
         viewRecord: true,
         required: true,
         type: "text",
         formatter: (cellContent, row)=>{
           return(
             <>
             <p style ={{textTransform:"uppercase"}}>
               {row.bankName}
             </p>
             </>
           )
         },
       },
       {
         id: "6",
         value: "status",
         label: "Status",
         sort: false,
         editRecord: false,
         viewRecord: true,
         formatter: (cellContent, row) =>
           row.loading ? (
             <p className="card-text placeholder-glow">
               <span className="placeholder col-7"></span>
             </p>
           ) : (
             <Badge
               className={`font-size-12 badge rounded-pill ${
                 row.status===1
                   ? "bg-success badge-soft-success"
                   : "bg-danger badge-soft-danger"
               }`}
               color={row.badgeclass}
               pill
             >
               {row.status ===1? "Active" : "Inactive"}
             </Badge>
           ),
         type: "text",
       },
       {
         id: "7",
         value: "branches",
         label: "Branches",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "8",
         value: "insertedBy",
         label: "Inserted By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "9",
         value: "updatedBy",
         label: "Updated By",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "10",
         value: "createdAt",
         label: "Created Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
       {
         id: "11",
         value: "updatedAt",
         label: "Updated Date",
         sort: false,
         editRecord: false,
         viewRecord: false,
         type: "text",
       },
     ],
   },
   {
    schemaId: "YmFua19hY2NvdW50",
    name: 'bank_account',
    title: 'Bank Account List',
    formTitle: 'Bank Account List',
    path: '/bank-account',
    visible: true,
    ...YmFua19hY2NvdW50,
    page: 'bankAccount',
    exact: true,
    columns: (record = {}, metaData) => {

      if (record && record.bankId) {
        const bankName = metaData && metaData.bankOptions && metaData.bankOptions.filter(bankOptions => bankOptions.value == record.bankId).map(filteredPerson => {
          return filteredPerson.label
        })
        if (bankName && bankName[0]) {
          ReactSession.set("bankName", bankName[0])
        }
      }

      const branchOptions =
        record &&
          record.companyId &&
          metaData &&
          Object.keys(metaData).length > 0 &&
          metaData.branchOptions &&
          metaData.branchOptions.length > 0
          ? metaData.branchOptions.filter(
            (_) => _.companyId.toString() === record.companyId.toString()
          )
          : metaData &&
            Object.keys(metaData).length > 0 &&
            metaData.branchOptions &&
            metaData.branchOptions.length > 0
            ? metaData.branchOptions
            : []
      return [
        {
          id: "1",
          value: '_id',
          label: 'Id',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
        {
          id: "2",
          value: 'sno',
          label: 'S.No',
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) => row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : rowIndex + 1,
          type: 'text'
        },
        {
          id: "3",
          value: 'actions',
          label: 'Action',
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: 'actions',
          type: 'text'
        },

        {
          id: "4",
          value: 'companyId',
          label: 'Company',
          placeholder: 'Enter Company',
          sort: true,
          required: true,
          editRecord: true,
          viewRecord: false,
          type: 'select',
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (cellContent &&
                metaData &&
                metaData.companyOptions &&
                metaData.companyOptions.length > 0 &&
                metaData.companyOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ) &&
                metaData.companyOptions.find(
                  (_) => cellContent.toString() === _.value.toString()
                ).label) ||
              ""
            )
          },

          // colProps: {
          //   style: { textTransform: "uppercase" },
          // },
          // formatter: (cellContent, row) => {
          //   return (
          //     <span style={{ textTransform: "uppercase" }}>{row.companyName}</span>
          //   )
          // },
          options: 'companyOptions'
        },
        {
          id: "4",
          value: 'companyName',
          label: 'Company',
          placeholder: 'Enter Company',
          sort: true,
          required: true,
          editRecord: false,
          viewRecord: true,
          type: 'select',
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.companyName}</span>
            )
          }
        },
        {
          id: "5",
          label: "Branch",
          value: "branchId",
          sort: true,
          required: true,
          viewRecord: true,
          editRecord: false,
          formatter: (cellContent, row) => {
            console.log(metaData, "my metadata")
            return (
              <span style={{ textTransform: "uppercase" }}>{row.branchName}</span>
            )
          },

        },
        {
          id: "5",
          value: 'branchId',
          label: 'Branch',
          placeholder: 'Enter Branch',
          sort: true,
          required: true,
          editRecord: true,
          type: 'select',
          formatter: (cellContent, row) => {
            return <span style={{ textTransform: "uppercase" }}>{row.branchId} </span>
          },
          options: branchOptions
        },
        {
          id: "6",
          value: 'bankId',
          label: 'Bank',
          placeholder: 'Enter Bank',
          sort: true,
          editRecord: true,
          viewRecord: false,
          required: true,
          type: 'select',

          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>{row.bankName}</span>
            )
          },
          options: 'bankOptions'
        },
        {
          id: "7",
          value: 'bankName',
          label: 'Bank Name',
          placeholder: 'Enter Bank Name',
          sort: true,
          viewRecord: true,
          formatter: (cellContent, row) => {
            return <span style={{ textTransform: "uppercase" }}>{row.bankName} </span>
          },
          type: 'text'
        },
        {
          id: "7",
          value: 'displayName',
          label: 'Display Name',
          placeholder: 'Enter Display Name',
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          type: 'text',
          formatter: (cellContent, row) => {
            return (
              <>
                <p style={{ textTransform: "uppercase" }}>
                  {row.displayName}
                </p>
              </>
            )
          }
        },
        {
          id: "7",
          value: 'accountNo',
          label: 'Account No',
          placeholder: 'Enter Account No',
          sort: true,
          Validate: "number",
          editRecord: true,
          viewRecord: true,
          required: true,
          colProps: {
            className: "employee-input"
          },
          type: 'number'
        },

        {
          id: "7",
          value: 'branchName',
          label: 'Branch Name',
          placeholder: 'Enter Branch Name',
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          type: "textOnly",
          validations: "textOnly",
          formatter: (cellContent, row) => {
            return (
              <>
                <p style={{ textTransform: "uppercase" }}>
                  {row.bankBranchName}
                </p>
              </>
            )
          }
        },

        {
          id: "7",
          value: 'isfc',
          label: 'IFSC Code',
          placeholder: 'Enter IFSC Code',
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          type: 'text',
          formatter: (cellContent, row) => {
            return (
              <>
                <p style={{ textTransform: "uppercase" }}>
                  {row.isfc}
                </p>
              </>
            )
          }
        },

        {
          id: "7",
          value: 'accountType',
          label: 'Account Type',
          placeholder: 'Enter Account Type',
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          type: 'select',
          formatter: (cellContent, row) => {
            return (
              <>
                <p style={{ textTransform: "uppercase" }}>
                  {row.accountType}
                </p>
              </>
            )
          },
          options: [
            {
              label: "Savings Account",
              value: "Savings Account",
            },
            {
              label: "Current Account",
              value: "Current Account",
            },
            {
              label: "Salary Account",
              value: "Salary Account",
            },
            {
              label: "NRI Accounts",
              value: "NRI Accounts",
            },
            {
              label: "Fixed Deposit Account",
              value: "Fixed Deposit Account",
            },
            {
              label: "Recurring Deposit Account",
              value: "Recurring Deposit Account",
            },
          ],
        },

        {
          id: "7",
          value: 'address',
          label: 'Address',
          placeholder: 'Enter Address',
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          type: 'textarea',
          formatter: (cellContent, row) => {
            return (
              <>
                <p style={{ textTransform: "uppercase" }}>
                  {row.address}
                </p>
              </>
            )
          }
        },

        {
          id: "8",
          value: 'status',
          label: 'Status',
          sort: true,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) => row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status === 1 ? 'bg-success badge-soft-success' : 'bg-danger badge-soft-danger'}`}
              color={row.badgeclass}
              pill>
              {row.status === 1 ? 'Active' : 'Inactive'}
            </Badge>
          ),
          type: 'text'
        },
        {
          id: "9",
          value: 'insertedBy',
          label: 'Inserted By',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
        {
          id: "10",
          value: 'updatedBy',
          label: 'Updated By',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
        {
          id: "11",
          value: 'createdAt',
          label: 'Created Date',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        },
        {
          id: "12",
          value: 'updatedAt',
          label: 'Updated Date',
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: 'text'
        }
      ]
    }
  },
  {
    schemaId: "ZXZlbnRfdHlwZQ",
    name: "event_type",
    title: "Event Type List",
    path: "/event-type",
    visible: true,
    formTitle: "Event Type List",
    page: "EventType",
    ...ZXZlbnRfdHlwZQ,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "4",
          value: "eventType",
          label: "Event Type",
          placeholder: "Enter Event Type",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return <>
              <span style={{ textTransform: "uppercase" }}>{row.eventType}</span>
            </>
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "4",
          value: "shortCode",
          autofillValue: codeValueMetaData,
          label: "Short Code",
          placeholder: "Enter Short Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return <>
              <span style={{ textTransform: "uppercase" }}>{row.shortCode}</span>
            </>
          },
          type: "code",
        },
        {
          id: "5",
          value: "description",
          label: "Description",
          placeholder: "Enter Description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return <>
              <span style={{ textTransform: "uppercase" }}>{row.description}</span>
            </>
          },
          type: "textarea",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status ===1 
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "dGVhbQ",
    name: "team",
    title: "Team List",
    path: "/team",
    visible: true,
    formTitle: "Team List",
    page: "Team",
    ...dGVhbQ,
    columns: (records = [], metaData = {}) => {

      console.log(records, "record from api")
      console.log(metaData, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "5",
          value: "team",
          label: "Team Name",
          placeholder: "Enter Team Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.team}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "4",
          value: "teamCode",
          autofillValue: codeValueMetaData,
          label: "Team Code",
          placeholder: "Enter Team Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.teamCode}
              </span>)
          },
          type: "code",
        },
        {
          id: "4",
          value: "department",
          label: "Department",
          placeholder: "Select Department",
          sort: true,
          editRecord: true,
          viewRecord: false,
          required: true,
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (metaData &&
                metaData.departmentOptions &&
                metaData.departmentOptions.length > 0 &&
                metaData.departmentOptions.find((_) => _.value === cellContent) &&
                metaData.departmentOptions.find((_) => _.value === cellContent)
                  .label) ||
              ""
            )
          },
          type: "select",
          options: "departmentOptions",
        },
        {
          id: "4",
          value: "departmentName",
          label: "Department",
          placeholder: "Select Department",
          sort: true,
          editRecord: false,
          viewRecord: true,
          required: true,
        },

        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
 {
    schemaId: "dmVudWVfbG9",
    name: "venue_location",
    title: "venue Location List",
    path: "/venue-location",
    visible: true,
    formTitle: "venue Location List",
    page: "VenueLocation",
    ...dmVudWVfbG9,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "5",
        value: "name",
        label: "Venue Location",
        placeholder: "Enter Venue Location",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return (
            <span style={{ textTransform: "uppercase" }}>
              {row.name}
            </span>)
        },
        type: "textOnly",
        validations: "textOnly",
      },

      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ]
  },
  {
    schemaId: "dmVudW",
    name: "venue",
    title: "venue List",
    path: "/venue",
    visible: true,
    formTitle: "venue List",
    page: "Venue",
    ...dmVudW,
    columns: () => {
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },


        {
          id: "4",
          value: "cityId",
          label: "Venue Location",
          placeholder: "Select City",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row, rowIndex, metaData) => {
           const venueLocation =  (metaData &&
            metaData.cityOptions &&
            metaData.cityOptions.length > 0 &&
            metaData.cityOptions.find((_) => _.value === cellContent) &&
            metaData.cityOptions.find((_) => _.value === cellContent)
              .label) ||
          ""
            return (
             <span style={{textTransform: "uppercase"}}>{venueLocation}</span>
            )
          },
          type: "select",
          options: "cityOptions",
        },

        {
          id: "5",
          value: "venueName",
          label: "Venue Name",
          placeholder: "Enter Venue Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.venueName}
              </span>)
          },
          type: "textOnly",
          validations: "textOnly",
        },
        {
          id: "6",
          value: "isPremium",
          label: "Premium",
          sort: true,
          editRecord: true,
          viewRecord: true,
          formatter: (cellContent, row) => {
            return (
              <span style={{ textTransform: "uppercase" }}>
                {row.isPremium === true ? "YES" : "NO"}
              </span>)
          },
          type: "checkbox",
        },

        {
          id: "7",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    }
  },
  {
    schemaId: 'UmVzZXRQYX',
    name: 'resetpassword',
    title: 'Reset Password',
    path: 'reset-password',
    visible: true,
    formTitle: 'Reset Password',
    page: 'ResetPassword',
    ...UmVzZXRQYX,
    columns: () => [
      {
        id: '1',
        value: '_id',
        label: 'Id',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '2',
        value: 'sno',
        label: 'S.No',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: 'text',
      },
      {
        id: '3',
        value: 'actions',
        label: 'Actions',
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: 'actions',
        type: 'text',
      },
      {
        id: '4',
        value: 'code',
        label: 'Employee Code',
        placeholder: 'Enter Employee Code',
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: 'code',
      },
     
      {
        id: '6',
        value: 'status',
        label: 'Status',
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                ? 'bg-success badge-soft-success'
                : 'bg-danger badge-soft-danger'
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status && row.status === 1 ? 'Active' : 'Inactive'}
            </Badge>
          ),
        type: 'text',
      },
      {
        id: '7',
        value: 'branches',
        label: 'Branches',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '8',
        value: 'insertedBy',
        label: 'Inserted By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '9',
        value: 'updatedBy',
        label: 'Updated By',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '10',
        value: 'createdAt',
        label: 'Created Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
      {
        id: '11',
        value: 'updatedAt',
        label: 'Updated Date',
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: 'text',
      },
    ],
  },
  {
    schemaId: "bGF5b3V0X21hc3Rlcg",
    name: "layout_master",
    title: "Layout Master",
    path: "/layout-master",
    visible: true,
    formTitle: "Layout Master",
    page: "LayoutMaster",
    ...bGF5b3V0X21hc3Rlcg,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
         id: "3",
         value: "companyId",
         label: "Company",
         placeholder: "Select Company",
         sort: true,
         editRecord: true,
         viewRecord: false,
         required: true,
         type: "select",
         colProps: {
           lg: "6",
           md: "6",
           style: { paddingRight: "1px" },
         },
         options: "companyOptions",
       },
       {
         id: "3",
         value: "companyName",
         label: "Company",
         placeholder: "Select Company",
         sort: true,
         editRecord: false,
         viewRecord: true
       },
        {
          id: "4",
          value: "layoutCode",
          autofillValue: codeValueMetaData,
          label: "Layout Code",
          placeholder: "Enter Layout Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return <span style={{textTransform: "uppercase"}}>{row.layoutCode} </span>
            },
          type: "code",
        },
        {
          id: "5",
          value: "layoutName",
          label: "Layout Name",
          placeholder: "Enter Layout Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return <span style={{textTransform: "uppercase"}}>{row.layoutName} </span>
            },
          type: "text",
        },
        {
          id: "5",
          value: "description",
          label: "Description",
          placeholder: "Enter description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return <span style={{textTransform: "uppercase"}}>{row.description} </span>
            },
          type: "textarea",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status && row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status && row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "bGF5b3V0X3NlZ21lbnQ",
    name: "layout_segment",
    title: "Layout Segment",
    path: "/layout-segment",
    visible: true,
    formTitle: "Layout Segment",
    page: "LayoutSegment",
    ...bGF5b3V0X3NlZ21lbnQ,
    columns: (records = [], metaData) => {

      console.log(records, "record from api")

      const codeValueMetaData = metaData && metaData.codeOptions

      console.log(codeValueMetaData, "codeValueMetaData")
      return [
        {
          id: "1",
          value: "_id",
          label: "Id",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "2",
          value: "sno",
          label: "S.No",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row, rowIndex) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              rowIndex + 1
            ),
          type: "text",
        },
        {
          id: "3",
          value: "actions",
          label: "Actions",
          sort: false,
          editRecord: false,
          viewRecord: true,
          editFormatter: "actions",
          type: "text",
        },
        {
          id: "6",
          value: "layoutMasterId",
          label: "Layout Master",
          placeholder: "Select Layout Master",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          type: "select",
          colProps: {
            lg: "12",
            md: "12",
            style: { paddingRight: "15px" },
          },
          formatter: (cellContent, row, rowIndex, metaData) => {
            return (
              (metaData &&
                metaData.layoutMasterOptions &&
                metaData.layoutMasterOptions.length > 0 &&
                metaData.layoutMasterOptions.find(
                  (_) => _.value.toString() === cellContent.toString()
                ) &&
                metaData.layoutMasterOptions.find((_) => _.value === cellContent)
                  .label) ||
              ""
            )
          },
          options: "layoutMasterOptions",
        },
        {
          id: "4",
          value: "segmentCode",
          autofillValue: codeValueMetaData,
          label: "Segment Code",
          placeholder: "Enter Segment Code",
          sort: true,
          editRecord: true,
          viewRecord: true,
          // required: true,
          formatter: (cellContent, row) => {
            return <span style={{textTransform: "uppercase"}}>{row.segmentCode} </span>
            },
          type: "code",
        },
        {
          id: "5",
          value: "segmentName",
          label: "Segment Name",
          placeholder: "Enter Segment Name",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return <span style={{textTransform: "uppercase"}}>{row.segmentName} </span>
            },
          type: "text",
        },
        {
          id: "5",
          value: "layoutLink",
          label: "Layout Link",
          placeholder: "Enter Layout Link",
          sort: true,
          editRecord: true,
          viewRecord: false,
          required: true,
          formatter: (cellContent, row) => {
            return <span style={{textTransform: "uppercase"}}>{row.layoutLink} </span>
            },
          type: "text",
        },
        {
          id: "5",
          value: "description",
          label: "Description",
          placeholder: "Enter description",
          sort: true,
          editRecord: true,
          viewRecord: true,
          required: true,
          formatter: (cellContent, row) => {
            return <span style={{textTransform: "uppercase"}}>{row.description} </span>
            },
          type: "textarea",
        },
        {
          id: "6",
          value: "status",
          label: "Status",
          sort: false,
          editRecord: false,
          viewRecord: true,
          formatter: (cellContent, row) =>
            row.loading ? (
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
              </p>
            ) : (
              <Badge
                className={`font-size-12 badge rounded-pill ${row.status === 1
                  ? "bg-success badge-soft-success"
                  : "bg-danger badge-soft-danger"
                  }`}
                color={row.badgeclass}
                pill
              >
                {row.status === 1 ? "Active" : "Inactive"}
              </Badge>
            ),
          type: "text",
        },
        {
          id: "7",
          value: "branches",
          label: "Branches",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "8",
          value: "insertedBy",
          label: "Inserted By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "9",
          value: "updatedBy",
          label: "Updated By",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "10",
          value: "createdAt",
          label: "Created Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
        {
          id: "11",
          value: "updatedAt",
          label: "Updated Date",
          sort: false,
          editRecord: false,
          viewRecord: false,
          type: "text",
        },
      ]
    },
  },
  {
    schemaId: "bWVzc2FnZV90ZW1wbGF0ZV9ncm91cA",
    name: "message_template_group",
    title: "Message Template Group List",
    path: "/message-template-group",
    visible: true,
    formTitle: "Message Template Group List",
    page: "MessageTemplateGroup",
    ...bWVzc2FnZV90ZW1wbGF0ZV9ncm91cA,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },

      {
        id: "4",
        value: "mode",
        label: "Mode",
        placeholder: "Enter Mode",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        colProps: {
          lg: "3",
          md: "3",
          className: "pt-3",
        },
        type: "checkboxmultiple",
        options: [
          {
            label: "WHATSAPP",
            value: "Whatsapp",
          },
          {
            label: "EMAIL",
            value: "Email",
          },
          {
            label: "MESSAGE",
            value: "Message",
          },
        ],
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.mode}</span>
          },
      },


      {
        id: "5",
        value: "groupName",
        label: "Group Name",
        placeholder: "Enter Group Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.groupName}</span>
          },
        type: "text",
      },
      {
        id: "5",
        value: "description",
        label: "Description",
        placeholder: "Enter Description",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.description} </span>
          },
        type: "textarea",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.branches} </span>
          },
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
  {
    schemaId: "dGVtcGxhdGVfbWVzc2FnZQ",
    name: "template_message",
    title: "Template Message List",
    path: "/template-message",
    visible: true,
    formTitle: "Template Message List",
    page: "TemplateMessage",
    ...dGVtcGxhdGVfbWVzc2FnZQ,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "6",
        value: "messagetemplateGroupId",
        label: "Message template Group",
        placeholder: "Select Message template Group",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        type: "select",
        colProps: {
          lg: "12",
          md: "12",
          //style: { paddingRight: "15px" },
        },
        
        formatter: (cellContent, row, rowIndex, metaData) => {
          console.log("message",metaData)
          return (
            (metaData &&
              metaData.messagetemplateOptions &&
              metaData.messagetemplateOptions.length > 0 &&
              metaData.messagetemplateOptions.find(
                (_) => _.value.toString() === cellContent.toString()
              ) &&
              metaData.messagetemplateOptions.find((_) => _.value === cellContent)
                .label) ||
            ""
          )
        },
        options: "messagetemplateOptions",
      },
      {
        id: "4",
        value: "templateNo",
        label: "Template No",
        placeholder: "Enter Template No",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.templateNo} </span>
        
      },
        type: "text",
      },
      {
        id: "5",
        value: "subject",
        label: "Subject",
        placeholder: "Enter Subject",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.subject} </span>
          },
    
        type: "text",
      },
      {
        id: "5",
        value: "emailFrom",
        label: "Email From",
        placeholder: "Enter Email From",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.emailFrom} </span>
          },
        type: "text",
      },
      {
        id: "5",
        value: "emailFromName",
        label: "Email From Name",
        placeholder: "Enter Email From Name",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.emailFromName} </span>
          },
        type: "text",
      },
      {
        id: "5",
        value: "emailSignature",
        label: "Email Signature",
        placeholder: "Enter Email Signature",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.emailSignature} </span>
          },
        type: "text",
      },
      {
        id: "5",
        value: "message",
        label: "Message",
        placeholder: "Enter Message",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.message} </span>
          },
        type: "text",
      },
      {
        id: "16",
        value:"attachments",
        label: "Attachment",
        placeholder: "Choose Media Attachment",
        //sort: true,
       required: true,
        editRecord: true,
        viewRecord:false,
        colProps: {
          lg: "4",
          md: "4",
          style: {
            borderBottom: "2px solid #eff2f7",
            borderRight: "2px solid #eff2f7",
            borderBottomRightRadius: "6px",
            padding: "15px",
            backgroundColor: "#d3d3d321",
          },
        },
        type: "upload",
       
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status === 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
  {
    schemaId: "YnVkZ2V0X2NvbG9y",
    name: "budget_color",
    title: "Budget List",
    path: "/budget",
    visible: true,
    formTitle: "Budget List",
    page: "BudgetColor",
    ...YnVkZ2V0X2NvbG9y,
    columns: () => [
      {
        id: "1",
        value: "_id",
        label: "Id",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "2",
        value: "sno",
        label: "S.No",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row, rowIndex) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            rowIndex + 1
          ),
        type: "text",
      },
      {
        id: "3",
        value: "actions",
        label: "Actions",
        sort: false,
        editRecord: false,
        viewRecord: true,
        editFormatter: "actions",
        type: "text",
      },
      {
        id: "5",
        value: "budgetFrom",
        label: "Budget From",
        placeholder: "Enter Budget From",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        colProps: {
          className: "employee-input"
        },
        type: "number",
        formatter: (cellContent, row) => {
          return <span style={{textTransform: "uppercase"}}>{row.budgetFrom} </span>
          },
      },
      {
        id: "5",
        value: "budgetTo",
        label: "Budget To",
        placeholder: "Enter Budget To",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        colProps: {
          className: "employee-input",
          style: {
            marginTop: "7px"
          },
        },
        type: "number",
      },
      {
        id: "5",
        value: "colorCode",
        label: "Color Code",
        placeholder: "Enter Color Code",
        sort: true,
        editRecord: true,
        viewRecord: true,
        required: true,
        colProps: {
          style: {
            marginTop: "7px"
          },
        },
        formatter: (cellContent, row) => {
          console.log(row, "row from api")
          return (
            <>
              <p style={{ textTransform: "uppercase" }}>{row.colorCode}</p>
            </>
          )},
        type: "text",
      },
      {
        id: "6",
        value: "status",
        label: "Status",
        sort: false,
        editRecord: false,
        viewRecord: true,
        formatter: (cellContent, row) =>
          row.loading ? (
            <p className="card-text placeholder-glow">
              <span className="placeholder col-7"></span>
            </p>
          ) : (
            <Badge
              className={`font-size-12 badge rounded-pill ${row.status == 1
                ? "bg-success badge-soft-success"
                : "bg-danger badge-soft-danger"
                }`}
              color={row.badgeclass}
              pill
            >
              {row.status === 1 ? "Active" : "Inactive"}
            </Badge>
          ),
        type: "text",
      },
      {
        id: "7",
        value: "branches",
        label: "Branches",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "8",
        value: "insertedBy",
        label: "Inserted By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "9",
        value: "updatedBy",
        label: "Updated By",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "10",
        value: "createdAt",
        label: "Created Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
      {
        id: "11",
        value: "updatedAt",
        label: "Updated Date",
        sort: false,
        editRecord: false,
        viewRecord: false,
        type: "text",
      },
    ],
  },
]

export default schema
